// Data synchronization service for IFM Portal
// This service manages all data operations using localStorage

// Storage keys
export const STORAGE_KEYS = {
  EVENTS: 'ifm_events',
  NEWS: 'ifm_news',
  MEMBERSHIP_PLANS: 'ifm_membership_plans',
  GALLERY: 'ifm_gallery',
  GRIEVANCES: 'ifm_grievances',
  MEMBERS: 'ifm_members',
  LANGUAGES: 'ifm_languages'
};

// Existing dummy data from main portal
export const existingData = {
  events: [
    {
      id: 1,
      title: 'Industrial Safety Workshop 2024',
      description: 'Comprehensive safety training program for industrial workers and managers',
      category: 'Workshop',
      startDate: '2024-03-15',
      endDate: '2024-03-15',
      startTime: '10:00 AM',
      endTime: '4:00 PM',
      location: 'IFM Conference Hall, Mumbai',
      image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=400&auto=format&fit=crop'
    },
    {
      id: 2,
      title: 'Environmental Compliance Seminar',
      description: 'Latest updates on environmental regulations and compliance requirements',
      category: 'Seminar',
      startDate: '2024-03-20',
      endDate: '2024-03-20',
      startTime: '9:00 AM',
      endTime: '5:00 PM',
      location: 'IFM Training Center, Pune',
      image: 'https://images.unsplash.com/photo-1532634896-26909d0d4b6a?q=80&w=400&auto=format&fit=crop'
    },
    {
      id: 3,
      title: 'Industry Networking Event',
      description: 'Connect with industry leaders and explore collaboration opportunities',
      category: 'Networking',
      startDate: '2024-03-25',
      endDate: '2024-03-25',
      startTime: '6:00 PM',
      endTime: '9:00 PM',
      location: 'Hotel Taj, Mumbai',
      image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=400&auto=format&fit=crop'
    }
  ],
  news: [
    {
      id: 1,
      title: 'New Environmental Regulations Announced',
      description: 'Government announces new environmental compliance requirements for industries',
      category: 'Regulations',
      date: '2024-03-10',
      image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=400&auto=format&fit=crop'
    },
    {
      id: 2,
      title: 'IFM Launches New Support Services',
      description: 'Expanded support services for member industries across Maharashtra',
      category: 'Announcement',
      date: '2024-03-08',
      image: 'https://images.unsplash.com/photo-1532634896-26909d0d4b6a?q=80&w=400&auto=format&fit=crop'
    },
    {
      id: 3,
      title: 'Industry Safety Guidelines Updated',
      description: 'Updated safety protocols and guidelines for industrial operations',
      category: 'Safety',
      date: '2024-03-05',
      image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=400&auto=format&fit=crop'
    }
  ],
  membershipPlans: [
    {
      id: 1,
      name: 'Basic Membership',
      price: 5000,
      duration: 'Annual',
      features: ['Basic support', 'Newsletter', 'Event access'],
      description: 'Essential membership for small industries'
    },
    {
      id: 2,
      name: 'Premium Membership',
      price: 15000,
      duration: 'Annual',
      features: ['Priority support', 'All events', 'Consultation', 'Networking'],
      description: 'Comprehensive membership for growing industries'
    },
    {
      id: 3,
      name: 'Enterprise Membership',
      price: 30000,
      duration: 'Annual',
      features: ['Dedicated support', 'Custom solutions', 'Training programs', 'All benefits'],
      description: 'Complete membership for large enterprises'
    }
  ],
  gallery: {
    photos: [
      {
        id: 1,
        title: 'Industrial Conference 2024',
        image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=400&auto=format&fit=crop',
        category: 'Events'
      },
      {
        id: 2,
        title: 'Safety Training Session',
        image: 'https://images.unsplash.com/photo-1532634896-26909d0d4b6a?q=80&w=400&auto=format&fit=crop',
        category: 'Training'
      }
    ],
    videos: []
  },
  grievances: [],
  members: []
};

// Language support
export const languages = {
  en: {
    name: 'English',
    isDefault: true,
    content: {
      'nav.home': 'Home',
      'nav.about': 'About',
      'nav.support': 'Support',
      'nav.events': 'Events',
      'nav.news': 'News',
      'nav.partners': 'Partners',
      'nav.membership': 'Membership',
      'nav.gallery': 'Gallery',
      'nav.contact': 'Contact',
      'nav.socialMedia': 'Social Media',
      'nav.importantLinks': 'Important Links',
      // About Us submenu
      'nav.about.submenu.about': 'About Us',
      'nav.about.submenu.president': 'President Profile',
      'nav.about.submenu.founder': 'Founder',
      'nav.about.submenu.mission': 'Mission and Vision',
      'nav.about.submenu.values': 'Core Values',
      'nav.about.submenu.structure': 'Organisation Structure',
      'nav.about.submenu.leadershipTeam': 'Leadership Team',
      'nav.about.submenu.achievements': 'Our Achievements',
      'nav.about.submenu.committee': 'Member Committee',
      // News page
      'news.title': 'News & Updates',
      'news.subtitle': 'Stay informed with the latest industry news, regulatory updates, and IFM announcements.',
      'news.loadingError': 'Failed to load news. Please try again later.',
      // News Detail page
      'news.detail.loading': 'Loading news article...',
      'news.detail.notFound': 'News Not Found',
      'news.detail.notFoundDesc': 'The news article you\'re looking for doesn\'t exist or has been removed.',
      'news.detail.backToNews': 'Back to News',
      'news.detail.recentNews': 'Recent News',
      'news.detail.noRecentNews': 'No recent news',
      'news.detail.breakingNews': 'Breaking News',
      'news.detail.noContent': 'No content available for this article.',
      'news.detail.recently': 'Recently',
      // Contact & Grievance Forms
      'contact.form.contactTab': 'General Inquiry',
      'contact.form.grievanceTab': 'Grievance Submission',
      'contact.form.title': 'Get in Touch',
      'contact.form.subtitle': 'Fill out the form below and we\'ll get back to you as soon as possible.',
      'contact.form.name': 'Full Name',
      'contact.form.email': 'Email Address',
      'contact.form.phone': 'Phone Number',
      'contact.form.company': 'Company/Organization',
      'contact.form.subject': 'Subject',
      'contact.form.message': 'Message',
      'contact.form.submit': 'Send Message',
      'contact.form.success': 'Message sent successfully! We will get back to you soon.',
      'contact.form.error': 'Failed to send message. Please try again.',
      // Grievance Categories
      'grievance.category.general': 'General',
      'grievance.category.labour': 'Labour',
      'grievance.category.environmental': 'Environmental',
      'grievance.category.infrastructure': 'Infrastructure',
      'grievance.category.compliance': 'Compliance',
      'grievance.category.technical': 'Technical',
      'grievance.category.safety': 'Safety',
      'grievance.category.pollution': 'Pollution',
      'grievance.category.land': 'Land',
      'grievance.category.electricity': 'Electricity',
      'grievance.category.water': 'Water',
      'grievance.category.roads': 'Roads',
      'grievance.category.waste': 'Waste',
      'grievance.category.pricing': 'Pricing',
      'grievance.category.other': 'Other',
      // Grievance Priorities
      'grievance.priority.low': 'Low',
      'grievance.priority.medium': 'Medium',
      'grievance.priority.high': 'High',
      'grievance.priority.urgent': 'Urgent',
      'grievance.priority.critical': 'Critical',
      'grievance.form.subtitle': 'Report your concerns and we will address them promptly.',
      'grievance.form.submitting': 'Submitting...',
      'grievance.form.category': 'Category',
      'grievance.form.priority': 'Priority',
      'grievance.form.description': 'Description',
      'grievance.form.urgent': 'Mark as Urgent',
      'grievance.form.submit': 'Submit Grievance',
      'grievance.form.success': 'Grievance submitted successfully! We will address it soon.',
      'grievance.form.error': 'Failed to submit grievance. Please try again.',
      // Grievance Page Tabs
      'grievance.tab.submit': 'Submit Grievance',
      'grievance.tab.track': 'Track Grievances',
      'grievance.tab.faq': 'FAQ & Help',
      'grievance.form.title': 'Submit New Grievance',
      'grievance.form.name': 'Full Name',
      'grievance.form.email': 'Email Address',
      'grievance.form.phone': 'Phone Number',
      'grievance.form.company': 'Company / Organization',
      'grievance.form.subjectLabel': 'Grievance Subject',
      'grievance.form.descriptionLabel': 'Detailed Grievance Description',
      'grievance.form.descriptionPlaceholder': 'Please describe your grievance in detail. Include relevant dates, locations, departments and any supporting information...',
      'grievance.form.urgentLabel': 'Mark as urgent (requires immediate attention)',
      'grievance.track.title': 'Your Grievances',
      'grievance.track.allCategories': 'All Categories',
      'grievance.track.noGrievances': 'No grievances found',
      'grievance.track.noGrievancesDesc': 'Submit your first grievance to get started.',
      'grievance.track.submittedOn': 'Submitted on',
      'grievance.track.viewDetails': 'View Details',
      'grievance.track.validation.missingFields': 'Please enter both Ticket Number and Email used while submitting grievance.',
      'grievance.track.success': 'Grievance details fetched successfully.',
      'grievance.track.notFound': 'Unable to find grievance for provided details.',
      'grievance.track.error': 'Failed to fetch grievance details. Please check details and try again.',
      'grievance.faq.title': 'Frequently Asked Questions',
      'grievance.faq.q1': 'How long does it take to resolve a grievance?',
      'grievance.faq.a1': 'Resolution time depends on the complexity and priority of your issue. Critical issues are typically addressed within 24-48 hours, while standard issues may take 5-7 working days.',
      'grievance.faq.q2': 'Can I track the progress of my grievance?',
      'grievance.faq.a2': 'Yes, you can track the progress of your grievance using the ticket number provided when you submit. You\'ll also receive regular updates via email.',
      'grievance.faq.q3': 'What information should I include in my grievance?',
      'grievance.faq.a3': 'Include specific details about the issue, relevant dates, any documentation or evidence, and your contact information. The more detailed your description, the faster we can assist you.',
      'grievance.faq.q4': 'How do I know if my grievance has been resolved?',
      'grievance.faq.a4': 'You\'ll receive a resolution notification via email, and the status will be updated in your grievance tracking. You can also contact our support team for updates.',
      'grievance.cta.title': 'Need Immediate Assistance?',
      'grievance.cta.subtitle': 'For urgent matters, contact our 24/7 helpline or reach out to our support team directly.',
      'grievance.cta.callHelpline': 'Call Helpline',
      'grievance.cta.contactSupport': 'Contact Support',
      // Contact Page CTA
      'contact.cta.title': 'Need Immediate Assistance?',
      'contact.cta.subtitle': 'Our dedicated support team is ready to help you. Reach out to us through any of the channels below for prompt assistance.',
      'contact.cta.callSupport': 'Call Support',
      'contact.cta.sendEmail': 'Send Email',
      // Admin Panel - Sidebar
      'admin.sidebar.dashboard': 'Dashboard',
      'admin.sidebar.news': 'News',
      'admin.sidebar.events': 'Events',
      'admin.sidebar.eventRegistrations': 'Event Registrations',
      'admin.sidebar.members': 'Members',
      'admin.sidebar.membershipPlans': 'Membership Plans',
      'admin.sidebar.gallery': 'Gallery',
      'admin.sidebar.payments': 'Payments',
      'admin.sidebar.contactEnquiries': 'Contact Enquiries',
      'admin.sidebar.grievances': 'Grievances',
      'admin.sidebar.activityLogs': 'Activity Logs',
      'admin.sidebar.logout': 'Logout',
      'admin.sidebar.language': 'Language',
      'admin.sidebar.selectLanguage': 'Select Language',
      // Admin Common
      'admin.common.loading': 'Loading...',
      'admin.common.error': 'Error',
      'admin.common.success': 'Success',
      'admin.common.save': 'Save',
      'admin.common.cancel': 'Cancel',
      'admin.common.delete': 'Delete',
      'admin.common.edit': 'Edit',
      'admin.common.create': 'Create',
      'admin.common.update': 'Update',
      'admin.common.add': 'Add',
      'admin.common.remove': 'Remove',
      'admin.common.search': 'Search',
      'admin.common.filter': 'Filter',
      'admin.common.clear': 'Clear',
      'admin.common.clearFilters': 'Clear Filters',
      'admin.common.apply': 'Apply',
      'admin.common.submit': 'Submit',
      'admin.common.close': 'Close',
      'admin.common.view': 'View',
      'admin.common.details': 'Details',
      'admin.common.back': 'Back',
      'admin.common.next': 'Next',
      'admin.common.previous': 'Previous',
      'admin.common.page': 'Page',
      'admin.common.of': 'of',
      'admin.common.total': 'Total',
      'admin.common.noData': 'No data available',
      'admin.common.confirm': 'Confirm',
      'admin.common.yes': 'Yes',
      'admin.common.no': 'No',
      'admin.common.actions': 'Actions',
      'admin.common.status': 'Status',
      'admin.common.date': 'Date',
      'admin.common.name': 'Name',
      'admin.common.email': 'Email',
      'admin.common.phone': 'Phone',
      'admin.common.organization': 'Organization',
      'admin.common.category': 'Category',
      'admin.common.description': 'Description',
      'admin.common.notes': 'Notes',
      'admin.common.created': 'Created',
      'admin.common.updated': 'Updated',
      // Admin Dashboard
      'admin.dashboard.title': 'Dashboard',
      'admin.dashboard.loading': 'Loading dashboard...',
      'admin.dashboard.error': 'Failed to load dashboard statistics',
      'admin.dashboard.totalMembers': 'Total Members',
      'admin.dashboard.approved': 'Approved',
      'admin.dashboard.events': 'Events',
      'admin.dashboard.upcoming': 'Upcoming',
      'admin.dashboard.newsArticles': 'News Articles',
      'admin.dashboard.published': 'Published',
      'admin.dashboard.eventRegistrations': 'Event Registrations',
      'admin.dashboard.confirmed': 'Confirmed',
      'admin.dashboard.totalRevenue': 'Total Revenue',
      'admin.dashboard.payments': 'Payments',
      'admin.dashboard.recentActivity': 'Recent Activity',
      'admin.dashboard.newMembers': 'New Members',
      'admin.dashboard.newEvents': 'New Events',
      'admin.dashboard.newNews': 'New News',
      'admin.dashboard.newRegistrations': 'New Registrations',
      'admin.dashboard.newPayments': 'New Payments',
      'admin.dashboard.managementActions': 'Management Actions',
      'admin.dashboard.manageMembers': 'Manage Members',
      'admin.dashboard.manageMembersDesc': 'View and manage all member registrations',
      'admin.dashboard.manageEvents': 'Manage Events',
      'admin.dashboard.manageEventsDesc': 'Create, edit, and manage events',
      'admin.dashboard.manageNews': 'Manage News',
      'admin.dashboard.manageNewsDesc': 'Create and publish news articles',
      'admin.dashboard.eventRegistrationsDesc': 'View and manage event registrations',
      'admin.dashboard.galleryManagement': 'Gallery Management',
      'admin.dashboard.galleryManagementDesc': 'Upload and manage photos and videos',
      'admin.dashboard.membershipPlansDesc': 'Configure membership plans and pricing',
      'admin.dashboard.paymentManagement': 'Payment Management',
      'admin.dashboard.paymentManagementDesc': 'View payment history and transactions',
      'admin.dashboard.quickLinks': 'Quick Links',
      'admin.dashboard.memberRegistration': 'Member Registration',
      'admin.dashboard.viewAllMembers': 'View All Members',
      'admin.dashboard.createEvent': 'Create Event',
      'admin.dashboard.viewAllEvents': 'View All Events',
      'admin.dashboard.createNews': 'Create News',
      'admin.dashboard.viewAllNews': 'View All News',
      // Admin Members
      'admin.members.title': 'Members',
      'admin.members.createNew': 'Create New Member',
      'admin.members.editMember': 'Edit Member',
      'admin.members.viewMember': 'Member Details',
      'admin.members.approve': 'Approve Member',
      'admin.members.approved': 'Approved',
      'admin.members.reject': 'Reject Member',
      'admin.members.activate': 'Activate Member',
      'admin.members.deactivate': 'Deactivate Member',
      'admin.members.createCashPayment': 'Create Cash Payment',
      'admin.members.cashPayment': 'Cash Payment',
      'admin.members.amount': 'Amount',
      'admin.members.paymentDescription': 'Payment Description',
      'admin.members.pending': 'Pending',
      'admin.members.active': 'Active',
      'admin.members.inactive': 'Inactive',
      'admin.members.expired': 'Expired',
      'admin.members.completed': 'Completed',
      'admin.members.failed': 'Failed',
      'admin.members.cancelled': 'Cancelled',
      'admin.members.personName': 'Person Name',
      'admin.members.organizationName': 'Organization Name',
      'admin.members.mobile': 'Mobile',
      'admin.members.location': 'Location',
      'admin.members.industry': 'Industry',
      'admin.members.membershipPlan': 'Membership Plan',
      'admin.members.approvalStatus': 'Approval Status',
      'admin.members.paymentStatus': 'Payment Status',
      'admin.members.membershipStatus': 'Membership Status',
      'admin.members.registrationDate': 'Registration Date',
      'admin.members.expiryDate': 'Expiry Date',
      'admin.members.memberId': 'Member ID',
      'admin.members.filterByStatus': 'Filter by Status',
      'admin.members.filterByPayment': 'Filter by Payment',
      'admin.members.filterByApproval': 'Filter by Approval',
      'admin.members.all': 'All',
      'admin.members.memberCreated': 'Member created successfully!',
      'admin.members.memberUpdated': 'Member updated successfully!',
      'admin.members.memberDeleted': 'Member deleted successfully!',
      'admin.members.memberApproved': 'Member approved successfully!',
      'admin.members.memberRejected': 'Member rejected successfully!',
      'admin.members.memberActivated': 'Member activated successfully!',
      'admin.members.paymentCreated': 'Cash payment created successfully!',
      'admin.members.fillRequired': 'Please fill all required fields',
      'admin.members.invalidEmail': 'Please enter a valid email address',
      'admin.members.invalidMobile': 'Please enter a valid 10-digit mobile number',
      // Admin News
      'admin.news.title': 'News',
      'admin.news.createNew': 'Create New News',
      'admin.news.editNews': 'Edit News',
      'admin.news.titleLabel': 'Title',
      'admin.news.summary': 'Summary',
      'admin.news.content': 'Content',
      'admin.news.author': 'Author',
      'admin.news.category': 'Category',
      'admin.news.addCategory': 'Add Category',
      'admin.news.newCategory': 'New Category',
      'admin.news.newsCreated': 'News created successfully!',
      'admin.news.newsUpdated': 'News updated successfully!',
      'admin.news.newsDeleted': 'News deleted successfully!',
      'admin.news.filterByTitle': 'Filter by Title',
      'admin.news.filterByAuthor': 'Filter by Author',
      'admin.news.filterByCategory': 'Filter by Category',
      // Admin Events
      'admin.events.title': 'Events',
      'admin.events.createNew': 'Add New Event',
      'admin.events.editEvent': 'Edit Event',
      'admin.events.eventTitle': 'Event Title',
      'admin.events.eventDescription': 'Event Description',
      'admin.events.startDate': 'Start Date',
      'admin.events.endDate': 'End Date',
      'admin.events.startTime': 'Start Time',
      'admin.events.endTime': 'End Time',
      'admin.events.location': 'Location',
      'admin.events.category': 'Category',
      'admin.events.imageUrl': 'Image URL',
      'admin.events.registrationRequired': 'Registration Required',
      'admin.events.maxParticipants': 'Max Participants',
      'admin.events.fees': 'Fees',
      'admin.events.published': 'Published',
      'admin.events.eventCreated': 'Event created successfully!',
      'admin.events.eventUpdated': 'Event updated successfully!',
      'admin.events.eventDeleted': 'Event deleted successfully!',
      'admin.events.filterByTitle': 'Filter by Title',
      'admin.events.filterByCategory': 'Filter by Category',
      'admin.events.filterByStatus': 'Filter by Status',
      // Admin Payments
      'admin.payments.title': 'Payments',
      'admin.payments.paymentDetails': 'Payment Details',
      'admin.payments.markCompleted': 'Mark Payment as Completed',
      'admin.payments.approveMember': 'Approve Member',
      'admin.payments.activateMember': 'Activate Member',
      'admin.payments.orderId': 'Order ID',
      'admin.payments.memberName': 'Member Name',
      'admin.payments.memberEmail': 'Member Email',
      'admin.payments.amount': 'Amount',
      'admin.payments.paymentMethod': 'Payment Method',
      'admin.payments.online': 'Online',
      'admin.payments.cash': 'Cash',
      'admin.payments.gateway': 'Gateway',
      'admin.payments.processedAt': 'Processed At',
      'admin.payments.filterByMethod': 'Filter by Payment Method',
      'admin.payments.filterByStatus': 'Filter by Status',
      // Admin Grievances
      'admin.grievances.title': 'Grievances',
      'admin.grievances.ticketNumber': 'Ticket Number',
      'admin.grievances.submittedBy': 'Submitted By',
      'admin.grievances.category': 'Category',
      'admin.grievances.priority': 'Priority',
      'admin.grievances.resolutionNotes': 'Resolution Notes',
      'admin.grievances.updateResolution': 'Update Resolution',
      'admin.grievances.open': 'Open',
      'admin.grievances.inProgress': 'In Progress',
      'admin.grievances.resolved': 'Resolved',
      'admin.grievances.closed': 'Closed',
      'admin.grievances.low': 'Low',
      'admin.grievances.medium': 'Medium',
      'admin.grievances.high': 'High',
      'admin.grievances.urgent': 'Urgent',
      'admin.grievances.critical': 'Critical',
      'admin.grievances.filterByTicket': 'Filter by Ticket Number',
      'admin.grievances.filterByStatus': 'Filter by Status',
      'admin.grievances.filterByPriority': 'Filter by Priority',
      // Admin Contact
      'admin.contact.title': 'Contact Enquiries',
      'admin.contact.submissions': 'Submissions',
      'admin.contact.subject': 'Subject',
      'admin.contact.message': 'Message',
      'admin.contact.new': 'New',
      'admin.contact.inProgress': 'In Progress',
      'admin.contact.resolved': 'Resolved',
      'admin.contact.closed': 'Closed',
      'admin.contact.filterByName': 'Filter by Name',
      'admin.contact.filterByEmail': 'Filter by Email',
      'admin.contact.filterByStatus': 'Filter by Status',
      // Admin Gallery
      'admin.gallery.title': 'Gallery',
      'admin.gallery.addPhoto': 'Add Photo',
      'admin.gallery.addVideo': 'Add Video',
      'admin.gallery.bulkUpload': 'Bulk Upload',
      'admin.gallery.photos': 'Photos',
      'admin.gallery.videos': 'Videos',
      'admin.gallery.titleLabel': 'Title',
      'admin.gallery.description': 'Description',
      'admin.gallery.imageUrl': 'Image URL',
      'admin.gallery.videoUrl': 'Video URL',
      'admin.gallery.category': 'Category',
      'admin.gallery.photoAdded': 'Photo added successfully!',
      'admin.gallery.videoAdded': 'Video added successfully!',
      // Admin Membership Plans
      'admin.plans.title': 'Membership Plans',
      'admin.plans.createNew': 'Create New Membership Plan',
      'admin.plans.editPlan': 'Edit Membership Plan',
      'admin.plans.planName': 'Plan Name',
      'admin.plans.price': 'Price',
      'admin.plans.duration': 'Duration',
      'admin.plans.durationUnit': 'Duration Unit',
      'admin.plans.features': 'Features',
      'admin.plans.active': 'Active',
      'admin.plans.popular': 'Popular',
      'admin.plans.planCreated': 'Membership plan created successfully!',
      'admin.plans.planUpdated': 'Membership plan updated successfully!',
      'admin.plans.planDeleted': 'Membership plan deleted successfully!',
      // Admin Audit Logs
      'admin.logs.title': 'Activity Logs',
      'admin.logs.action': 'Action',
      'admin.logs.entityType': 'Entity Type',
      'admin.logs.entityName': 'Entity Name',
      'admin.logs.admin': 'Admin',
      'admin.logs.description': 'Description',
      'admin.logs.timestamp': 'Timestamp',
      'admin.logs.filterByAdmin': 'Filter by Admin',
      'admin.logs.filterByEntity': 'Filter by Entity Type',
      'admin.logs.filterByAction': 'Filter by Action',
      // Admin Event Registrations
      'admin.registrations.title': 'Event Registrations',
      'admin.registrations.eventTitle': 'Event Title',
      'admin.registrations.participantName': 'Participant Name',
      'admin.registrations.participantEmail': 'Participant Email',
      'admin.registrations.participantMobile': 'Participant Mobile',
      'admin.registrations.registrationDate': 'Registration Date',
      'admin.registrations.paymentStatus': 'Payment Status',
      'admin.registrations.status': 'Status',
      'admin.registrations.registered': 'Registered',
      'admin.registrations.confirmed': 'Confirmed',
      'admin.registrations.cancelled': 'Cancelled',
      'admin.registrations.filterByEvent': 'Filter by Event',
      'admin.registrations.filterByStatus': 'Filter by Status',
      // Renewal Page
      'renewal.title': 'Renew Your Membership',
      'renewal.subtitle': 'Enter your customer ID or email to find your membership plan and renew it',
      'renewal.searchLabel': 'Customer ID or Email',
      'renewal.searchPlaceholder': 'Enter customer ID or email to find your plan',
      'renewal.search': 'Search',
      'renewal.searching': 'Searching...',
      'renewal.memberDetails': 'Member Details',
      'renewal.memberName': 'Member Name',
      'renewal.organization': 'Organization',
      'renewal.email': 'Email',
      'renewal.mobile': 'Mobile',
      'renewal.memberId': 'Member ID',
      'renewal.currentPlan': 'Current Plan',
      'renewal.expiryDate': 'Membership Expiry Date',
      'renewal.daysRemaining': 'days remaining',
      'renewal.expired': 'Expired',
      'renewal.processing': 'Processing...',
      'renewal.renewButton': 'Renew Membership',
      'renewal.viewPlans': 'View Plans',
      'renewal.pendingApproval': 'Your membership is pending approval. Please contact support for assistance.',
      'renewal.needHelp': 'Need Help?',
      'renewal.helpText': 'If you cannot find your membership or need assistance with renewal, please contact our support team.',
      'renewal.contactSupport': 'Contact Support',
      'renewal.callUs': 'Call Us',
      'renewal.searchError': 'Please enter your customer ID or email',
      'renewal.notFound': 'Member not found. Please check your customer ID or email.',
      'renewal.cta.title': 'New to IFM?',
      'renewal.cta.subtitle': 'Join the Industrial Fedration of Maharashtra Region and unlock exclusive benefits, expert support, and networking opportunities.',
      'renewal.cta.register': 'New Member Registration',
      'renewal.cta.viewPlans': 'View Membership Plans',
      'renewal.renewalSuccess': 'Membership renewal initiated successfully! Redirecting to payment...',
      'renewal.renewalError': 'Failed to renew membership. Please try again.',
      'renewal.confirmTitle': 'Confirm Renewal',
      'renewal.confirmMessage': 'Are you sure you want to renew your membership? You will be redirected to payment.',
      'renewal.confirm': 'Yes, Renew',
      'renewal.cancel': 'Cancel',
      // Registration Form
      'registration.title': 'Member Registration',
      'registration.subtitle': 'Please fill in all required fields to complete your membership registration',
      'registration.personalDetails': 'Personal Details',
      'registration.membershipInfo': 'Membership Information',
      'registration.mobile': 'WhatsApp / Mobile No.',
      'registration.email': 'Email Address',
      'registration.emailPlaceholder': 'Enter email address',
      'registration.applicantName': 'Applicant Name (Shri./Smt./M/s.)',
      'registration.organizationName': 'Organization Name',
      'registration.representativeName': 'Representative Name',
      'registration.gender': 'Gender',
      'registration.gender.male': 'Male',
      'registration.gender.female': 'Female',
      'registration.telephone': 'Telephone',
      'registration.aadhar': 'Aadhar No.',
      'registration.pancard': 'PAN Card',
      'registration.address': 'Address',
      'registration.state': 'State',
      'registration.district': 'District',
      'registration.city': 'City',
      'registration.pincode': 'Pincode',
      'registration.website': 'Website',
      'registration.gst': 'GST Number',
      'registration.region': 'Region',
      'registration.memberDescription': 'Member Description',
      'registration.category': 'Category',
      'registration.natureOfBusiness': 'Nature of Business',
      'registration.industry': 'Industry',
      'registration.industryPlaceholder': 'Enter industry',
      'registration.workerCount': 'Number of Workers',
      'registration.membershipType': 'Membership Type',
      'registration.startDate': 'Start Date',
      'registration.endDate': 'End Date',
      'registration.selectPlan': 'Select Membership Plan',
      'registration.submit': 'Submit Registration',
      'registration.submitting': 'Submitting...',
      'registration.success': 'Registration submitted successfully!',
      'registration.error': 'Failed to submit registration. Please try again.',
      'registration.required': 'This field is required',
      'registration.invalidMobile': 'Please enter a valid 10-digit mobile number',
      'registration.invalidEmail': 'Please enter a valid email address',
      'registration.invalidPincode': 'Please enter a valid 6-digit pincode',
      'registration.invalidAadhar': 'Please enter a valid 12-digit Aadhar number',
      'registration.invalidPAN': 'Please enter a valid PAN card number',
      'registration.selectPlanError': 'Please select a membership plan',
      'registration.processing': 'Processing...',
      'registration.redirecting': 'Redirecting...',
      'registration.submitButton': 'Proceed to Payment',
      'registration.cta.title': 'Ready to Join IFM?',
      'registration.cta.subtitle': 'Become a member today and unlock comprehensive industrial support services, regulatory assistance, networking opportunities, and expert guidance for your business growth',
      'registration.cta.renew': 'Renew Membership',
      'registration.cta.viewPlans': 'View All Plans',
      'registration.termsPrefix': 'By submitting this form, you agree to our',
      'registration.termsAnd': 'and',
      'registration.securePayment': 'Secure Payment',
      'registration.dataProtected': 'Data Protected',
      'registration.instantConfirmation': 'Instant Confirmation',
      // Gallery page
      'gallery.title': 'Media Gallery',
      'gallery.subtitle': 'Explore photos and videos from our events, workshops, and industrial activities.',
      // Gallery (English)
      // Login
      'login.title': 'Sign in to your account',
      'login.email': 'Email address',
      'login.emailPlaceholder': 'Enter your email',
      'login.emailRequired': 'Email is required',
      'login.emailInvalid': 'Invalid email address',
      'login.password': 'Password',
      'login.passwordPlaceholder': 'Enter your password',
      'login.passwordRequired': 'Password is required',
      'login.passwordMinLength': 'Password must be at least 6 characters',
      'login.rememberMe': 'Remember me',
      'login.forgotPassword': 'Forgot your password?',
      'login.signIn': 'Sign in',
      'login.signingIn': 'Signing in...',
      'login.success': 'Login successful!',
      'login.invalidCredentials': 'Invalid credentials',
      'login.error': 'Login failed. Please try again.',
      // Events
      'events.title': 'Events & Programs',
      'events.subtitle': 'Stay updated with our latest workshops, seminars, training programs, and industry events.',
      'events.searchPlaceholder': 'Search events...',
      'events.allCategories': 'All Categories',
      'events.loading': 'Loading events...',
      'events.loadingError': 'Failed to load events. Please try again later.',
      'events.noEventsFound': 'No events found',
      'events.tryAdjusting': 'Try adjusting your search or filter criteria.',
      'events.viewDetails': 'View Details',
      'events.recentEvents': 'Recent Events',
      'events.noRecentEvents': 'No recent events',
      'events.free': 'Free',
      'events.status.upcoming': 'Upcoming',
      'events.status.ongoing': 'Ongoing',
      'events.status.completed': 'Completed',
      'events.dateTBD': 'Date TBD',
      'events.locationTBD': 'Location TBD',
      // Event Detail
      'events.detail.backToEvents': 'Back to Events',
      'events.detail.notFound': 'Event Not Found',
      'events.detail.notFoundDesc': 'The event you\'re looking for doesn\'t exist or has been removed.',
      'events.detail.loading': 'Loading event details...',
      'events.detail.registration': 'Event Registration',
      'events.detail.registrationClosed': 'Registration Closed',
      'events.detail.registrationClosedDesc': 'This event has already passed.',
      'events.detail.registrationNotAvailable': 'Registration Not Available',
      'events.detail.registrationNotAvailableDesc': 'This event is not currently open for registration.',
      'events.detail.eventFull': 'Event Full',
      'events.detail.eventFullDesc': 'Maximum participants reached',
      'events.detail.registrationFee': 'Registration Fee',
      'events.detail.freeEvent': 'Free Event',
      'events.detail.registerNow': 'Register Now',
      'events.detail.eventInformation': 'Event Information',
      'events.detail.capacity': 'Capacity',
      'events.detail.participants': 'participants',
      'events.detail.fee': 'Fee',
      'events.detail.registrationRequired': 'Registration',
      'events.detail.required': 'Required',
      'events.detail.otherEvents': 'Other Events',
      // Event Registration
      'eventRegistration.mobileRequired': 'Mobile number is required',
      'eventRegistration.mobileInvalid': 'Please enter a valid 10-digit mobile number',
      'eventRegistration.emailRequired': 'Email is required',
      'eventRegistration.emailInvalid': 'Please enter a valid email address',
      'eventRegistration.nameRequired': 'Participant name is required',
      'eventRegistration.nameMinLength': 'Participant name must be at least 2 characters',
      'eventRegistration.pincodeInvalid': 'Please enter a valid 6-digit pincode',
      'eventRegistration.namePlaceholder': 'Enter your full name',
      'eventRegistration.emailPlaceholder': 'Enter your email address',
      'eventRegistration.designationPlaceholder': 'Enter your designation (optional)',
      'eventRegistration.addressPlaceholder': 'Enter your address (optional)',
      'eventRegistration.registerAndPay': 'Register & Proceed to Payment',
      'eventRegistration.completeRegistration': 'Complete Registration',
      'eventRegistration.dismissError': 'Dismiss error',
      'eventRegistration.redirectingToPayment': 'Redirecting to Payment...',
      'eventRegistration.redirectingToPaymentGateway': 'Redirecting to Payment Gateway',
      'eventRegistration.addressDetails': 'Address Details',
      'eventRegistration.pleaseWaitRedirect': 'Please wait while we redirect you to complete your payment...',
      // Event Categories
      'events.category.workshop': 'Workshop',
      'events.category.seminar': 'Seminar',
      'events.category.training': 'Training',
      'events.category.meeting': 'Meeting',
      'events.category.conference': 'Conference',
      'events.category.webinar': 'Webinar',
      'events.category.exhibition': 'Exhibition',
      'events.category.general': 'General',
      'events.filter': 'Filter',
      // News Categories
      'news.category.regulatoryUpdates': 'Regulatory Updates',
      'news.category.events': 'Events',
      'news.category.infrastructure': 'Infrastructure',
      'news.category.environmental': 'Environmental',
      'news.category.legalUpdates': 'Legal Updates',
      'news.category.industryNews': 'Industry News',
      'news.category.policyUpdates': 'Policy Updates',
      'news.category.uncategorized': 'Uncategorized',
      'news.filter': 'Filter',
      'news.allCategories': 'All Categories',
      // Privacy Policy
      'privacy.title': 'Privacy Policy',
      'privacy.subtitle': 'Your privacy is important to us. This policy explains how we collect, use, and protect your information.',
      'privacy.lastUpdated': 'Last Updated',
      'privacy.effectiveDate': 'Effective Date',
      'privacy.tableOfContents': 'Table of Contents',
      'privacy.section.introduction': 'Introduction',
      'privacy.section.collection': 'Information We Collect',
      'privacy.section.usage': 'How We Use Your Information',
      'privacy.section.sharing': 'Information Sharing and Disclosure',
      'privacy.section.security': 'Data Security',
      'privacy.section.cookies': 'Cookies and Tracking Technologies',
      'privacy.section.rights': 'Your Rights',
      'privacy.section.retention': 'Data Retention',
      'privacy.section.thirdParty': 'Third-Party Links',
      'privacy.section.children': 'Children\'s Privacy',
      'privacy.section.changes': 'Changes to This Privacy Policy',
      'privacy.section.contact': 'Contact Us',
      // Terms & Conditions
      'terms.title': 'Terms & Conditions',
      'terms.subtitle': 'Please read these terms carefully before using our services.',
      'terms.tableOfContents': 'Table of Contents',
      'terms.section.introduction': 'Introduction',
      'terms.section.acceptance': 'Acceptance of Terms',
      'terms.section.membership': 'Membership Terms',
      'terms.section.payment': 'Payment Terms',
      'terms.section.services': 'Services',
      'terms.section.responsibilities': 'User Responsibilities',
      'terms.section.intellectual': 'Intellectual Property',
      'terms.section.liability': 'Limitation of Liability',
      'terms.section.indemnification': 'Indemnification',
      'terms.section.termination': 'Termination',
      'terms.section.disputes': 'Dispute Resolution',
      'terms.section.governing': 'Governing Law',
      'terms.section.contact': 'Contact Us',
      // Refund Policy
      'refund.title': 'Refund & Return Policy',
      'refund.subtitle': 'Important information regarding refunds and returns for our services.',
      'refund.tableOfContents': 'Table of Contents',
      'refund.noRefundNotice': 'No Refund Policy',
      'refund.section.introduction': 'Introduction',
      'refund.section.noRefund': 'No Refund Policy',
      'refund.section.payment': 'Payment Processing',
      'refund.section.exceptions': 'Limited Exceptions',
      'refund.section.nonRefundable': 'Non-Refundable Scenarios',
      'refund.section.membership': 'Membership Fees',
      'refund.section.events': 'Event Registrations',
      'refund.section.disputes': 'Payment Disputes',
      'refund.section.chargebacks': 'Chargebacks',
      'refund.section.cancellation': 'Cancellation by IFM',
      'refund.section.contact': 'Contact for Refund Requests',
      'refund.section.acknowledgment': 'Acknowledgment',
      // Policies Page
      'policies.noPoliciesFound': 'No policies found',
      'policies.tryAdjusting': 'Try adjusting your search or filter criteria.',
      'policies.downloadDocument': 'Download Document',
      'policies.updated': 'Updated',
      'policies.version': 'Version',
      'policies.size': 'Size',
      'news.defaultAuthor': 'IFM Team',
      'news.searchPlaceholder': 'Search news articles...',
      'news.loading': 'Loading news articles...',
      'news.noNewsAvailable': 'No news articles available yet. Check back soon!',
      'news.noArticlesMatch': 'No articles match your current filters.',
      'news.clearFilters': 'Clear Filters',
      'news.article': 'article',
      'news.articles': 'articles',
      'news.breaking': 'Breaking',
      'news.noNewsFound': 'No news found',
      // Gallery
      'gallery.tab.photos': 'Photo Gallery',
      'gallery.tab.videos': 'Video Gallery',
      'gallery.photo.defaultTitle': 'Photo',
      'gallery.photo.untitled': 'Untitled Photo',
      'gallery.photo.noDescription': 'No description',
      'gallery.video.defaultTitle': 'Video thumbnail',
      'gallery.video.untitled': 'Untitled Video',
      'gallery.video.noDescription': 'No description',
      'gallery.category.uncategorized': 'Uncategorized',
      'gallery.aria.closeImage': 'Close image',
      'gallery.aria.nextImage': 'Next image',
      'gallery.aria.closeVideo': 'Close video',
      'gallery.noPhotos': 'No photos available',
      'gallery.noPhotosDesc': 'Photos will appear here once uploaded by administrators.',
      'gallery.noVideos': 'No videos available',
      'gallery.noVideosDesc': 'Videos will appear here once uploaded by administrators.',
      'events.detail.registered': 'registered',
      // Membership (UI text)
      'membership.title': 'Membership',
      'membership.subtitle': 'Join IFM to access comprehensive support, resources, and networking.',
      'membership.benefits.title': 'Member Benefits',
      'membership.benefits.subtitle': 'Powerful advantages tailored for industries across Maharashtra',
      'membership.benefits.regulatory.title': 'Regulatory Support',
      'membership.benefits.regulatory.desc': 'Guidance for compliances, filings, inspections, and approvals',
      'membership.benefits.infrastructure.title': 'Infrastructure Facilitation',
      'membership.benefits.infrastructure.desc': 'Help with utilities, land, permissions, and coordination',
      'membership.benefits.networking.title': 'Networking',
      'membership.benefits.networking.desc': 'Connect with peers, experts, and government officials',
      'membership.benefits.documentation.title': 'Documentation',
      'membership.benefits.documentation.desc': 'Templates, checklists, and assistance for paperwork',
      'membership.benefits.training.title': 'Training & Workshops',
      'membership.benefits.training.desc': 'Regular programs to build skills and awareness',
      'membership.benefits.support.title': 'Dedicated Support',
      'membership.benefits.support.desc': 'Priority responses and case follow-ups',
      'membership.whyChoose.title': 'Why Choose IFM Membership?',
      'membership.whyChoose.network.title': 'Industry Network',
      'membership.whyChoose.network.desc': 'Connect with peers and experts',
      'membership.whyChoose.regulatory.title': 'Regulatory Support',
      'membership.whyChoose.regulatory.desc': 'Expert guidance on compliance',
      'membership.whyChoose.infrastructure.title': 'Infrastructure Help',
      'membership.whyChoose.infrastructure.desc': 'Assistance with utilities & permissions',
      'membership.whyChoose.documentation.title': 'Documentation',
      'membership.whyChoose.documentation.desc': 'Templates and checklists',
      'membership.benefits.core.title': 'Core Benefits',
      // Detailed IFM Membership Benefits (modeled on MACCIA, rebranded to IFM)
      'membership.benefits.long.title': 'Detailed Member Benefits',
      'membership.benefits.long.items': [
        'Generate Business: IFM\'s mission is to generate more business activity for the Trade, Commerce & Agro community. We initiate B2B opportunities and connect professionals for the betterment of your business.',
        'Certificate of Origin to Exporters: IFM supports exporters with guidance on Certificates of Origin, essential for customs clearance and availing trade benefits under FTAs.',
        'Attestation of Legal Documents: Attestation assistance for Power of Attorney, Partnership Agreements, Sales Contracts, Translations, Visa Support Letters, Free Sale Certificates, Product Descriptions, and Form 26.',
        'Monthly Magazine/Newsletter: Insightful articles, policy updates, interviews, economic outlook, and upcoming IFM programs and achievements to keep you informed.',
        'Chamber Events & Programs: B2B programs, networking meets, awards, Business After Hours, roundtables, expos, and special events to generate leads and partnerships.',
        'International Trade Promotion: IFM facilitates international trade interactions and delegations to enhance members\' competitiveness in global markets.',
        'Access to Representatives on Public Bodies: Policy representations to central/state governments and institutions; nominations to relevant national policy committees/task forces.',
        'Web Services: Online access to event registrations, circulars, press releases, membership applications, publications, legal updates, and downloadable business forms.',
        'Increase Your Visibility: Website directory listing, E-newsletter subscription, and new marketing/networking opportunities to elevate your profile.',
        'Visa Recommendatory Letters: Support letters for business travel to fairs, client meetings, or market exploration to strengthen visa applications.',
        'Training Programs: Regular workshops on Export-Import, Entrepreneurship, Startups, Taxation, Financial Literacy, Personality Development, Investment Planning, and Skill Enhancement.',
        'Weekly Economic Updates: Timely curated updates on economic trends, policy changes, regulations, markets, and sector performance.',
        'SMS Updates: Alerts on tax/GST changes, compliance deadlines, IFM event invites, policy shifts, and new business opportunities.',
        'Trade Delegations: Interactions with foreign consulates and business representatives for market exploration and partnerships.',
        'Business Delegations: Outbound delegations (e.g., UAE, China, Singapore, Sri Lanka, Indonesia) for B2B, exhibitions, and JV discussions.',
        'Conferences, Seminars & Workshops: Discounted access to industry-focused events on trade, taxation, innovation, technology, agriculture, and sustainability.',
        'Access to Expert Committees: Guidance from experts on legislation, regulatory challenges, advocacy, and dispute resolution.',
        'Representation on Public Bodies: IFM recommends member representatives to government bodies, task forces, and policy committees, amplifying member voices.',
        'Venue Booking: Concessional booking of IFM conference facilities for events, presses, trainings, launches, and networking.',
        'Directory of Members: Access to a professional directory to discover and collaborate with fellow members.'
      ],
      'membership.plans.title': 'Membership Plans',
      'membership.plans.subtitle': 'Choose the plan that best fits your organization',
      'membership.eligibility.title': 'Eligibility',
      'membership.eligibility.subtitle': 'Who can apply for IFM membership',
      'membership.eligibility.item1': 'Registered industrial entity or MSME',
      'membership.eligibility.item2': 'Valid business and identity documents',
      'membership.eligibility.item3': 'Compliance with applicable laws',
      'membership.eligibility.item4': 'Acceptance of IFM code of conduct',
      'membership.eligibility.item5': 'Timely payment of membership fees',
      'membership.eligibility.item6': 'Agreement to data and communication policies',
      'membership.requirements.title': 'Documentation Requirements',
      'membership.requirements.item1': 'Udyam / MSME Registration (if applicable)',
      'membership.requirements.item2': 'GST Registration Certificate',
      'membership.requirements.item3': 'PAN Card (Company/Proprietor)',
      'membership.requirements.item4': 'Address Proof of Establishment',
      'membership.requirements.item5': 'Authorized Signatory ID Proof',
      'membership.requirements.item6': 'Company Letterhead & Stamp',
      'membership.requirements.item7': 'Two recent photographs',
      'membership.requirements.item8': 'Any specific licenses (as applicable)',
      'membership.cta.register': 'Registration',
      'membership.cta.title': 'Become an IFM Member',
      'membership.cta.subtitle': 'Access expert guidance, representation, and growth opportunities',
      'membership.comparison.title': 'Plan Comparison',
      'membership.comparison.subtitle': 'Compare all membership plans side by side to find the best fit for your needs',
      'membership.comparison.tab': 'Comparison Table',
      'membership.comparison.loading': 'Loading comparison data...',
      'membership.comparison.noPlans': 'No plans available for comparison.',
      'membership.comparison.featuresPlan': 'Features / Plan',
      'membership.comparison.price': 'Price (per year)',
      'membership.comparison.unitsCovered': 'Units Covered',
      'membership.comparison.issueResolution': 'Issue Resolution Support',
      'membership.comparison.govtCoordination': 'Govt Dept. Coordination',
      'membership.comparison.consultations': 'Consultations',
      'membership.comparison.complianceAudit': 'Compliance Audit',
      'membership.comparison.cgwaDish': 'CGWA/DISH Documentation',
      'membership.comparison.infrastructure': 'Infrastructure Escalation',
      'membership.comparison.workshops': 'Workshops / Events',
      'membership.comparison.networking': 'Networking',
      'membership.comparison.branding': 'Branding / Logo Display',
      'membership.comparison.responseTime': 'Response Time',
      'membership.comparison.choosePlan': 'Choose {tier} Plan',
      'membership.comparison.notAvailable': 'N/A',
      'membership.comparison.yes': 'Yes',
      'membership.comparison.no': 'No',
      // Membership Plans specific
      'membership.plans.loading': 'Loading membership plans...',
      'membership.plans.noPlans': 'No membership plans available at the moment.',
      'membership.plans.noPlansDesc': 'Please check back later or contact us for more information.',
      'membership.plans.popular': 'Popular',
      'membership.plans.plan': 'Plan',
      'membership.plans.units': 'Units',
      'membership.plans.per': 'per',
      'membership.plans.months': 'Months',
      'membership.plans.response': 'Response:',
      'membership.plans.keyBenefits': 'Key Benefits',
      'membership.plans.showLess': 'Show Less',
      'membership.plans.viewAllBenefits': 'View All {count} Benefits',
      'membership.plans.noBenefits': 'No benefits listed',
      'membership.plans.support': 'Support',
      'membership.plans.consultations': 'Consultations',
      'membership.plans.choosePlan': 'Choose {tier} Plan',
      'membership.benefits.long.subtitle': 'Comprehensive advantages and services available to all IFM members',
      // Membership Registration/Renewal/Help/Join
      'membership.registration.new.title': 'New Member Registration',
      'membership.registration.new.desc': 'First time joining IFM? Complete the registration process to become a member.',
      'membership.registration.new.cta': 'Start Registration',
      'membership.renewal.title': 'Membership Renewal',
      'membership.renewal.desc': 'Existing member? Renew your membership to continue accessing our services.',
      'membership.renewal.cta': 'Renew Membership',
      'membership.help.title': 'Need Help?',
      'membership.help.desc': 'Our team is here to assist you with the registration process.',
      'membership.help.call': 'Call Us',
      'membership.help.email': 'Email Us',
      'membership.join.title': 'Ready to Join IFM?',
      'membership.join.desc': 'Become a member today and unlock comprehensive industrial support services.',
      'membership.join.registerNow': 'Register Now',
      'membership.join.downloadBrochure': 'Download Brochure',
      // Membership Calculator
      'membership.calculator.title': 'Calculate Your Membership Fee',
      'membership.calculator.workerCount': 'Number of Workers',
      'membership.calculator.workerCountPlaceholder': 'Enter worker count',
      'membership.calculator.calculate': 'Calculate',
      'membership.calculator.fee': 'Membership Fee',
      'membership.calculator.category': 'Category:',
      'membership.calculator.baseFee': 'Base Fee',
      'membership.calculator.additional': 'Additional',
      'membership.calculator.total': 'Total:',
      'membership.calculator.member': 'member',
      'membership.calculator.members': 'members',
      'membership.calculator.pricingStructure': 'Pricing Structure:',
      'membership.calculator.smallIndustries': 'Small Industries',
      'membership.calculator.mediumLargeIndustries': 'Medium/Large Industries',
      'membership.calculator.workers': 'workers',
      'membership.calculator.oneTime': 'one-time',
      'membership.calculator.base': 'base',
      'membership.calculator.perAdditionalWorker': 'per additional worker',
      'membership.calculator.error.workerCount': 'Please enter a valid worker count (at least 1)',
      'membership.calculator.error.calculation': 'Failed to calculate fee. Please try again.',
      // Membership Plan Details
      'membership.plan.unified': 'Stewardship Membership Plan',
      'membership.plan.notAvailable': 'Stewardship membership plan not available',
      'membership.plan.contactAdmin': 'Please contact administrator',
      'membership.plan.duration': 'Duration',
      'membership.plan.trainingProgram': 'Training Program',
      'membership.plan.trainingProgram.weekProgram': '-week program included',
      'membership.plan.trainingProgram.notAvailable': 'Not available',
      'membership.plan.trainingProgram.title': '52-Week Workers Training Program',
      'membership.plan.trainingProgram.description': 'As a value-added benefit, Industrial Fedration conducts continuous online and offline workshops and training programs throughout the year (52 weeks) for workers of member industries.',
      'membership.plan.trainingProgram.areas': 'Training Areas:',
      'membership.plan.trainingProgram.outcomes': 'Training Outcomes:',
      'membership.plan.keyBenefits': 'Key Benefits',
      // Events
      'events.participants': 'participants',
      // Gallery
      'gallery.video.unsupported': 'Unsupported video URL',
      'gallery.aria.previousImage': 'Previous image',
      // Navigation - Mobile
      'nav.mobile.followUs': 'Follow Us:',
      'nav.mobile.language': 'Language / भाषा',
      // Video
      'video.browserNotSupported': 'Your browser does not support the video tag.',
      // Carousel
      'carousel.previous': 'Previous feature',
      'carousel.next': 'Next feature',
      'carousel.goToSlide': 'Go to slide',
      'home.title': 'Industrial Fedration of Maharashtra Region',
      'home.subtitle': 'Empowering Industries, Building Maharashtra',
      'home.exploreSupport': 'Explore Support',
      'home.learnMore': 'Know More',
      'home.whyChooseUs': 'Why Choose Us',
      'home.whyChooseUsDesc': 'Trusted partner for industry growth, compliance and advocacy',
      'home.whyChooseUs.title': 'Why Choose Us?',
      'home.whyChooseUs.subtitle': 'We provide comprehensive support and expert guidance to help your business thrive in Maharashtra\'s industrial landscape.',
      'home.whyChooseUs.feature1.title': 'Multi-Departmental Coordination',
      'home.whyChooseUs.feature1.desc': 'A strong chain of multi-departmental government coordination',
      'home.whyChooseUs.feature2.title': 'Expert Compliance Guidance',
      'home.whyChooseUs.feature2.desc': 'Expert guidance on compliance and minimizing legal risks',
      'home.whyChooseUs.feature3.title': 'Fast Problem Resolution',
      'home.whyChooseUs.feature3.desc': 'Fast and effective representation to solve problems',
      'home.whyChooseUs.feature4.title': 'Sustainable Business Culture',
      'home.whyChooseUs.feature4.desc': 'Emphasis on sustainability, security, and a lawful business culture',
      'home.whyChooseUs.feature5.title': 'Government Benefits Access',
      'home.whyChooseUs.feature5.desc': 'Assistance that ensures full utilization of government schemes and benefits',
      'home.whyChooseUs.feature6.title': 'Industry Networking & Collaboration',
      'home.whyChooseUs.feature6.desc': 'Connect with industry leaders, share best practices, and collaborate on initiatives that drive industrial growth across Maharashtra',
      'home.whyChooseUs.feature7.title': 'Training & Development Programs',
      'home.whyChooseUs.feature7.desc': 'Comprehensive training programs, workshops, and skill development initiatives to enhance workforce capabilities and industry standards',
      'home.president.experienceLabel': 'Experience',
      'home.president.backgroundLabel': 'Background',
      'home.recentNewsTitle': 'Recent News & Announcements',
      'home.recentNewsSubtitle': 'Stay updated with the latest news, updates, and upcoming events from IFM',
      'home.upcomingEvents': 'Upcoming Events',
      'home.feature1.title': 'Regulatory Support',
      'home.feature1.desc': 'Expert guidance on compliance and regulations',
      'home.feature2.title': 'Industry Networking',
      'home.feature2.desc': 'Connect with fellow industrialists',
      'home.feature3.title': 'Training Programs',
      'home.feature3.desc': 'Professional development opportunities',
      'home.feature4.title': 'Advocacy',
      'home.feature4.desc': 'Representing industry interests',
      // Home - Quick Links
      'home.quickLinks': 'Quick Links',
      'home.quickLinksDesc': 'Access common sections of the portal quickly',
      // Home - Companies
      'home.companies.title': 'Companies Tied Up With Us',
      'home.companies.subtitle': 'Trusted partners and collaborators across industry',
      'home.companies.emptyTitle': 'Companies coming soon',
      'home.companies.emptyDesc': 'We are onboarding partner companies and will showcase them here shortly.',
      'home.companies.viewAll': 'View All Partners',
      // Partners Page
      'partners.title': 'Our Partner Companies',
      'partners.subtitle': 'Explore the companies tied up with IFM and collaborating across industry initiatives.',
      'partners.filters': 'Filters',
      'partners.searchPlaceholder': 'Search company name or tagline',
      'partners.filterAll': 'All companies',
      'partners.filterWithWebsite': 'With website link',
      'partners.filterWithoutWebsite': 'Without website link',
      'partners.loading': 'Loading companies...',
      'partners.emptyTitle': 'No companies found',
      'partners.emptyDesc': 'Try adjusting your filters or check back later.',
      'partners.visitWebsite': 'Visit Website',
      'partners.noWebsite': 'Website link not provided',
      'partners.back': 'Back',
      'partners.homeLink': 'Go to Home',
      'home.viewAllNews': 'View All News',
      'home.viewAllEvents': 'View All Events',
      'home.quickLink1.title': 'Explore Support Services',
      'home.quickLink1.desc': 'Discover regulatory, compliance, and advisory support',
      'home.quickLink2.title': 'Upcoming Events',
      'home.quickLink2.desc': 'Workshops, seminars, and networking opportunities',
      'home.quickLink3.title': 'Photo Gallery',
      'home.quickLink3.desc': 'View recent events and activities',
      // Home - Contact
      'home.contactUs': 'Contact Us',
      'home.contactUsDesc': 'Reach out to us for support and information',
      'home.contact.phone': 'Phone',
      'home.contact.email': 'Email',
      'home.contact.address': 'Office Address',
      'home.contact.addressValue': 'IFM Office, 3rd Floor, Business Plaza, Bandra East, Mumbai - 400051',
      'home.contact.followUs': 'Follow Us',
      'home.contact.quickLinks': 'Quick Links',
      // Footer
      'footer.legalPolicies': 'Legal & Policies',
      'footer.privacyPolicy': 'Privacy Policy',
      'footer.termsConditions': 'Terms & Conditions',
      'footer.refundPolicy': 'Refund Policy',
      // Navigation - Important Links
      'nav.importantLinks.rofPortal': 'ROF | Portal',
      'nav.importantLinks.incomeTax': 'Income Tax Department',
      'nav.importantLinks.mahagst': 'MAHAGST',
      'nav.importantLinks.aapleSarkar': 'Aaple Sarkar',
      'nav.importantLinks.esic': 'ESIC',
      'nav.importantLinks.epfo': 'EPFO',
      // Navigation - Social Media
      'nav.socialMedia.linkedin': 'LinkedIn',
      'nav.socialMedia.instagram': 'Instagram',
      'nav.socialMedia.facebook': 'Facebook',
      'nav.socialMedia.youtube': 'YouTube',
      'home.contact.aboutUs': 'About Us',
      'home.contact.missionVision': 'Mission & Vision',
      'home.contact.committee': 'Committee',
      'home.contact.presidentMessage': 'President Message',
      'home.contact.copyright': 'All rights reserved',
      'home.readMore': 'Read More',
      'home.news.label': 'News',
      'home.event.label': 'Event',
      // Dashboard
      'dashboard.title': 'Dashboard',
      'dashboard.welcome': 'Welcome back! Here\'s what\'s happening with IFM.',
      'dashboard.totalMembers': 'Total Members',
      'dashboard.activeServices': 'Active Services',
      'dashboard.upcomingEvents': 'Upcoming Events',
      'dashboard.openGrievances': 'Open Grievances',
      'dashboard.fromLastMonth': 'from last month',
      'dashboard.quickActions': 'Quick Actions',
      'dashboard.recentActivities': 'Recent Activities',
      'dashboard.submitGrievance': 'Submit Grievance',
      'dashboard.submitGrievanceDesc': 'Report an issue or concern',
      'dashboard.registerForEvent': 'Register for Event',
      'dashboard.registerForEventDesc': 'Join upcoming workshops',
      'dashboard.downloadPolicy': 'Download Policy',
      'dashboard.downloadPolicyDesc': 'Access latest guidelines',
      'dashboard.contactSupport': 'Contact Support',
      'dashboard.contactSupportDesc': 'Get help from our team',
      'dashboard.upcomingEventsTitle': 'Upcoming Events',
      'dashboard.systemStatus': 'System Status',
      'dashboard.operational': 'Operational',
      'dashboard.apiServices': 'API Services',
      'dashboard.database': 'Database',
      'dashboard.paymentGateway': 'Payment Gateway',
      'dashboard.emailService': 'Email Service',
      // About - Hero
      'about.title': 'About IFM',
      'about.subtitle': 'Leading Maharashtra\'s Industrial Growth',
      // About - Vision & Mission
      'about.vision.title': 'Our Vision',
      'about.vision.desc': 'To build a unified, compliant, and thriving industrial ecosystem that promotes sustainable growth, regulatory adherence, and mutual cooperation between industries and governmental authorities.',
      'about.mission.title': 'Our Mission',
      'about.mission.subtitle': 'To serve as a proactive and results-driven platform for industries by resolving critical regulatory, infrastructural, and administrative challenges through effective coordination, expert representation, and strategic policy advocacy.',
      'about.mission.desc': 'To serve as a proactive and results-driven platform for industries by resolving critical regulatory, infrastructural, and administrative challenges through effective coordination, expert representation, and strategic policy advocacy.',
      // About - Values
      'about.values.title': 'Core Values',
      'about.values.desc': 'Principles that guide our mission and services',
      'about.values.integrity': 'Integrity',
      'about.values.integrity.desc': 'We uphold transparency and accountability in all actions',
      'about.values.collaboration': 'Collaboration',
      'about.values.collaboration.desc': 'We work with stakeholders to deliver better outcomes',
      'about.values.innovation': 'Innovation',
      'about.values.innovation.desc': 'We promote modern, efficient, and sustainable practices',
      'about.values.excellence': 'Excellence',
      'about.values.excellence.desc': 'We strive for high standards and continuous improvement',

      // About - Strategic Objectives
      'about.objectives.title': 'Strategic Objectives',
      'about.objectives.desc': 'Key focus areas that drive our mission and vision forward',
      'about.objectives.sustainable.title': 'Sustainable Growth',
      'about.objectives.sustainable.desc': 'Promoting environmentally responsible industrial practices and green technologies for long-term prosperity.',
      'about.objectives.collaboration.title': 'Industry Collaboration',
      'about.objectives.collaboration.desc': 'Building strong partnerships between government, industry, and communities for mutual benefit.',
      'about.objectives.innovation.title': 'Innovation Support',
      'about.objectives.innovation.desc': 'Fostering technological advancement and research initiatives to drive industrial competitiveness.',

      // About - Call to Action
      'about.join.title': 'Join Our Mission',
      'about.join.desc': 'Be part of Maharashtra\'s industrial transformation. Together, we can build a sustainable and prosperous future.',
      'about.join.member': 'Become a Member',
      'about.join.contact': 'Get in Touch',

      // About - IFM Introduction
      'about.intro.title': 'About Industrial Fedration of Maharashtra Region',
      'about.intro.description': 'Industrial Fedration of Maharashtra Region (IFM) (Reg. No. Maha./745/2025, Pune) is a registered body working for the rights and issues of industries in Maharashtra. We represent industries before government authorities like MPCB, MIDC, DIC, Safety Dept., and Pollution Control Boards to ensure fair policies, transparency, and support for small, medium, and large industries.',

      // About - Vision Details
      'about.vision.details.1': 'To ensure equal opportunities for all industries.',
      'about.vision.details.2': 'To create a transparent and competitive environment.',
      'about.vision.details.3': 'To promote scientific and just environmental policies.',
      'about.vision.details.4': 'To eliminate monopoly practices in industrial services.',
      'about.vision.details.5': 'To build a sustainable and progressive industrial ecosystem in Maharashtra.',

      // About - Core Values Details
      'about.values.integrity.details.1': 'Transparent decision-making processes',
      'about.values.integrity.details.2': 'Accountable leadership and governance',
      'about.values.integrity.details.3': 'Ethical business practices',
      'about.values.integrity.details.4': 'Honest communication with stakeholders',
      'about.values.collaboration.details.1': 'Cross-sector partnerships',
      'about.values.collaboration.details.2': 'Government-industry cooperation',
      'about.values.collaboration.details.3': 'Community engagement initiatives',
      'about.values.collaboration.details.4': 'Knowledge sharing platforms',
      'about.values.innovation.details.1': 'Technology adoption programs',
      'about.values.innovation.details.2': 'Digital transformation initiatives',
      'about.values.innovation.details.3': 'Sustainable manufacturing processes',
      'about.values.innovation.details.4': 'Research and development support',
      'about.values.excellence.details.1': 'Quality assurance programs',
      'about.values.excellence.details.2': 'Continuous improvement initiatives',
      'about.values.excellence.details.3': 'Best practice implementation',
      'about.values.excellence.details.4': 'Performance benchmarking',

      // About - Core Values Sections
      'about.values.living.title': 'Living Our Values',
      'about.values.living.desc': 'How we translate our core values into actionable initiatives and measurable outcomes',
      'about.values.initiatives.title': 'Key Initiatives',
      'about.values.action.title': 'Values in Action',
      'about.values.action.desc': 'Real examples of how our values guide our work and create positive impact',
      'about.values.action.transparent.title': 'Transparent Governance',
      'about.values.action.transparent.desc': 'Regular public reports on our activities, financial transparency, and open communication with all stakeholders.',
      'about.values.action.community.title': 'Community Partnerships',
      'about.values.action.community.desc': 'Collaborative projects with local communities, educational institutions, and industry associations.',
      'about.values.action.excellence.title': 'Excellence Recognition',
      'about.values.action.excellence.desc': 'Awards and recognition programs for outstanding industrial practices and innovation achievements.',

      // About - Core Values Call to Action
      'about.values.share.title': 'Share Our Values',
      'about.values.share.desc': 'Join us in upholding these values and contributing to Maharashtra\'s industrial excellence.',
      'about.values.share.member': 'Become a Member',
      'about.values.share.learn': 'Learn More',

      // About - Structure Additional Content
      'about.structure.detailed.title': 'Detailed Organization Structure',
      'about.structure.detailed.desc': 'Understanding how each department contributes to our mission and serves our members',
      'about.structure.leadership.title': 'Leadership Team',
      'about.structure.leadership.desc': 'Meet the dedicated leaders who guide IFM\'s strategic direction and operations',
      'about.structure.leadershipCta': 'Meet the dedicated leaders who guide our strategic direction.',
      'about.leadership.viewCommittee': 'View Committee Members',
      'about.structure.chart.title': 'Organizational Chart',
      'about.structure.chart.desc': 'Visual representation of our organizational hierarchy and reporting structure',

      // About - Structure Regional Cities
      'about.structure.regional.mumbai': 'Mumbai',
      'about.structure.regional.pune': 'Pune',
      'about.structure.regional.nagpur': 'Nagpur',
      'about.structure.regional.aurangabad': 'Aurangabad',
      'about.structure.regional.nashik': 'Nashik',

      // About - Structure Leadership Team
      'about.structure.leadership.president.name': 'Mr Kailas Narke',
      'about.structure.leadership.president.position': 'President',
      'about.structure.leadership.president.department': 'Executive Leadership',
      'about.structure.leadership.vicePresident.name': 'Mr Javed Inamdar',
      'about.structure.leadership.vicePresident.position': 'Vice President',
      'about.structure.leadership.vicePresident.department': 'Strategic Planning',
      'about.structure.leadership.secretary.name': 'Ms Deepa Mahajan',
      'about.structure.leadership.secretary.position': 'Secretary',
      'about.structure.leadership.secretary.department': 'Operations',
      'about.structure.leadership.treasurer.name': 'Mr Ramdas Napte',
      'about.structure.leadership.treasurer.position': 'Treasurer',
      'about.structure.leadership.treasurer.department': 'Finance',
      'about.structure.leadership.chiefConsultant.name': 'Mr Prashant Mundada',
      'about.structure.leadership.chiefConsultant.position': 'Chief Consultant Officer',
      'about.structure.leadership.chiefConsultant.department': 'Consulting',

      // About - Structure Chart Departments
      'about.structure.chart.technical.title': 'Technical',
      'about.structure.chart.technical.subtitle': 'Committee',
      'about.structure.chart.regional.title': 'Regional',
      'about.structure.chart.regional.subtitle': 'Committees',
      'about.structure.chart.support.title': 'Support',
      'about.structure.chart.support.subtitle': 'Staff',
      'about.structure.chart.external.title': 'External',
      'about.structure.chart.external.subtitle': 'Relations',

      // About - Structure Call to Action
      'about.structure.join.title': 'Join Our Organization',
      'about.structure.join.desc': 'Be part of a well-structured organization that\'s committed to industrial excellence and member success.',
      'about.structure.join.member': 'Become a Member',
      'about.structure.join.learn': 'Learn More',

      // About - Achievements Page
      'about.achievements.journey.title': 'Our Journey',
      'about.achievements.journey.desc': 'Key milestones and achievements that have shaped our organization\'s growth and impact',
      'about.achievements.milestone.2023.title': 'Digital Transformation Initiative',
      'about.achievements.milestone.2023.desc': 'Launched comprehensive digital platform for member services and regulatory compliance.',
      'about.achievements.milestone.2023.achievements.1': 'Online membership portal',
      'about.achievements.milestone.2023.achievements.2': 'Digital document management',
      'about.achievements.milestone.2023.achievements.3': 'Mobile app launch',
      'about.achievements.milestone.2022.title': 'Sustainability Program',
      'about.achievements.milestone.2022.desc': 'Introduced green industrial practices and environmental compliance support.',
      'about.achievements.milestone.2022.achievements.1': 'Green certification program',
      'about.achievements.milestone.2022.achievements.2': 'Carbon footprint reduction',
      'about.achievements.milestone.2022.achievements.3': 'Renewable energy adoption',
      'about.achievements.milestone.2021.title': 'Regional Expansion',
      'about.achievements.milestone.2021.desc': 'Extended services to all major industrial districts in Maharashtra.',
      'about.achievements.milestone.2021.achievements.1': '5 new regional offices',
      'about.achievements.milestone.2021.achievements.2': 'Local support teams',
      'about.achievements.milestone.2021.achievements.3': 'District-level partnerships',
      'about.achievements.milestone.2020.title': 'COVID-19 Support Initiative',
      'about.achievements.milestone.2020.desc': 'Provided critical support to industries during the pandemic.',
      'about.achievements.milestone.2020.achievements.1': 'Emergency relief fund',
      'about.achievements.milestone.2020.achievements.2': 'Safety protocol guidance',
      'about.achievements.milestone.2020.achievements.3': 'Supply chain support',
      'about.achievements.impact.title': 'Our Impact',
      'about.achievements.impact.desc': 'How our achievements translate into real benefits for Maharashtra\'s industrial sector',
      'about.achievements.impact.economic.title': 'Economic Growth',
      'about.achievements.impact.economic.desc': 'Contributing to Maharashtra\'s industrial GDP through member support and policy advocacy.',
      'about.achievements.impact.employment.title': 'Employment Generation',
      'about.achievements.impact.employment.desc': 'Supporting job creation through industrial development and skill enhancement programs.',
      'about.achievements.impact.policy.title': 'Policy Influence',
      'about.achievements.impact.policy.desc': 'Shaping industrial policies through advocacy and representation at state and national levels.',
      'about.achievements.recognition.title': 'Recognition & Awards',
      'about.achievements.recognition.desc': 'Industry recognition for our outstanding contributions and service excellence',
      'about.achievements.award1.title': 'Best Industry Association',
      'about.achievements.award1.event': 'Maharashtra Industrial Excellence Awards 2023',
      'about.achievements.award1.desc': 'Recognized for outstanding service to Maharashtra\'s industrial sector and innovative member support programs.',
      'about.achievements.award2.title': 'Sustainability Leadership',
      'about.achievements.award2.event': 'Green Industrial Awards 2022',
      'about.achievements.award2.desc': 'Honored for promoting sustainable industrial practices and environmental compliance across Maharashtra.',
      'about.achievements.future.title': 'Looking Ahead',
      'about.achievements.future.desc': 'Our vision for the future and upcoming initiatives to further strengthen Maharashtra\'s industrial sector',
      'about.achievements.goals.title': '2024-2026 Strategic Goals',
      'about.achievements.goals.1': 'Expand membership to 1000+ active members',
      'about.achievements.goals.2': 'Launch AI-powered compliance assistance platform',
      'about.achievements.goals.3': 'Establish international trade partnerships',
      'about.achievements.goals.4': 'Achieve 100% digital service delivery',
      'about.achievements.innovation.title': 'Innovation Initiatives',
      'about.achievements.innovation.1': 'Smart manufacturing support programs',
      'about.achievements.innovation.2': 'Blockchain-based certification system',
      'about.achievements.innovation.3': 'Virtual reality training modules',
      'about.achievements.innovation.4': 'IoT integration for industrial monitoring',
      'about.achievements.cta.title': 'Be Part of Our Success Story',
      'about.achievements.cta.desc': 'Join us in continuing our journey of excellence and contributing to Maharashtra\'s industrial growth.',
      'about.achievements.cta.member': 'Become a Member',
      'about.achievements.cta.learn': 'Learn More',

      // About - Committee Page
      'about.committee.leadership.desc': 'Experienced professionals leading IFM\'s strategic direction and day-to-day operations',
      'about.committee.structure.desc': 'Organized committees ensuring comprehensive coverage of all aspects of industrial support',
      'about.committee.responsibilities.desc': 'Clear roles and responsibilities ensuring effective governance and service delivery',
      'about.committee.contact.desc': 'Reach out to our committee members for specific inquiries and support',
      'about.committee.contact.secretary.role': 'Committee Coordination',
      'about.committee.cta.title': 'Join Our Committee',
      'about.committee.cta.desc': 'Interested in contributing to IFM\'s mission? Consider joining one of our committees.',
      'about.committee.cta.member': 'Become a Member',
      'about.committee.cta.contact': 'Contact Us',
      'about.committee.experience': 'Experience',
      'about.committee.members': 'Committee Members:',
      'about.committee.membersSection.title': 'Committee Members',
      'about.committee.membersSection.desc': 'Our dedicated committee members and their roles',
      'about.committee.role.member': 'Committee Member',
      'about.committee.member.prashantMundada.name': 'prashant Mundada',
      'about.committee.member.shrikantNarke.name': 'Mr Shrikant Narke',
      'about.committee.member.dadasahebShinalkar.name': 'Mr Dadasaheb Shinalkar',
      'about.committee.member.sachinDhumal.name': 'Mr Sachin Dhumal',
      'about.committee.member.sudhirBhadhe.name': 'Mr Sudhir Bhadhe',
      'about.committee.expertise': 'Expertise',
      'about.committee.responsibility.executive.1': 'Strategic planning and policy formulation',
      'about.committee.responsibility.executive.2': 'Board governance and oversight',
      'about.committee.responsibility.executive.3': 'Financial approval and budget management',
      'about.committee.responsibility.executive.4': 'Stakeholder relationship management',
      'about.committee.responsibility.technical.1': 'Technical advisory and consultation',
      'about.committee.responsibility.technical.2': 'Safety standards and compliance guidance',
      'about.committee.responsibility.technical.3': 'Technology adoption recommendations',
      'about.committee.responsibility.technical.4': 'Training program development',
      'about.committee.responsibility.regional.1': 'Local member support and engagement',
      'about.committee.responsibility.regional.2': 'Regional event coordination',
      'about.committee.responsibility.regional.3': 'District-level policy advocacy',
      'about.committee.responsibility.regional.4': 'Community outreach programs',
      'about.committee.responsibility.finance.1': 'Budget planning and monitoring',
      'about.committee.responsibility.finance.2': 'Financial reporting and audit oversight',
      'about.committee.responsibility.finance.3': 'Investment and fund management',
      'about.committee.responsibility.finance.4': 'Cost control and efficiency measures',
      'about.committee.executive.name': 'Executive Committee',
      'about.committee.executive.desc': 'Strategic leadership and governance oversight',
      'about.committee.technical.name': 'Technical Committee',
      'about.committee.technical.desc': 'Subject matter expertise and advisory services',
      'about.committee.regional.name': 'Regional Committee',
      'about.committee.regional.desc': 'Local representation across Maharashtra',
      'about.committee.finance.name': 'Finance Committee',
      'about.committee.finance.desc': 'Financial oversight and budget management',

      // Home Page - About IFM Section
      'home.about.title': 'About IFM',
      'home.about.intro': 'Industrial Fedration is a leading professional organization.',
      'home.about.point1': 'It is an organization which brings together the industry sector and various government departments.',
      'home.about.point2': 'An important link (Bridge) between departments.',
      'home.about.point3': 'So it works. Regulators facing industries (Regulatory), technical and infrastructure.',
      'home.about.commitment': 'We are always committed to solving problems.',
      'home.about.federation.title': 'About Federation',
      'home.about.federation.desc1': 'The Industrial Fedration is a professional and reliable organization that works to resolve the regulatory, operational, and infrastructure challenges faced by industries. We act as a crucial coordinating link between industries and various government departments, ensuring that industrial operations run smoothly, legally, and sustainably.',
      'home.about.federation.desc2': 'Our primary objective is to create a favorable and fear-free environment for industries, and to promote responsible industrial practices such as environmental protection, worker safety, and resource management.',
      'home.about.knowMore': 'Know More',

      // Home Page - President Message Section
      'home.president.title': 'President\'s Message',
      'home.president.message1': 'Dear Industrial Partners,',
      'home.president.message2': 'It is my great pleasure to welcome you to the Industrial Federation. Industries are the backbone of regional and national economic growth. Yet, in the journey of progress, industries often face challenges related to regulations, administration, and infrastructure. Industrial Fedration was established with a clear purpose—to address these challenges and to bring industries together on one unified, empowered platform.',
      'home.president.message3': 'Our mission is simple yet powerful: To empower industries, resolve challenges, and serve as a strong and effective bridge between industries and government authorities.',
      'home.president.message4': 'The industrial world is evolving rapidly. With increasing competition, it is essential for industries to embrace quality, safety, environmental responsibility, innovation, and compliance. Industrial Fedration supports industries in all these areas through expert coordination, policy guidance, administrative assistance, and strategic representation across various government departments.',
      'home.president.message5': 'Strong Industries = Strong Region = Strong Nation',
      'home.president.message6': 'To achieve this vision, we work consistently with Pollution Control Authorities, DISH, MIDC, MSEDCL, DIC, Labour Department, and other key government bodies ensuring transparent, reliable, and timely solutions for industrial needs.',
      'home.president.message7': 'Our purpose goes beyond problem-solving. We are committed to promoting sustainable and responsible industrial growth, building safe and compliant workplaces, supporting eco-friendly and efficient resource management, strengthening the collective voice of industries, and creating an ecosystem that encourages innovation and development.',
      'home.president.message8': 'Industrial Fedration is not just a platform—it is the pride, strength, and unified voice of the industrial community. We are dedicated to working tirelessly for the progress, stability, and long-term development of all industries.',
      'home.president.message9': 'With your continued support, we are confident of building a strong, progressive, and collaborative industrial ecosystem for the future. Thank you for being a valued part of the Industrial Federation.',
      'home.president.thankYou': 'Thank you for being a valued part of the Industrial Federation.',
      'home.president.missionTitle': 'Our Mission is Simple Yet Powerful',
      'home.president.name': 'Mr Kailas Narke',
      'home.president.position': 'President, Industrial Fedration of Maharashtra Region',
      'home.president.experience': '10+ Years in Industrial Leadership',
      'home.president.background': 'Former Director, Maharashtra Industries',
      'about.president.purpose.title': 'Our Purpose Goes Beyond Problem-Solving',
      'about.president.purpose.committed': 'We are committed to:',
      'about.president.commitment.sustainable': 'Promoting sustainable and responsible industrial growth',
      'about.president.commitment.safeWorkplaces': 'Building safe and compliant workplaces',
      'about.president.commitment.resourceManagement': 'Supporting eco-friendly and efficient resource management',
      'about.president.commitment.collectiveVoice': 'Strengthening the collective voice of industries',
      'about.president.commitment.innovationEcosystem': 'Creating an ecosystem that encourages innovation and development',
      'about.president.partnerships.title': 'Government Partnerships & Collaborations',
      // About - Structure
      'about.structure.title': 'Organization Structure',
      'about.structure.subtitle': 'How IFM is organized to serve industry better',
      'about.structure.executive.title': 'Executive Committee',
      'about.structure.executive.desc': 'Strategic leadership and governance',
      'about.structure.executive.members.chairman': 'Chairman',
      'about.structure.executive.members.viceChairman': 'Vice Chairman',
      'about.structure.executive.members.secretary': 'Secretary',
      'about.structure.executive.members.treasurer': 'Treasurer',
      'about.structure.technical.title': 'Technical Committee',
      'about.structure.technical.desc': 'Subject matter expertise and advisory',
      'about.structure.technical.members.safety': 'Industrial Safety',
      'about.structure.technical.members.environmental': 'Environmental Compliance',
      'about.structure.technical.members.infrastructure': 'Infrastructure',
      'about.structure.technical.members.compliance': 'Regulatory Compliance',
      'about.structure.regional.title': 'Regional Committees',
      'about.structure.regional.desc': 'Local representation across Maharashtra',
      'about.structure.support.title': 'Support Staff',
      'about.structure.support.desc': 'Operational excellence and service delivery',
      'about.structure.support.members.admin': 'Administration',
      'about.structure.support.members.technical': 'Technical Support',
      'about.structure.support.members.field': 'Field Operations',
      'about.structure.support.members.it': 'IT Support',
      // About - Achievements
      'about.achievements.title': 'Our Achievements',
      'about.achievements.subtitle': 'Building trust and excellence across Maharashtra\'s industrial landscape',
      'about.quickLinks.title': 'Explore More About Us',
      'about.quickLinks.subtitle': 'Discover our leadership, mission, structure, and achievements',
      'about.quickLinks.learnMore': 'Learn More',
      'about.values.viewAll': 'View All Core Values',
      'about.achievements.members.label': 'Active Members',
      'about.achievements.members.desc': 'Strong and growing member base',
      'about.achievements.events.label': 'Events Conducted',
      'about.achievements.events.desc': 'Workshops, seminars, and trainings organized',
      'about.achievements.satisfaction.label': 'Member Satisfaction',
      'about.achievements.satisfaction.desc': 'Consistently high satisfaction ratings',
      'about.achievements.years.label': 'Years of Service',
      'about.achievements.years.desc': 'Experience in supporting industries',
      // About - President
      'about.president.title': 'President Profile',
      'about.president.subtitle': 'Leadership that drives industrial excellence across Maharashtra',
      'about.president.name': 'Mr Kailas Narke',
      'about.president.position': 'President',
      'about.president.organization': 'Industrial Fedration of Maharashtra Region',
      'about.president.message.title': 'President\'s Message',
      'about.president.message.text1': 'It gives me immense pleasure to welcome you to the Industrial Fedration of Maharashtra Region (IFM). As we navigate through the dynamic landscape of industrial development, IFM remains committed to fostering sustainable growth and innovation across Maharashtra.',
      'about.president.message.text2': 'Our organization has been at the forefront of promoting industrial excellence, safety standards, and environmental responsibility. We believe that true progress comes from balancing economic growth with social responsibility and environmental stewardship.',
      'about.president.message.text3': 'Through our comprehensive programs, we provide technical support, policy advocacy, and training opportunities that empower industries to thrive while contributing positively to our communities. Our collaborative approach brings together government agencies, industry leaders, and local stakeholders.',
      'about.president.message.text4': 'As we look towards the future, IFM is committed to embracing new technologies, sustainable practices, and innovative solutions that will drive Maharashtra\'s industrial sector to new heights. Together, we can build a more prosperous and sustainable tomorrow.',
      'about.president.experience.title': 'Experience',
      'about.president.experience.item1': '10+ Years in Industrial Leadership',
      'about.president.experience.item2': 'Former Director, Maharashtra Industries',
      'about.president.experience.item3': 'Expert in Policy Advocacy',
      'about.president.experience.item4': 'Regulatory Compliance Specialist',
      'about.president.leadership.title': 'Leadership',
      'about.president.leadership.item1': 'Strategic Vision & Planning',
      'about.president.leadership.item2': 'Stakeholder Management',
      'about.president.leadership.item3': 'Industry Development',
      'about.president.leadership.item4': 'Team Building & Mentoring',
      'about.president.focus.title': 'Key Focus Areas',
      'about.president.focus.sustainable.title': 'Sustainable Development',
      'about.president.focus.sustainable.desc': 'Promoting eco-friendly industrial practices and green technologies.',
      'about.president.focus.policy.title': 'Policy Advocacy',
      'about.president.focus.policy.desc': 'Representing industry interests at state and national levels.',
      'about.president.focus.skill.title': 'Skill Development',
      'about.president.focus.skill.desc': 'Enhancing workforce capabilities through training programs.',
      'about.president.focus.innovation.title': 'Innovation Support',
      'about.president.focus.innovation.desc': 'Fostering technological advancement and R&D initiatives.',
      'about.president.timeline.title': 'Professional Timeline',
      'about.president.timeline.2020.title': '2020 - Present',
      'about.president.timeline.2020.position': 'President, Industrial Fedration of Maharashtra Region',
      'about.president.timeline.2020.desc': 'Leading strategic initiatives and policy advocacy for industrial growth',
      'about.president.timeline.2015.title': '2015 - 2020',
      'about.president.timeline.2015.position': 'Director, Maharashtra Industries',
      'about.president.timeline.2015.desc': 'Oversaw industrial development policies and regulatory frameworks',
      'about.president.timeline.2010.title': '2010 - 2015',
      'about.president.timeline.2010.position': 'Senior Advisor, Industrial Policy',
      'about.president.timeline.2010.desc': 'Provided expert guidance on industrial regulations and compliance',
      // About - Founder
      'about.founder.title': 'Founder',
      'about.founder.subtitle': 'The visionary leader who laid the foundation for Maharashtra\'s industrial excellence',
      'about.founder.name': 'Dr. Rajesh Kumar Sharma',
      'about.founder.position': 'Founder & Chairman Emeritus',
      'about.founder.organization': 'Industrial Fedration of Maharashtra Region',
      'about.founder.stats.years': 'Years of Service',
      'about.founder.stats.industries': 'Industries Supported',
      'about.founder.stats.awards': 'Awards Received',
      'about.founder.vision.title': 'Founder\'s Vision',
      'about.founder.vision.text1': 'I envisioned a Maharashtra where industries would not just survive, but thrive through collaboration, innovation, and mutual support. The Industrial Fedration of Maharashtra Region was born from this dream - to create a unified platform that would bridge the gap between government policies and industrial needs.',
      'about.founder.vision.text2': 'Our mission was simple yet profound: to empower every industrial unit, from the smallest MSME to the largest corporation, with the tools, knowledge, and support they need to succeed in an ever-evolving economic landscape.',
      'about.founder.vision.text3': 'I believed that true industrial growth comes not from competition alone, but from collaboration, shared learning, and collective progress. This philosophy continues to guide IFM\'s work today.',
      'about.founder.journey.title': 'Founding Journey',
      'about.founder.journey.1995.title': '1995 - The Vision',
      'about.founder.journey.1995.position': 'Initial Concept Development',
      'about.founder.journey.1995.desc': 'Recognized the need for a unified industrial body in Maharashtra during early career in industrial policy',
      'about.founder.journey.2000.title': '2000 - Foundation',
      'about.founder.journey.2000.position': 'IFM Establishment',
      'about.founder.journey.2000.desc': 'Officially founded IFM with initial 50 member companies and established the first office in Mumbai',
      'about.founder.journey.2005.title': '2005 - Expansion',
      'about.founder.journey.2005.position': 'Regional Growth',
      'about.founder.journey.2005.desc': 'Expanded operations to Pune, Nagpur, and Aurangabad, establishing regional committees',
      'about.founder.journey.2010.title': '2010 - Recognition',
      'about.founder.journey.2010.position': 'Government Recognition',
      'about.founder.journey.2010.desc': 'Received official recognition from Maharashtra government as the premier industrial federation',
      'about.founder.achievements.title': 'Key Achievements',
      'about.founder.achievements.item1': 'Established IFM as Maharashtra\'s leading industrial body',
      'about.founder.achievements.item2': 'Grew membership from 50 to 500+ companies',
      'about.founder.achievements.item3': 'Created comprehensive support framework',
      'about.founder.achievements.item4': 'Established government-industry partnerships',
      'about.founder.legacy.title': 'Legacy',
      'about.founder.legacy.item1': 'Sustainable industrial development model',
      'about.founder.legacy.item2': 'Collaborative governance framework',
      'about.founder.legacy.item3': 'Member-centric service approach',
      'about.founder.legacy.item4': 'Innovation-driven growth strategy',
      'about.founder.philosophy.title': 'Founding Philosophy',
      'about.founder.philosophy.unity.title': 'Unity in Diversity',
      'about.founder.philosophy.unity.desc': 'Bringing together industries of all sizes and sectors under one umbrella for mutual benefit.',
      'about.founder.philosophy.service.title': 'Service Above Self',
      'about.founder.philosophy.service.desc': 'Prioritizing member needs and industrial development over personal or organizational gains.',
      'about.founder.philosophy.innovation.title': 'Innovation & Excellence',
      'about.founder.philosophy.innovation.desc': 'Continuously evolving to meet changing industrial needs and technological advancements.',
      'about.founder.philosophy.sustainable.title': 'Sustainable Growth',
      'about.founder.philosophy.sustainable.desc': 'Balancing economic development with environmental responsibility and social impact.',
      'about.founder.awards.title': 'Awards & Recognition',
      'about.founder.awards.2015.title': 'Industrial Excellence Award',
      'about.founder.awards.2015.org': 'Maharashtra Government, 2015',
      'about.founder.awards.2018.title': 'Lifetime Achievement Award',
      'about.founder.awards.2018.org': 'Fedration of Indian Chambers, 2018',
      'about.founder.awards.2020.title': 'Social Impact Award',
      'about.founder.awards.2020.org': 'Industrial Development Society, 2020',
      'about.founder.awards.2022.title': 'Visionary Leader Award',
      'about.founder.awards.2022.org': 'Maharashtra Industrial Association, 2022',
      'about.founder.continuing.title': 'Continuing the Legacy',
      'about.founder.continuing.growth.title': 'Member Growth',
      'about.founder.continuing.growth.desc': 'Continuing to expand our membership base while maintaining the personal touch and quality service envisioned by our founder.',
      'about.founder.continuing.innovation.title': 'Innovation',
      'about.founder.continuing.innovation.desc': 'Embracing new technologies and methodologies while staying true to the core values of collaboration and service.',
      'about.founder.continuing.impact.title': 'Social Impact',
      'about.founder.continuing.impact.desc': 'Maintaining focus on sustainable development and community welfare as envisioned in the founding principles.',
      // About - Committee
      'about.committee.title': 'Member Committee',
      'about.committee.subtitle': 'Meet the dedicated leaders and experts who guide IFM\'s mission and operations',
      'about.committee.leadership.title': 'Leadership Team',
      'about.committee.leadership.subtitle': 'Experienced professionals leading IFM\'s strategic direction and day-to-day operations',
      'about.committee.structure.title': 'Committee Structure',
      'about.committee.structure.subtitle': 'Organized committees ensuring comprehensive coverage of all aspects of industrial support',
      'about.committee.responsibilities.title': 'Committee Responsibilities',
      'about.committee.responsibilities.subtitle': 'Clear roles and responsibilities ensuring effective governance and service delivery',
      'about.committee.contact.title': 'Contact Our Committee',
      'about.committee.contact.subtitle': 'Reach out to our committee members for specific inquiries and support',
      'about.committee.contact.general.title': 'General Inquiries',
      'about.committee.contact.secretary.title': 'Committee Secretary',
      'about.committee.contact.secretary.desc': 'Committee Coordination',
      // About - Team
      'about.team.title': 'Leadership Team',
      'about.team.subtitle': 'Experienced professionals leading IFM',
      'about.team.director.name': 'Director Name',
      'about.team.director.position': 'Director',
      'about.team.director.department': 'Executive Leadership',
      'about.team.director.experience': '20+ years of industry experience',
      'about.team.director.expertise': 'Policy, Strategy, Stakeholder Engagement',
      'about.team.deputy.name': 'Deputy Director Name',
      'about.team.deputy.position': 'Deputy Director',
      'about.team.deputy.department': 'Operations',
      'about.team.deputy.experience': '15+ years of operations management',
      'about.team.deputy.expertise': 'Compliance, Training, Member Services',
      // About - Contact
      'about.contact.title': 'Contact Information',
      'about.contact.subtitle': 'Reach the right department for quick assistance',
      'about.contact.office.title': 'Head Office',
      'about.contact.office.address': 'IFM Office, 3rd Floor, Business Plaza, Bandra East, Mumbai - 400051',
      'about.contact.phone.title': 'Phone Support',
      'about.contact.phone.number': '+91-22-1234-5678',
      'about.contact.phone.hours': 'Mon-Fri: 9:00 AM - 6:00 PM | Sat-Sun: 9:00 AM - 1:00 PM',
      'about.contact.email.title': 'Email Support',
      'about.contact.email.address': 'info@ifm.gov.in',
      'about.contact.email.response': 'We usually respond within 24-48 hours',
      'services.title': 'Our Support Services',
      'services.subtitle': 'Comprehensive solutions for your industrial needs',
      'services.loading': 'Loading services...',
      'services.noServices': 'No services available',
      // Services - CTA
      'services.cta.title': 'Need Guidance Selecting a Service?',
      'services.cta.subtitle': 'Our team will recommend the right support based on your requirement.',
      'services.cta.contactTeam': 'Contact IFM Team',
      'services.cta.submitQuery': 'Submit a Query',
      // CTA Sections
      'cta.gallery.title': 'Explore More of IFM',
      'cta.gallery.subtitle': 'Discover our latest events, news, and connect with us to stay updated with IFM activities.',
      'cta.gallery.viewNews': 'View Latest News',
      'cta.gallery.contact': 'Contact Us',
      'cta.news.title': 'Stay Updated with IFM',
      'cta.news.subtitle': 'Never miss an update. Explore our events, gallery, and services to stay connected with the latest from IFM.',
      'cta.news.viewEvents': 'View Upcoming Events',
      'cta.news.visitGallery': 'Visit Gallery',
      'cta.mission.title': 'Need Guidance Selecting a Service?',
      'cta.mission.subtitle': 'Our dedicated support team is ready to help you. Reach out to us through any of the channels below for prompt assistance.',
      'cta.mission.contact': 'Contact Us',
      'cta.mission.join': 'Join IFM',
      'cta.service.title': 'Ready to Get Started?',
      'cta.service.subtitle': 'Contact our experts for personalized guidance on your environmental compliance needs.',
      'cta.service.contact': 'Contact Us',
      'cta.service.viewAll': 'View All Services',
      'cta.president.title': 'Need Guidance Selecting a Service?',
      'cta.president.subtitle': 'Our dedicated support team is ready to help you. Reach out to us through any of the channels below for prompt assistance.',
      'cta.president.contact': 'Contact Us',
      'cta.president.join': 'Join IFM',
      'cta.about.title': 'Ready to Join the Industrial Federation?',
      'cta.about.subtitle': 'Become a part of Maharashtra\'s leading industrial community and unlock exclusive benefits, expert support, and networking opportunities.',
      'cta.about.join': 'Join IFM',
      'cta.about.learnMore': 'Learn More',
      'cta.events.title': 'Want to Host an Event?',
      'cta.events.subtitle': 'Partner with IFM to organize workshops, seminars, or training programs for the industrial community.',
      'cta.events.contact': 'Contact Us',
      // Services - List items
      'service.mpcb.name': 'MPCB (Pollution Control Board)',
      'service.mpcb.shortDesc': 'Consent, renewals, waste authorization, compliance support',
      'service.dish.name': 'DISH (Industrial Safety & Health)',
      'service.dish.shortDesc': 'Factory license, safety audit, compliance documentation',
      'service.dic.name': 'DIC (District Industries Centre)',
      'service.dic.shortDesc': 'Registrations, MSME facilitation, incentives guidance',
      'service.cgwa.name': 'CGWA (Ground Water Authority)',
      'service.cgwa.shortDesc': 'Borewell permissions, renewal, compliance',
      'service.midc.name': 'MIDC (Industrial Development Corporation)',
      'service.midc.shortDesc': 'Plot allotment, utilities, approvals coordination',
      'service.mseb.name': 'MSEB / MSEDCL (Electricity)',
      'service.mseb.shortDesc': 'New connections, load increase, billing issues',
      'service.chwtsdf.fullName': 'Common Hazardous Waste Treatment, Storage & Disposal Facility (CHWTSDF) - Monopoly in Solid Waste Management',
      'service.dish.fullName': 'Directorate of Industrial Safety and Health (DISH)',
      'service.infrastructure.fullName': 'Industrial Infrastructure - MIDC, MSEB / MSEDCL',
      'service.labor.fullName': 'Labor Laws and Industrial Relations - Labor Department',
      'service.cgwa.fullName': 'Central Ground Water Authority (CGWA)',
      'service.anti-industry.fullName': 'Reconsider Anti-Industry Policies',
      'service.mpcb.fullName': 'Maharashtra Pollution Control Board (MPCB) - Environment and Pollution Control',
      'services.viewDetails': 'View Details',
      'service.labor.name': 'Labour & Compliance',
      'service.labor.shortDesc': 'Shops & Establishment, CLRA, registers and returns',
      'service.fairprice.name': 'Fair Price Shop',
      'service.fairprice.shortDesc': 'Industry canteen and essential supplies support',
      'service.hazardous.name': 'Hazardous Waste Management',
      'service.hazardous.shortDesc': 'Authorizations, manifest, transport & disposal support',
      'contact.title': 'Get In Touch',
      'contact.subtitle': 'We\'re here to help your business grow',
      'contact.info.title': 'Get in Touch',
      'contact.info.subtitle': 'Reach out to us through any of these channels',
      'contact.info.address': 'Address',
      'contact.info.address.value': 'Office no.9, A-wing, Jewel of Pimpri, Kamla Cross Road, Pimpri, Pune-411018',
      'contact.info.phone': 'Phone',
      'contact.info.phone.value1': '9067205252',
      'contact.info.phone.value2': '',
      'contact.info.email': 'Email',
      'contact.info.email.value1': 'support@mahaifm.com',
      'contact.info.email.value2': 'Info@mahaifm.com',
      'contact.info.hours': 'Business Hours',
      'contact.info.hours.monFri': 'Mon-Fri: 9:00 AM - 6:00 PM',
      'contact.info.hours.sat': 'Sat: 9:00 AM - 1:00 PM',
      'contact.info.hours.sun': 'Sun: 9:00 AM - 1:00 PM',
      // Footer
      'footer.quickLinks': 'Quick Links',
      'footer.resources': 'Resources',
      'footer.support': 'Support',
      'footer.services': 'Services',
      'footer.events': 'Events',
      'footer.news': 'News',
      'footer.membership': 'Membership',
      'footer.contactUs': 'Contact Us',
      'footer.grievance': 'Grievance',
      'footer.memberRegistration': 'Member Registration',
      'footer.renewMembership': 'Renew Membership',
      'footer.missionVision': 'Mission & Vision',
      'footer.workingHours': 'Mon-Fri: 9:00 AM - 6:00 PM | Sat-Sun: 9:00 AM - 1:00 PM',
      'footer.designedBy': 'Designed and Developed by',
      'footer.organizationName': 'Industrial Fedration of Maharashtra Region'
    }
  },
  hi: {
    name: 'हिंदी',
    isDefault: false,
    content: {
      'nav.home': 'मुख्यपृष्ठ',
      'nav.about': 'हमारे बारे में',
      'nav.support': 'सहायता',
      'nav.events': 'कार्यक्रम',
      'nav.news': 'समाचार',
      'nav.partners': 'साझेदार',
      'nav.membership': 'सदस्यता',
      'nav.gallery': 'गैलरी',
      'nav.contact': 'संपर्क',
      'nav.socialMedia': 'सोशल मीडिया',
      'nav.importantLinks': 'महत्वपूर्ण लिंक',
      // About Us submenu
      'nav.about.submenu.about': 'हमारे बारे में',
      'nav.about.submenu.president': 'अध्यक्ष प्रोफाइल',
      'nav.about.submenu.founder': 'संस्थापक',
      'nav.about.submenu.mission': 'मिशन और व्हिजन',
      'nav.about.submenu.values': 'मूल्य',
      'nav.about.submenu.structure': 'संगठनात्मक संरचना',
      'nav.about.submenu.leadershipTeam': 'संचालक मंडल',
      'nav.about.submenu.achievements': 'हमारी उपलब्धियां',
      'nav.about.submenu.committee': 'सदस्य समिति',
      // News page
      'news.title': 'समाचार और अपडेट्स',
      'news.subtitle': 'उद्योग समाचार, नियामक अपडेट और IFM घोषणाओं से अवगत रहें।',
      // News Detail page
      'news.detail.loading': 'समाचार लेख लोड हो रहा है...',
      'news.detail.notFound': 'समाचार नहीं मिला',
      'news.detail.notFoundDesc': 'आप जिस समाचार लेख की तलाश कर रहे हैं वह मौजूद नहीं है या हटा दिया गया है।',
      'news.detail.backToNews': 'समाचार पर वापस जाएं',
      'news.detail.recentNews': 'हाल के समाचार',
      'news.detail.noRecentNews': 'कोई हाल का समाचार नहीं',
      'news.detail.breakingNews': 'ताज़ा खबर',
      'news.detail.noContent': 'इस लेख के लिए कोई सामग्री उपलब्ध नहीं है।',
      'news.detail.recently': 'हाल ही में',
      // News Categories (Hindi)
      'news.category.regulatoryUpdates': 'नियामक अपडेट',
      'news.category.events': 'कार्यक्रम',
      'news.category.infrastructure': 'अवसंरचना',
      'news.category.environmental': 'पर्यावरणीय',
      'news.category.legalUpdates': 'कानूनी अपडेट',
      'news.category.industryNews': 'उद्योग समाचार',
      'news.category.policyUpdates': 'नीति अपडेट',
      'news.category.uncategorized': 'अवर्गीकृत',
      'news.filter': 'फ़िल्टर',
      'news.allCategories': 'सभी श्रेणियां',
      'news.defaultAuthor': 'IFM टीम',
      'news.searchPlaceholder': 'समाचार लेख खोजें...',
      'news.loading': 'समाचार लेख लोड हो रहे हैं...',
      'news.noNewsAvailable': 'अभी तक कोई समाचार लेख उपलब्ध नहीं है। जल्द ही वापस जांचें!',
      'news.noArticlesMatch': 'कोई लेख आपके वर्तमान फ़िल्टर से मेल नहीं खाता।',
      'news.clearFilters': 'फ़िल्टर साफ़ करें',
      'news.article': 'लेख',
      'news.articles': 'लेख',
      'news.breaking': 'ताज़ा खबर',
      // Contact & Grievance Forms
      'contact.form.contactTab': 'सामान्य पूछताछ',
      'contact.form.grievanceTab': 'शिकायत प्रस्तुत करें',
      'contact.form.title': 'संपर्क करें',
      'contact.form.subtitle': 'नीचे दिया गया फॉर्म भरें और हम जल्द से जल्द आपसे संपर्क करेंगे।',
      'contact.form.name': 'पूरा नाम',
      'contact.form.email': 'ईमेल पता',
      'contact.form.phone': 'फोन नंबर',
      'contact.form.company': 'कंपनी/संगठन',
      'contact.form.subject': 'विषय',
      'contact.form.message': 'संदेश',
      'contact.form.submit': 'संदेश भेजें',
      'contact.form.success': 'संदेश सफलतापूर्वक भेजा गया! हम जल्द ही आपसे संपर्क करेंगे।',
      'contact.form.error': 'संदेश भेजने में विफल। कृपया पुनः प्रयास करें।',
      'grievance.form.subtitle': 'अपनी चिंताओं की रिपोर्ट करें और हम उन्हें तुरंत संबोधित करेंगे।',
      'grievance.form.category': 'श्रेणी',
      'grievance.form.priority': 'प्राथमिकता',
      'grievance.form.description': 'विवरण',
      'grievance.form.urgent': 'जरूरी के रूप में चिह्नित करें',
      'grievance.form.submit': 'शिकायत प्रस्तुत करें',
      'grievance.form.success': 'शिकायत सफलतापूर्वक प्रस्तुत की गई! हम इसे जल्द ही संबोधित करेंगे।',
      'grievance.form.error': 'शिकायत प्रस्तुत करने में विफल। कृपया पुनः प्रयास करें।',
      // Grievance Page Tabs
      'grievance.tab.submit': 'शिकायत प्रस्तुत करें',
      'grievance.tab.track': 'शिकायत ट्रैक करें',
      'grievance.tab.faq': 'FAQ और सहायता',
      'grievance.form.title': 'नई शिकायत प्रस्तुत करें',
      'grievance.form.name': 'पूरा नाम',
      'grievance.form.email': 'ईमेल पता',
      'grievance.form.phone': 'फोन नंबर',
      'grievance.form.company': 'कंपनी / संगठन',
      'grievance.form.subjectLabel': 'शिकायत विषय',
      'grievance.form.descriptionLabel': 'विस्तृत शिकायत विवरण',
      'grievance.form.descriptionPlaceholder': 'कृपया अपनी शिकायत का विस्तार से वर्णन करें। प्रासंगिक तारीखें, स्थान, विभाग और कोई सहायक जानकारी शामिल करें...',
      'grievance.form.urgentLabel': 'जरूरी के रूप में चिह्नित करें (तत्काल ध्यान देने की आवश्यकता)',
      // Grievance Categories (Hindi)
      'grievance.category.general': 'सामान्य',
      'grievance.category.labour': 'श्रम',
      'grievance.category.environmental': 'पर्यावरणीय',
      'grievance.category.infrastructure': 'अवसंरचना',
      'grievance.category.compliance': 'अनुपालन',
      'grievance.category.technical': 'तकनीकी',
      'grievance.category.safety': 'सुरक्षा',
      'grievance.category.pollution': 'प्रदूषण',
      'grievance.category.land': 'भूमि',
      'grievance.category.electricity': 'बिजली',
      'grievance.category.water': 'पानी',
      'grievance.category.roads': 'सड़कें',
      'grievance.category.waste': 'अपशिष्ट',
      'grievance.category.pricing': 'मूल्य निर्धारण',
      'grievance.category.other': 'अन्य',
      // Grievance Priorities (Hindi)
      'grievance.priority.low': 'कम',
      'grievance.priority.medium': 'मध्यम',
      'grievance.priority.high': 'उच्च',
      'grievance.priority.urgent': 'जरूरी',
      'grievance.priority.critical': 'गंभीर',
      'grievance.track.title': 'आपकी शिकायतें',
      'grievance.track.allCategories': 'सभी श्रेणियां',
      'grievance.track.noGrievances': 'कोई शिकायत नहीं मिली',
      'grievance.track.noGrievancesDesc': 'शुरू करने के लिए अपनी पहली शिकायत प्रस्तुत करें।',
      'grievance.track.submittedOn': 'प्रस्तुत की गई',
      'grievance.track.viewDetails': 'विवरण देखें',
      'grievance.faq.title': 'अक्सर पूछे जाने वाले प्रश्न',
      'grievance.faq.q1': 'शिकायत का समाधान करने में कितना समय लगता है?',
      'grievance.faq.a1': 'समाधान समय आपके मुद्दे की जटिलता और प्राथमिकता पर निर्भर करता है। महत्वपूर्ण मुद्दों को आमतौर पर 24-48 घंटों के भीतर संबोधित किया जाता है, जबकि मानक मुद्दों में 5-7 कार्य दिवस लग सकते हैं।',
      'grievance.faq.q2': 'क्या मैं अपनी शिकायत की प्रगति को ट्रैक कर सकता हूं?',
      'grievance.faq.a2': 'हां, आप प्रस्तुत करते समय प्रदान किए गए टिकट नंबर का उपयोग करके अपनी शिकायत की प्रगति को ट्रैक कर सकते हैं। आपको ईमेल के माध्यम से नियमित अपडेट भी मिलेंगे।',
      'grievance.faq.q3': 'मुझे अपनी शिकायत में कौन सी जानकारी शामिल करनी चाहिए?',
      'grievance.faq.a3': 'मुद्दे के बारे में विशिष्ट विवरण, प्रासंगिक तारीखें, कोई दस्तावेज या साक्ष्य, और आपकी संपर्क जानकारी शामिल करें। आपका विवरण जितना अधिक विस्तृत होगा, हम उतनी ही तेजी से आपकी सहायता कर सकेंगे।',
      'grievance.faq.q4': 'मुझे कैसे पता चलेगा कि मेरी शिकायत का समाधान हो गया है?',
      'grievance.faq.a4': 'आपको ईमेल के माध्यम से एक समाधान सूचना मिलेगी, और स्थिति आपके शिकायत ट्रैकिंग में अपडेट हो जाएगी। अपडेट के लिए आप हमारी सहायता टीम से भी संपर्क कर सकते हैं।',
      'grievance.cta.title': 'तत्काल सहायता चाहिए?',
      'grievance.cta.subtitle': 'जरूरी मामलों के लिए, हमारी 24/7 हेल्पलाइन से संपर्क करें या सीधे हमारी सहायता टीम से संपर्क करें।',
      'grievance.cta.callHelpline': 'हेल्पलाइन पर कॉल करें',
      'grievance.cta.contactSupport': 'सहायता से संपर्क करें',
      // Contact Page CTA
      'contact.cta.title': 'तत्काल सहायता चाहिए?',
      'contact.cta.subtitle': 'हमारी समर्पित सहायता टीम आपकी मदद के लिए तैयार है। त्वरित सहायता के लिए नीचे दिए गए किसी भी चैनल के माध्यम से हमसे संपर्क करें।',
      'contact.cta.callSupport': 'सहायता पर कॉल करें',
      'contact.cta.sendEmail': 'ईमेल भेजें',
      // Admin Panel - Sidebar
      'admin.sidebar.dashboard': 'डैशबोर्ड',
      'admin.sidebar.news': 'समाचार',
      'admin.sidebar.events': 'कार्यक्रम',
      'admin.sidebar.eventRegistrations': 'कार्यक्रम पंजीकरण',
      'admin.sidebar.members': 'सदस्य',
      'admin.sidebar.membershipPlans': 'सदस्यता योजनाएं',
      'admin.sidebar.gallery': 'गैलरी',
      'admin.sidebar.payments': 'भुगतान',
      'admin.sidebar.contactEnquiries': 'संपर्क पूछताछ',
      'admin.sidebar.grievances': 'शिकायतें',
      'admin.sidebar.activityLogs': 'गतिविधि लॉग',
      'admin.sidebar.logout': 'लॉगआउट',
      'admin.sidebar.language': 'भाषा',
      'admin.sidebar.selectLanguage': 'भाषा चुनें',
      // Renewal Page
      'renewal.title': 'अपनी सदस्यता नवीनीकृत करें',
      'renewal.subtitle': 'अपनी सदस्यता योजना खोजने और नवीनीकृत करने के लिए अपना ग्राहक ID या ईमेल दर्ज करें',
      'renewal.searchLabel': 'ग्राहक ID या ईमेल',
      'renewal.searchPlaceholder': 'अपनी योजना खोजने के लिए ग्राहक ID या ईमेल दर्ज करें',
      'renewal.search': 'खोजें',
      'renewal.searching': 'खोज रहे हैं...',
      'renewal.memberDetails': 'सदस्य विवरण',
      'renewal.memberName': 'सदस्य का नाम',
      'renewal.organization': 'संगठन',
      'renewal.email': 'ईमेल',
      'renewal.mobile': 'मोबाइल',
      'renewal.memberId': 'सदस्य ID',
      'renewal.currentPlan': 'वर्तमान योजना',
      'renewal.expiryDate': 'सदस्यता समाप्ति तिथि',
      'renewal.daysRemaining': 'दिन शेष',
      'renewal.expired': 'समाप्त',
      'renewal.processing': 'प्रसंस्करण...',
      'renewal.renewButton': 'सदस्यता नवीनीकृत करें',
      'renewal.viewPlans': 'योजनाएं देखें',
      'renewal.pendingApproval': 'आपकी सदस्यता अनुमोदन के लिए लंबित है। कृपया सहायता के लिए समर्थन से संपर्क करें।',
      'renewal.needHelp': 'मदद चाहिए?',
      'renewal.helpText': 'यदि आप अपनी सदस्यता नहीं ढूंढ सकते हैं या नवीनीकरण के साथ सहायता की आवश्यकता है, तो कृपया हमारी सहायता टीम से संपर्क करें।',
      'renewal.contactSupport': 'समर्थन से संपर्क करें',
      'renewal.callUs': 'हमें कॉल करें',
      'renewal.searchError': 'कृपया अपना ग्राहक ID या ईमेल दर्ज करें',
      'renewal.notFound': 'सदस्य नहीं मिला। कृपया अपना ग्राहक ID या ईमेल जांचें।',
      'renewal.cta.title': 'IFM में नए हैं?',
      'renewal.cta.subtitle': 'Industrial Fedration of Maharashtra Region में शामिल हों और विशेष लाभ, विशेषज्ञ सहायता और नेटवर्किंग अवसरों का लाभ उठाएं।',
      'renewal.cta.register': 'नए सदस्य का पंजीकरण',
      'renewal.cta.viewPlans': 'सदस्यता योजनाएं देखें',
      'renewal.confirmTitle': 'नवीनीकरण की पुष्टि करें',
      'renewal.confirmMessage': 'क्या आप वाकई अपनी सदस्यता नवीनीकृत करना चाहते हैं? आपको भुगतान के लिए पुनर्निर्देशित किया जाएगा।',
      'renewal.confirm': 'हाँ, नवीनीकृत करें',
      'renewal.cancel': 'रद्द करें',
      'renewal.renewalSuccess': 'सदस्यता नवीनीकरण सफलतापूर्वक शुरू किया गया! भुगतान पर पुनर्निर्देशित कर रहे हैं...',
      'renewal.renewalError': 'सदस्यता नवीनीकरण विफल। कृपया पुनः प्रयास करें।',
      // Registration Form
      'registration.title': 'सदस्य पंजीकरण',
      'registration.subtitle': 'कृपया अपनी सदस्यता पंजीकरण पूरा करने के लिए सभी आवश्यक फ़ील्ड भरें।',
      'registration.personalDetails': 'व्यक्तिगत विवरण',
      'registration.membershipInfo': 'सदस्यता जानकारी',
      'registration.mobile': 'व्हाट्सएप / मोबाइल नंबर',
      'registration.email': 'ईमेल पता',
      'registration.emailPlaceholder': 'ईमेल पता दर्ज करें',
      'registration.applicantName': 'आवेदक का नाम (श्री./श्रीमती/M/s.)',
      'registration.organizationName': 'संगठन का नाम',
      'registration.representativeName': 'प्रतिनिधि का नाम',
      'registration.gender': 'लिंग',
      'registration.gender.male': 'पुरुष',
      'registration.gender.female': 'महिला',
      'registration.telephone': 'टेलीफोन',
      'registration.aadhar': 'आधार नंबर',
      'registration.pancard': 'पैन कार्ड',
      'registration.address': 'पता',
      'registration.state': 'राज्य',
      'registration.district': 'जिला',
      'registration.city': 'शहर',
      'registration.pincode': 'पिनकोड',
      'registration.website': 'वेबसाइट',
      'registration.gst': 'जीएसटी नंबर',
      'registration.region': 'क्षेत्र',
      'registration.memberDescription': 'सदस्य विवरण',
      'registration.category': 'श्रेणी',
      'registration.natureOfBusiness': 'व्यवसाय की प्रकृति',
      'registration.industry': 'उद्योग',
      'registration.industryPlaceholder': 'उद्योग दर्ज करें',
      'registration.workerCount': 'कर्मचारियों की संख्या',
      'registration.membershipType': 'सदस्यता प्रकार',
      'registration.startDate': 'प्रारंभ तिथि',
      'registration.endDate': 'समाप्ति तिथि',
      'registration.selectPlan': 'सदस्यता योजना चुनें',
      'registration.submit': 'पंजीकरण प्रस्तुत करें',
      'registration.submitting': 'प्रस्तुत कर रहे हैं...',
      'registration.success': 'पंजीकरण सफलतापूर्वक प्रस्तुत किया गया!',
      'registration.error': 'पंजीकरण प्रस्तुत करने में विफल। कृपया पुनः प्रयास करें।',
      'registration.cta.title': 'पहले से सदस्य हैं?',
      'registration.cta.subtitle': 'सभी IFM लाभों और सेवाओं का लाभ उठाना जारी रखने के लिए अपनी मौजूदा सदस्यता नवीनीकृत करें।',
      'registration.cta.renew': 'सदस्यता नवीनीकृत करें',
      'registration.cta.viewPlans': 'सदस्यता योजनाएं देखें',
      'registration.required': 'यह फ़ील्ड आवश्यक है',
      'registration.invalidMobile': 'कृपया एक वैध 10-अंकीय मोबाइल नंबर दर्ज करें',
      'registration.invalidEmail': 'कृपया एक वैध ईमेल पता दर्ज करें',
      'registration.invalidPincode': 'कृपया एक वैध 6-अंकीय पिनकोड दर्ज करें',
      'registration.invalidAadhar': 'कृपया एक वैध 12-अंकीय आधार नंबर दर्ज करें',
      'registration.invalidPAN': 'कृपया एक वैध पैन कार्ड नंबर दर्ज करें',
      'registration.selectPlanError': 'कृपया एक सदस्यता योजना चुनें',
      'registration.processing': 'पंजीकरण प्रसंस्करण...',
      'registration.redirecting': 'भुगतान पर पुनर्निर्देशित कर रहे हैं...',
      'registration.submitButton': 'पंजीकरण करें और भुगतान के लिए आगे बढ़ें',
      'registration.termsPrefix': 'यह फॉर्म सबमिट करके, आप हमारी',
      'registration.termsAnd': 'और',
      'registration.securePayment': 'सुरक्षित भुगतान',
      'registration.dataProtected': 'डेटा सुरक्षित है',
      'registration.instantConfirmation': 'तत्काल पुष्टि',
      // Gallery page
      'gallery.title': 'मीडिया गैलरी',
      'gallery.subtitle': 'हमारे कार्यक्रमों, कार्यशालाओं और औद्योगिक गतिविधियों की फोटो और वीडियो देखें।',
      // Gallery (Hindi)
      'gallery.tab.photos': 'फोटो गैलरी',
      'gallery.tab.videos': 'वीडियो गैलरी',
      'gallery.photo.defaultTitle': 'फोटो',
      'gallery.photo.untitled': 'अनाम फोटो',
      'gallery.photo.noDescription': 'कोई विवरण नहीं',
      'gallery.video.defaultTitle': 'वीडियो थंबनेल',
      'gallery.video.untitled': 'अनाम वीडियो',
      'gallery.video.noDescription': 'कोई विवरण नहीं',
      'gallery.category.uncategorized': 'अवर्गीकृत',
      'gallery.aria.closeImage': 'छवि बंद करें',
      'gallery.aria.nextImage': 'अगली छवि',
      'gallery.aria.closeVideo': 'वीडियो बंद करें',
      'gallery.noPhotos': 'कोई फोटो उपलब्ध नहीं',
      'gallery.noPhotosDesc': 'एडमिनिस्ट्रेटर द्वारा अपलोड किए जाने के बाद फोटो यहां दिखाई देंगी।',
      'gallery.noVideos': 'कोई वीडियो उपलब्ध नहीं',
      'gallery.noVideosDesc': 'एडमिनिस्ट्रेटर द्वारा अपलोड किए जाने के बाद वीडियो यहां दिखाई देंगे।',
      // Events
      'events.title': 'कार्यक्रम और प्रोग्राम',
      'events.subtitle': 'हमारी नवीनतम कार्यशालाओं, सेमिनार, प्रशिक्षण कार्यक्रमों और उद्योग कार्यक्रमों से अपडेट रहें।',
      'events.searchPlaceholder': 'कार्यक्रम खोजें...',
      'events.allCategories': 'सभी श्रेणियां',
      'events.loading': 'कार्यक्रम लोड हो रहे हैं...',
      'events.noEventsFound': 'कोई कार्यक्रम नहीं मिला',
      'events.tryAdjusting': 'कृपया अपनी खोज या फ़िल्टर मानदंड समायोजित करने का प्रयास करें।',
      'events.viewDetails': 'विवरण देखें',
      'events.recentEvents': 'हाल के कार्यक्रम',
      'events.noRecentEvents': 'कोई हाल का कार्यक्रम नहीं',
      'events.free': 'मुफ्त',
      'events.status.upcoming': 'आगामी',
      'events.status.ongoing': 'चल रहा है',
      'events.status.completed': 'पूर्ण',
      'events.dateTBD': 'तारीख निर्धारित नहीं',
      'events.locationTBD': 'स्थान निर्धारित नहीं',
      // Event Detail
      'events.detail.backToEvents': 'कार्यक्रम पर वापस जाएं',
      'events.detail.notFound': 'कार्यक्रम नहीं मिला',
      'events.detail.notFoundDesc': 'आप जिस कार्यक्रम की तलाश कर रहे हैं वह मौजूद नहीं है या हटा दिया गया है।',
      'events.detail.loading': 'कार्यक्रम विवरण लोड हो रहे हैं...',
      'events.detail.registration': 'कार्यक्रम पंजीकरण',
      'events.detail.registrationClosed': 'पंजीकरण बंद',
      'events.detail.registrationClosedDesc': 'यह कार्यक्रम पहले ही समाप्त हो चुका है।',
      'events.detail.registrationNotAvailable': 'पंजीकरण उपलब्ध नहीं',
      'events.detail.registrationNotAvailableDesc': 'यह कार्यक्रम वर्तमान में पंजीकरण के लिए खुला नहीं है।',
      'events.detail.eventFull': 'कार्यक्रम भरा हुआ',
      'events.detail.eventFullDesc': 'अधिकतम प्रतिभागी पहुंच गए',
      'events.detail.registrationFee': 'पंजीकरण शुल्क',
      'events.detail.freeEvent': 'मुफ्त कार्यक्रम',
      'events.detail.registerNow': 'अभी पंजीकरण करें',
      'events.detail.eventInformation': 'कार्यक्रम जानकारी',
      'events.detail.capacity': 'क्षमता',
      'events.detail.participants': 'प्रतिभागी',
      'events.detail.fee': 'शुल्क',
      'events.detail.registrationRequired': 'पंजीकरण',
      'events.detail.required': 'आवश्यक',
      'events.detail.otherEvents': 'अन्य कार्यक्रम',
      // Event Registration (Hindi)
      'eventRegistration.mobileRequired': 'मोबाइल नंबर आवश्यक है',
      'eventRegistration.mobileInvalid': 'कृपया एक वैध 10-अंकीय मोबाइल नंबर दर्ज करें',
      'eventRegistration.emailRequired': 'ईमेल आवश्यक है',
      'eventRegistration.emailInvalid': 'कृपया एक वैध ईमेल पता दर्ज करें',
      'eventRegistration.nameRequired': 'प्रतिभागी का नाम आवश्यक है',
      'eventRegistration.nameMinLength': 'प्रतिभागी का नाम कम से कम 2 वर्ण का होना चाहिए',
      'eventRegistration.pincodeInvalid': 'कृपया एक वैध 6-अंकीय पिनकोड दर्ज करें',
      'eventRegistration.namePlaceholder': 'अपना पूरा नाम दर्ज करें',
      'eventRegistration.emailPlaceholder': 'अपना ईमेल पता दर्ज करें',
      'eventRegistration.designationPlaceholder': 'अपना पदनाम दर्ज करें (वैकल्पिक)',
      'eventRegistration.addressPlaceholder': 'अपना पता दर्ज करें (वैकल्पिक)',
      'eventRegistration.registerAndPay': 'पंजीकरण करें और भुगतान के लिए आगे बढ़ें',
      'eventRegistration.completeRegistration': 'पंजीकरण पूरा करें',
      'eventRegistration.dismissError': 'त्रुटि खारिज करें',
      'eventRegistration.redirectingToPayment': 'भुगतान पर पुनर्निर्देशित कर रहे हैं...',
      'eventRegistration.redirectingToPaymentGateway': 'भुगतान गेटवे पर पुनर्निर्देशित कर रहे हैं',
      'eventRegistration.addressDetails': 'पता विवरण',
      'eventRegistration.pleaseWaitRedirect': 'कृपया प्रतीक्षा करें जब तक हम आपको भुगतान पूरा करने के लिए पुनर्निर्देशित करते हैं...',
      // Policies (Hindi)
      'policies.title': 'नीतियां और दिशानिर्देश',
      'policies.subtitle': 'औद्योगिक अनुपालन और सर्वोत्तम प्रथाओं के लिए व्यापक नीतियां, दिशानिर्देश और नियामक दस्तावेजों तक पहुंच।',
      'policies.searchPlaceholder': 'नीतियां खोजें...',
      'policies.allCategories': 'सभी श्रेणियां',
      'policies.category.membership': 'सदस्यता',
      'policies.category.environmental': 'पर्यावरणीय',
      'policies.category.safety': 'सुरक्षा',
      'policies.category.labor': 'श्रम',
      'policies.category.infrastructure': 'अवसंरचना',
      // Event Categories (Hindi)
      'events.category.workshop': 'कार्यशाला',
      'events.category.seminar': 'सेमिनार',
      'events.category.training': 'प्रशिक्षण',
      'events.category.meeting': 'बैठक',
      'events.category.conference': 'सम्मेलन',
      'events.category.webinar': 'वेबिनार',
      'events.category.exhibition': 'प्रदर्शनी',
      'events.category.general': 'सामान्य',
      'events.filter': 'फ़िल्टर',
      'events.detail.registered': 'पंजीकृत',
      // Membership (UI text)
      'membership.title': 'सदस्यता',
      'membership.subtitle': 'IFM से जुड़ें और सहायता, संसाधन व नेटवर्किंग का लाभ लें।',
      'membership.benefits.title': 'सदस्य लाभ',
      'membership.benefits.subtitle': 'महाराष्ट्र के उद्योगों के लिए विशेष रूप से तैयार लाभ',
      'membership.benefits.regulatory.title': 'नियामक सहायता',
      'membership.benefits.regulatory.desc': 'अनुपालन, फाइलिंग, निरीक्षण और अनुमोदनों में मार्गदर्शन',
      'membership.benefits.infrastructure.title': 'इन्फ्रास्ट्रक्चर सुविधा',
      'membership.benefits.infrastructure.desc': 'यूटिलिटीज, भूमि, अनुमतियाँ और समन्वय में मदद',
      'membership.benefits.networking.title': 'नेटवर्किंग',
      'membership.benefits.networking.desc': 'साथी उद्योगों, विशेषज्ञों और अधिकारियों से जुड़ें',
      'membership.benefits.documentation.title': 'डॉक्युमेंटेशन',
      'membership.benefits.documentation.desc': 'टेम्पलेट, चेकलिस्ट और कागज़ात में सहायता',
      'membership.benefits.training.title': 'प्रशिक्षण व कार्यशालाएँ',
      'membership.benefits.training.desc': 'कौशल व जागरूकता के लिए नियमित कार्यक्रम',
      'membership.benefits.support.title': 'समर्पित सहायता',
      'membership.benefits.support.desc': 'प्राथमिकता प्रतिक्रिया और केस फॉलो-अप',
      'membership.whyChoose.title': 'IFM सदस्यता क्यों चुनें?',
      'membership.whyChoose.network.title': 'उद्योग नेटवर्क',
      'membership.whyChoose.network.desc': 'साथियों और विशेषज्ञों से जुड़ें',
      'membership.whyChoose.regulatory.title': 'नियामक सहायता',
      'membership.whyChoose.regulatory.desc': 'अनुपालन पर विशेषज्ञ मार्गदर्शन',
      'membership.whyChoose.infrastructure.title': 'अवसंरचना सहायता',
      'membership.whyChoose.infrastructure.desc': 'उपयोगिताओं और अनुमतियों में सहायता',
      'membership.whyChoose.documentation.title': 'दस्तावेज़ीकरण',
      'membership.whyChoose.documentation.desc': 'टेम्प्लेट और चेकलिस्ट',
      'membership.benefits.core.title': 'मुख्य लाभ',
      // Detailed IFM Membership Benefits (Hindi mirror kept concise)
      'membership.benefits.long.title': 'विस्तृत सदस्य लाभ',
      'membership.benefits.long.items': [
        'IFM सदस्यता आपको व्यापक व्यवसाय नेटवर्क से जोड़ती है और स्थानीय बाज़ार रुझानों से अपडेट रखती है।',
        'व्यवसाय सृजन: व्यापार, कॉमर्स और एग्रो समुदाय के लिए B2B अवसर और नेटवर्किंग।',
        'निर्यातकों हेतु उत्पत्ति प्रमाणपत्र मार्गदर्शन (FTAs/कस्टम हेतु आवश्यक)।',
        'कानूनी दस्तावेज़ों का एटेस्टेशन (POA, करार, अनुवाद, वीज़ा पत्र, आदि)।',
        'मासिक पत्रिका/न्यूज़लेटर: नीति अपडेट, लेख, कार्यक्रम व उपलब्धियाँ।',
        'कार्यक्रम व नेटवर्किंग: B2B, पुरस्कार, राउंडटेबल, एक्सपो इत्यादि।',
        'अंतरराष्ट्रीय व्यापार प्रोत्साहन और प्रतिनिधिमंडल।',
        'सरकारी निकायों तक प्रतिनिधित्व और नामांकन।',
        'वेब सेवाएँ: पंजीकरण, सर्कुलर, प्रेस, प्रकाशन, कानूनी अपडेट, फॉर्म।',
        'दृश्यता में वृद्धि: डायरेक्टरी लिस्टिंग व ई-न्यूज़लेटर।',
        'वीज़ा अनुशंसा पत्र।',
        'प्रशिक्षण: एक्सिम, उद्यमिता, स्टार्टअप, टैक्स, वित्त, कौशल विकास।',
        'साप्ताहिक आर्थिक अपडेट।',
        'SMS अलर्ट: टैक्स/जीएसटी, अनुपालन, कार्यक्रम, अवसर।',
        'ट्रेड/बिजनेस डेलीगेशन, सम्मेलन, सेमिनार, वर्कशॉप।',
        'विशेषज्ञ समितियों तक पहुँच और नीति वकालत।',
        'IFM हॉल बुकिंग रियायती दरों पर।',
        'सदस्य डायरेक्टरी तक पहुँच।'
      ],
      'membership.plans.title': 'सदस्यता योजनाएँ',
      'membership.plans.subtitle': 'अपने संस्थान के अनुसार उपयुक्त योजना चुनें',
      'membership.eligibility.title': 'पात्रता',
      'membership.eligibility.subtitle': 'कौन IFM सदस्यता के लिए आवेदन कर सकता है',
      'membership.eligibility.item1': 'पंजीकृत औद्योगिक इकाई या MSME',
      'membership.eligibility.item2': 'वैध व्यवसाय व पहचान दस्तावेज',
      'membership.eligibility.item3': 'लागू कानूनों का अनुपालन',
      'membership.eligibility.item4': 'IFM आचार संहिता की स्वीकृति',
      'membership.eligibility.item5': 'सदस्यता शुल्क का समय पर भुगतान',
      'membership.eligibility.item6': 'डेटा व संचार नीतियों से सहमति',
      'membership.requirements.title': 'दस्तावेज़ आवश्यकताएँ',
      'membership.requirements.item1': 'उद्यम / MSME पंजीकरण (यदि लागू)',
      'membership.requirements.item2': 'GST पंजीकरण प्रमाणपत्र',
      'membership.requirements.item3': 'PAN कार्ड (कंपनी/स्वामी)',
      'membership.requirements.item4': 'स्थापना का पता प्रमाण',
      'membership.requirements.item5': 'अधिकृत हस्ताक्षरकर्ता का पहचान प्रमाण',
      'membership.requirements.item6': 'कंपनी लेटरहेड व स्टाम्प',
      'membership.requirements.item7': 'दो हालिया फोटोग्राफ',
      'membership.requirements.item8': 'कोई विशेष लाइसेंस (जैसा लागू हो)',
      'membership.cta.register': 'पंजीकरण',
      'membership.cta.title': 'IFM सदस्य बनें',
      'membership.cta.subtitle': 'विशेषज्ञ मार्गदर्शन, प्रतिनिधित्व और विकास अवसरों तक पहुँच',
      'membership.comparison.title': 'योजना तुलना',
      'membership.comparison.subtitle': 'अपनी आवश्यकताओं के लिए सर्वोत्तम फिट खोजने के लिए सभी सदस्यता योजनाओं की तुलना करें',
      'membership.comparison.tab': 'तुलना तालिका',
      'membership.comparison.loading': 'तुलना डेटा लोड हो रहा है...',
      'membership.comparison.noPlans': 'तुलना के लिए कोई योजना उपलब्ध नहीं है।',
      'membership.comparison.featuresPlan': 'सुविधाएं / योजना',
      'membership.comparison.price': 'मूल्य (प्रति वर्ष)',
      'membership.comparison.unitsCovered': 'इकाइयां कवर',
      'membership.comparison.issueResolution': 'समस्या समाधान सहायता',
      'membership.comparison.govtCoordination': 'सरकारी विभाग समन्वय',
      'membership.comparison.consultations': 'परामर्श',
      'membership.comparison.complianceAudit': 'अनुपालन ऑडिट',
      'membership.comparison.cgwaDish': 'CGWA/DISH दस्तावेज़ीकरण',
      'membership.comparison.infrastructure': 'अवसंरचना एस्केलेशन',
      'membership.comparison.workshops': 'कार्यशालाएं / कार्यक्रम',
      'membership.comparison.networking': 'नेटवर्किंग',
      'membership.comparison.branding': 'ब्रांडिंग / लोगो प्रदर्शन',
      'membership.comparison.responseTime': 'प्रतिक्रिया समय',
      'membership.comparison.choosePlan': '{tier} योजना चुनें',
      'membership.comparison.notAvailable': 'उपलब्ध नहीं',
      'membership.comparison.yes': 'हाँ',
      'membership.comparison.no': 'नहीं',
      // Membership Plans specific
      'membership.plans.loading': 'सदस्यता योजनाएँ लोड हो रही हैं...',
      'membership.plans.noPlans': 'इस समय कोई सदस्यता योजना उपलब्ध नहीं है।',
      'membership.plans.noPlansDesc': 'कृपया बाद में पुनः जांचें या अधिक जानकारी के लिए हमसे संपर्क करें।',
      'membership.plans.popular': 'लोकप्रिय',
      'membership.plans.plan': 'योजना',
      'membership.plans.units': 'इकाइयां',
      'membership.plans.per': 'प्रति',
      'membership.plans.months': 'महीने',
      'membership.plans.response': 'प्रतिक्रिया:',
      'membership.plans.keyBenefits': 'मुख्य लाभ',
      'membership.plans.showLess': 'कम दिखाएं',
      'membership.plans.viewAllBenefits': 'सभी {count} लाभ देखें',
      'membership.plans.noBenefits': 'कोई लाभ सूचीबद्ध नहीं',
      'membership.plans.support': 'सहायता',
      'membership.plans.consultations': 'परामर्श',
      'membership.plans.choosePlan': '{tier} योजना चुनें',
      'membership.benefits.long.subtitle': 'सभी IFM सदस्यों के लिए उपलब्ध व्यापक लाभ और सेवाएं',
      // Membership Registration/Renewal/Help/Join
      'membership.registration.new.title': 'नए सदस्य का पंजीकरण',
      'membership.registration.new.desc': 'पहली बार IFM से जुड़ रहे हैं? सदस्य बनने के लिए पंजीकरण प्रक्रिया पूरी करें।',
      'membership.registration.new.cta': 'पंजीकरण शुरू करें',
      'membership.renewal.title': 'सदस्यता नवीनीकरण',
      'membership.renewal.desc': 'क्या आप मौजूदा सदस्य हैं? हमारी सेवाओं का लाभ जारी रखने के लिए सदस्यता नवीनीकृत करें।',
      'membership.renewal.cta': 'सदस्यता नवीनीकृत करें',
      'membership.help.title': 'मदद चाहिए?',
      'membership.help.desc': 'पंजीकरण प्रक्रिया में हमारी टीम आपकी सहायता के लिए उपलब्ध है।',
      'membership.help.call': 'कॉल करें',
      'membership.help.email': 'ईमेल करें',
      'membership.join.title': 'IFM से जुड़ने के लिए तैयार?',
      'membership.join.desc': 'आज ही सदस्य बनें और व्यापक औद्योगिक सहायता सेवाओं का लाभ उठाएँ।',
      'membership.join.registerNow': 'अभी पंजीकरण करें',
      // Membership Calculator
      'membership.calculator.title': 'अपनी सदस्यता शुल्क की गणना करें',
      'membership.calculator.workerCount': 'श्रमिकों की संख्या',
      'membership.calculator.workerCountPlaceholder': 'श्रमिक संख्या दर्ज करें',
      'membership.calculator.calculate': 'गणना करें',
      'membership.calculator.fee': 'सदस्यता शुल्क',
      'membership.calculator.category': 'श्रेणी:',
      'membership.calculator.baseFee': 'आधार शुल्क',
      'membership.calculator.additional': 'अतिरिक्त',
      'membership.calculator.total': 'कुल:',
      'membership.calculator.member': 'सदस्य',
      'membership.calculator.members': 'सदस्य',
      'membership.calculator.pricingStructure': 'मूल्य निर्धारण संरचना:',
      'membership.calculator.smallIndustries': 'छोटे उद्योग',
      'membership.calculator.mediumLargeIndustries': 'मध्यम/बड़े उद्योग',
      'membership.calculator.workers': 'श्रमिक',
      'membership.calculator.oneTime': 'एक बार',
      'membership.calculator.base': 'आधार',
      'membership.calculator.perAdditionalWorker': 'प्रति अतिरिक्त श्रमिक',
      'membership.calculator.error.workerCount': 'कृपया एक वैध श्रमिक संख्या दर्ज करें (कम से कम 1)',
      'membership.calculator.error.calculation': 'शुल्क की गणना करने में विफल। कृपया पुनः प्रयास करें।',
      // Membership Plan Details
      'membership.plan.unified': 'स्टीवर्डशिप  सदस्यता योजना',
      'membership.plan.notAvailable': 'स्टीवर्डशिप  सदस्यता योजना उपलब्ध नहीं है',
      'membership.plan.contactAdmin': 'कृपया प्रशासक से संपर्क करें',
      'membership.plan.duration': 'अवधि',
      'membership.plan.trainingProgram': 'प्रशिक्षण कार्यक्रम',
      'membership.plan.trainingProgram.weekProgram': '-सप्ताह का कार्यक्रम शामिल',
      'membership.plan.trainingProgram.notAvailable': 'उपलब्ध नहीं',
      'membership.plan.trainingProgram.title': '52-सप्ताह श्रमिक प्रशिक्षण कार्यक्रम',
      'membership.plan.trainingProgram.description': 'एक मूल्य-वर्धित लाभ के रूप में, Industrial Fedration सदस्य उद्योगों के श्रमिकों के लिए पूरे वर्ष (52 सप्ताह) निरंतर ऑनलाइन और ऑफलाइन कार्यशालाएं और प्रशिक्षण कार्यक्रम आयोजित करती है।',
      'membership.plan.trainingProgram.areas': 'प्रशिक्षण क्षेत्र:',
      'membership.plan.trainingProgram.outcomes': 'प्रशिक्षण परिणाम:',
      'membership.plan.keyBenefits': 'मुख्य लाभ',
      // Events
      'events.participants': 'प्रतिभागी',
      // Gallery
      'gallery.video.unsupported': 'असमर्थित वीडियो URL',
      'gallery.aria.previousImage': 'पिछली छवि',
      // Navigation - Mobile
      'nav.mobile.followUs': 'हमें फॉलो करें:',
      'nav.mobile.language': 'भाषा / Language',
      // Video
      'video.browserNotSupported': 'आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता है।',
      // Carousel
      'carousel.previous': 'पिछली सुविधा',
      'carousel.next': 'अगली सुविधा',
      'carousel.goToSlide': 'स्लाइड पर जाएं',
      // Dashboard (Hindi)
      'dashboard.title': 'डैशबोर्ड',
      'dashboard.welcome': 'वापस स्वागत है! IFM के साथ क्या हो रहा है यहाँ देखें।',
      'dashboard.totalMembers': 'कुल सदस्य',
      'dashboard.activeServices': 'सक्रिय सेवाएं',
      'dashboard.upcomingEvents': 'आगामी कार्यक्रम',
      'dashboard.openGrievances': 'खुले शिकायतें',
      'dashboard.fromLastMonth': 'पिछले महीने से',
      'dashboard.quickActions': 'त्वरित कार्य',
      'dashboard.recentActivities': 'हाल की गतिविधियां',
      'dashboard.submitGrievance': 'शिकायत दर्ज करें',
      'dashboard.submitGrievanceDesc': 'एक मुद्दा या चिंता रिपोर्ट करें',
      'dashboard.registerForEvent': 'कार्यक्रम के लिए पंजीकरण करें',
      'dashboard.registerForEventDesc': 'आगामी कार्यशालाओं में शामिल हों',
      'dashboard.downloadPolicy': 'नीति डाउनलोड करें',
      'dashboard.downloadPolicyDesc': 'नवीनतम दिशानिर्देशों तक पहुंचें',
      'dashboard.contactSupport': 'समर्थन से संपर्क करें',
      'dashboard.contactSupportDesc': 'हमारी टीम से मदद लें',
      'dashboard.upcomingEventsTitle': 'आगामी कार्यक्रम',
      'dashboard.systemStatus': 'सिस्टम स्थिति',
      'dashboard.operational': 'संचालन',
      'dashboard.apiServices': 'API सेवाएं',
      'dashboard.database': 'डेटाबेस',
      'dashboard.paymentGateway': 'भुगतान गेटवे',
      'dashboard.emailService': 'ईमेल सेवा',
      // Committee (Hindi)
      'about.committee.expertise': 'विशेषज्ञता',
      'about.committee.responsibility.executive.1': 'रणनीतिक योजना और नीति निर्माण',
      'about.committee.responsibility.executive.2': 'बोर्ड शासन और निगरानी',
      'about.committee.responsibility.executive.3': 'वित्तीय अनुमोदन और बजट प्रबंधन',
      'about.committee.responsibility.executive.4': 'हितधारक संबंध प्रबंधन',
      'about.committee.responsibility.technical.1': 'तकनीकी सलाह और परामर्श',
      'about.committee.responsibility.technical.2': 'सुरक्षा मानक और अनुपालन मार्गदर्शन',
      'about.committee.responsibility.technical.3': 'प्रौद्योगिकी अपनाने की सिफारिशें',
      'about.committee.responsibility.technical.4': 'प्रशिक्षण कार्यक्रम विकास',
      'about.committee.responsibility.regional.1': 'स्थानीय सदस्य सहायता और जुड़ाव',
      'about.committee.responsibility.regional.2': 'क्षेत्रीय कार्यक्रम समन्वय',
      'about.committee.responsibility.regional.3': 'जिला स्तरीय नीति वकालत',
      'about.committee.responsibility.regional.4': 'सामुदायिक आउटरीच कार्यक्रम',
      'about.committee.responsibility.finance.1': 'बजट योजना और निगरानी',
      'about.committee.responsibility.finance.2': 'वित्तीय रिपोर्टिंग और ऑडिट निगरानी',
      'about.committee.responsibility.finance.3': 'निवेश और फंड प्रबंधन',
      'about.committee.responsibility.finance.4': 'लागत नियंत्रण और दक्षता उपाय',
      'membership.join.downloadBrochure': 'ब्रॉशर डाउनलोड करें',
      'home.title': 'Industrial Fedration of Maharashtra Region',
      'home.subtitle': 'उद्योगों को सशक्त बनाना, महाराष्ट्र का निर्माण',
      'home.exploreSupport': 'सहायता देखें',
      'home.learnMore': 'और जानें',
      'home.whyChooseUs': 'हम क्यों चुनें',
      'home.whyChooseUsDesc': 'विकास, अनुपालन और वकालत के लिए विश्वसनीय भागीदार',
      'home.whyChooseUs.title': 'हम क्यों चुनें?',
      'home.whyChooseUs.subtitle': 'हम महाराष्ट्र के औद्योगिक परिदृश्य में आपके व्यवसाय को फलने-फूलने में मदद करने के लिए व्यापक सहायता और विशेषज्ञ मार्गदर्शन प्रदान करते हैं।',
      'home.whyChooseUs.feature1.title': 'बहु-विभागीय समन्वय',
      'home.whyChooseUs.feature1.desc': 'बहु-विभागीय सरकारी समन्वय की एक मजबूत श्रृंखला',
      'home.whyChooseUs.feature2.title': 'विशेषज्ञ अनुपालन मार्गदर्शन',
      'home.whyChooseUs.feature2.desc': 'अनुपालन और कानूनी जोखिमों को कम करने पर विशेषज्ञ मार्गदर्शन',
      'home.whyChooseUs.feature3.title': 'तेज़ समस्या समाधान',
      'home.whyChooseUs.feature3.desc': 'समस्याओं को हल करने के लिए तेज़ और प्रभावी प्रतिनिधित्व',
      'home.whyChooseUs.feature4.title': 'सतत व्यावसायिक संस्कृति',
      'home.whyChooseUs.feature4.desc': 'सततता, सुरक्षा और कानूनी व्यावसायिक संस्कृति पर जोर',
      'home.whyChooseUs.feature5.title': 'सरकारी लाभ पहुंच',
      'home.whyChooseUs.feature5.desc': 'सहायता जो सरकारी योजनाओं और लाभों के पूर्ण उपयोग को सुनिश्चित करती है',
      'home.whyChooseUs.feature6.title': 'उद्योग नेटवर्किंग और सहयोग',
      'home.whyChooseUs.feature6.desc': 'उद्योग के नेताओं के साथ जुड़ें, सर्वोत्तम प्रथाओं को साझा करें, और महाराष्ट्र भर में औद्योगिक विकास को बढ़ावा देने वाली पहलों पर सहयोग करें',
      'home.whyChooseUs.feature7.title': 'प्रशिक्षण और विकास कार्यक्रम',
      'home.whyChooseUs.feature7.desc': 'कार्यबल क्षमताओं और उद्योग मानकों को बढ़ाने के लिए व्यापक प्रशिक्षण कार्यक्रम, कार्यशालाएं और कौशल विकास पहल',
      'home.president.experienceLabel': 'अनुभव',
      'home.president.backgroundLabel': 'पृष्ठभूमि',
      'home.recentNewsTitle': 'हाल की खबरें और घोषणाएँ',
      'home.recentNewsSubtitle': 'IFM की नवीनतम खबरें, अपडेट और कार्यक्रमों से जुड़े रहें',
      'home.upcomingEvents': 'आगामी कार्यक्रम',
      'home.feature1.title': 'नियामक सहायता',
      'home.feature1.desc': 'अनुपालन और नियमों पर विशेषज्ञ मार्गदर्शन',
      'home.feature2.title': 'उद्योग नेटवर्किंग',
      'home.feature2.desc': 'साथी उद्योगपतियों से जुड़ें',
      'home.feature3.title': 'प्रशिक्षण कार्यक्रम',
      'home.feature3.desc': 'पेशेवर विकास के अवसर',
      'home.feature4.title': 'वकालत',
      'home.feature4.desc': 'उद्योग हितों का प्रतिनिधित्व',
      // Home - Quick Links
      'home.quickLinks': 'त्वरित लिंक',
      'home.quickLinksDesc': 'पोर्टल के सामान्य अनुभागों तक तुरंत पहुँचें',
      // Home - Companies
      'home.companies.title': 'हमारे साथ जुड़ी कंपनियाँ',
      'home.companies.subtitle': 'विश्वसनीय साझेदार और उद्योग सहयोगी जो IFM के साथ काम करते हैं',
      'home.companies.emptyTitle': 'कंपनियाँ जल्द ही',
      'home.companies.emptyDesc': 'हम साझेदार कंपनियों को जोड़ रहे हैं और जल्द ही उन्हें यहाँ दिखाएंगे।',
      'home.companies.viewAll': 'सभी साझेदार देखें',
      // Partners Page
      'partners.title': 'हमारे साझेदार',
      'partners.subtitle': 'IFM के साथ जुड़ी कंपनियों और सहयोगों की सूची देखें।',
      'partners.filters': 'फ़िल्टर',
      'partners.searchPlaceholder': 'कंपनी नाम या टैगलाइन खोजें',
      'partners.filterAll': 'सभी कंपनियाँ',
      'partners.filterWithWebsite': 'वेबसाइट वाले',
      'partners.filterWithoutWebsite': 'वेबसाइट बिना',
      'partners.loading': 'कंपनियाँ लोड हो रही हैं...',
      'partners.emptyTitle': 'कोई कंपनी नहीं मिली',
      'partners.emptyDesc': 'कृपया फ़िल्टर बदलें या बाद में फिर देखें।',
      'partners.visitWebsite': 'वेबसाइट देखें',
      'partners.noWebsite': 'वेबसाइट लिंक उपलब्ध नहीं है',
      'partners.back': 'वापस',
      'partners.homeLink': 'होम पर जाएँ',
      'home.viewAllNews': 'सभी समाचार देखें',
      'home.viewAllEvents': 'सभी कार्यक्रम देखें',
      'home.quickLink1.title': 'सहायता सेवाओं का अन्वेषण करें',
      'home.quickLink1.desc': 'नियामक, अनुपालन और परामर्श सहायता',
      'home.quickLink2.title': 'आगामी कार्यक्रम',
      'home.quickLink2.desc': 'कार्यशालाएं, सेमिनार और नेटवर्किंग',
      'home.quickLink3.title': 'फोटो गैलरी',
      'home.quickLink3.desc': 'हाल के कार्यक्रम और गतिविधियाँ देखें',
      // Home - Contact
      'home.contactUs': 'हमसे संपर्क करें',
      'home.contactUsDesc': 'सहायता और जानकारी के लिए हमसे संपर्क करें',
      'home.contact.phone': 'फोन',
      'home.contact.email': 'ईमेल',
      'home.contact.address': 'कार्यालय का पता',
      'home.contact.addressValue': 'IFM कार्यालय, 3री मंजिल, बिजनेस प्लाज़ा, बांद्रा ईस्ट, मुंबई - 400051',
      'home.contact.followUs': 'हमें फॉलो करें',
      'home.contact.quickLinks': 'त्वरित लिंक',
      'home.contact.aboutUs': 'हमारे बारे में',
      'home.contact.missionVision': 'मिशन और व्हिजन',
      'home.contact.committee': 'समिति',
      'home.contact.presidentMessage': 'अध्यक्ष संदेश',
      'home.contact.copyright': 'सभी अधिकार सुरक्षित',
      'home.readMore': 'और पढ़ें',
      'home.news.label': 'समाचार',
      'home.event.label': 'कार्यक्रम',
      // About - Hero
      'about.title': 'IFM के बारे में',
      'about.subtitle': 'महाराष्ट्र के औद्योगिक विकास का नेतृत्व',
      // About - Vision & Mission
      'about.vision.title': 'हमारी  व्हिजन',
      'about.vision.desc': 'एक एकीकृत, अनुपालनकारी और प्रगतिशील औद्योगिक पारिस्थितिकी तंत्र का निर्माण करना, जो सतत विकास, नियामकीय अनुपालन और उद्योगों व सरकारी प्राधिकरणों के बीच आपसी सहयोग को बढ़ावा दे।',
      'about.mission.title': 'हमारा मिशन',
      'about.mission.subtitle': 'उद्योगों के लिए एक सक्रिय और परिणाम-केंद्रित मंच के रूप में कार्य करना, जो प्रभावी समन्वय, विशेषज्ञ प्रतिनिधित्व और रणनीतिक नीति वकालत के माध्यम से महत्वपूर्ण नियामकीय, अवसंरचनात्मक और प्रशासनिक चुनौतियों का समाधान करे।',
      'about.mission.desc': 'उद्योगों के लिए एक सक्रिय और परिणाम-केंद्रित मंच के रूप में कार्य करना, जो प्रभावी समन्वय, विशेषज्ञ प्रतिनिधित्व और रणनीतिक नीति वकालत के माध्यम से महत्वपूर्ण नियामकीय, अवसंरचनात्मक और प्रशासनिक चुनौतियों का समाधान करे।',
      // About - Values
      'about.values.title': 'मुख्य मूल्य',
      'about.values.desc': 'हमारे मिशन और सेवाओं का मार्गदर्शन करने वाले सिद्धांत',
      'about.values.integrity': 'ईमानदारी',
      'about.values.integrity.desc': 'हम पारदर्शिता और जवाबदेही का पालन करते हैं',
      'about.values.collaboration': 'सहयोग',
      'about.values.collaboration.desc': 'बेहतर परिणामों के लिए हम साझेदारों के साथ काम करते हैं',
      'about.values.innovation': 'नवाचार',
      'about.values.innovation.desc': 'आधुनिक, कुशल और टिकाऊ प्रथाओं को बढ़ावा',
      'about.values.excellence': 'उत्कृष्टता',
      'about.values.excellence.desc': 'उच्च मानकों और निरंतर सुधार के लिए प्रयास',

      // About - Strategic Objectives
      'about.objectives.title': 'रणनीतिक उद्देश्य',
      'about.objectives.desc': 'मुख्य फोकस क्षेत्र जो हमारे मिशन और व्हिजन को आगे बढ़ाते हैं',
      'about.objectives.sustainable.title': 'सतत विकास',
      'about.objectives.sustainable.desc': 'दीर्घकालिक समृद्धि के लिए पर्यावरण के अनुकूल औद्योगिक प्रथाओं और हरित प्रौद्योगिकियों को बढ़ावा देना।',
      'about.objectives.collaboration.title': 'उद्योग सहयोग',
      'about.objectives.collaboration.desc': 'पारस्परिक लाभ के लिए सरकार, उद्योग और समुदायों के बीच मजबूत साझेदारी का निर्माण।',
      'about.objectives.innovation.title': 'नवाचार सहायता',
      'about.objectives.innovation.desc': 'औद्योगिक प्रतिस्पर्धा को बढ़ावा देने के लिए तकनीकी प्रगति और अनुसंधान पहलों को बढ़ावा देना।',

      // About - Call to Action
      'about.join.title': 'हमारे मिशन में शामिल हों',
      'about.join.desc': 'महाराष्ट्र के औद्योगिक परिवर्तन का हिस्सा बनें। साथ मिलकर, हम एक सतत और समृद्ध भविष्य का निर्माण कर सकते हैं।',
      'about.join.member': 'सदस्य बनें',
      'about.join.contact': 'संपर्क करें',

      // About - IFM Introduction
      'about.intro.title': 'Industrial Fedration of Maharashtra Region के बारे में',
      'about.intro.description': 'Industrial Fedration of Maharashtra Region (IFM) (रजिस्ट्रेशन नं. महा./745/2025, पुणे) महाराष्ट्र में उद्योगों के अधिकारों और मुद्दों के लिए काम करने वाला एक पंजीकृत निकाय है। हम MPCB, MIDC, DIC, सुरक्षा विभाग और प्रदूषण नियंत्रण बोर्ड जैसे सरकारी अधिकारियों के सामने उद्योगों का प्रतिनिधित्व करते हैं ताकि छोटे, मध्यम और बड़े उद्योगों के लिए निष्पक्ष नीतियां, पारदर्शिता और सहायता सुनिश्चित हो सके।',

      // About - Vision Details
      'about.vision.details.1': 'सभी उद्योगों के लिए समान अवसर सुनिश्चित करना।',
      'about.vision.details.2': 'एक पारदर्शी और प्रतिस्पर्धी वातावरण बनाना।',
      'about.vision.details.3': 'वैज्ञानिक और न्यायसंगत पर्यावरणीय नीतियों को बढ़ावा देना।',
      'about.vision.details.4': 'औद्योगिक सेवाओं में एकाधिकार प्रथाओं को समाप्त करना।',
      'about.vision.details.5': 'महाराष्ट्र में एक सतत और प्रगतिशील औद्योगिक पारिस्थितिकी तंत्र का निर्माण करना।',

      // About - Core Values Details
      'about.values.integrity.details.1': 'पारदर्शी निर्णय लेने की प्रक्रियाएं',
      'about.values.integrity.details.2': 'जवाबदेह नेतृत्व और शासन',
      'about.values.integrity.details.3': 'नैतिक व्यापार प्रथाएं',
      'about.values.integrity.details.4': 'हितधारकों के साथ ईमानदार संचार',
      'about.values.collaboration.details.1': 'क्रॉस-सेक्टर साझेदारी',
      'about.values.collaboration.details.2': 'सरकार-उद्योग सहयोग',
      'about.values.collaboration.details.3': 'सामुदायिक जुड़ाव पहल',
      'about.values.collaboration.details.4': 'ज्ञान साझाकरण मंच',
      'about.values.innovation.details.1': 'प्रौद्योगिकी अपनाने के कार्यक्रम',
      'about.values.innovation.details.2': 'डिजिटल परिवर्तन पहल',
      'about.values.innovation.details.3': 'टिकाऊ विनिर्माण प्रक्रियाएं',
      'about.values.innovation.details.4': 'अनुसंधान और विकास सहायता',
      'about.values.excellence.details.1': 'गुणवत्ता आश्वासन कार्यक्रम',
      'about.values.excellence.details.2': 'निरंतर सुधार पहल',
      'about.values.excellence.details.3': 'सर्वोत्तम अभ्यास कार्यान्वयन',
      'about.values.excellence.details.4': 'प्रदर्शन बेंचमार्किंग',

      // About - Core Values Sections
      'about.values.living.title': 'हमारे मूल्यों को जीना',
      'about.values.living.desc': 'हम अपने मुख्य मूल्यों को क्रियाशील पहलों और मापने योग्य परिणामों में कैसे बदलते हैं',
      'about.values.initiatives.title': 'मुख्य पहल',
      'about.values.action.title': 'कार्य में मूल्य',
      'about.values.action.desc': 'हमारे मूल्य हमारे काम का मार्गदर्शन कैसे करते हैं और सकारात्मक प्रभाव कैसे बनाते हैं, इसके वास्तविक उदाहरण',
      'about.values.action.transparent.title': 'पारदर्शी शासन',
      'about.values.action.transparent.desc': 'हमारी गतिविधियों पर नियमित सार्वजनिक रिपोर्ट, वित्तीय पारदर्शिता, और सभी हितधारकों के साथ खुला संचार।',
      'about.values.action.community.title': 'सामुदायिक साझेदारी',
      'about.values.action.community.desc': 'स्थानीय समुदायों, शैक्षणिक संस्थानों और उद्योग संघों के साथ सहयोगात्मक परियोजनाएं।',
      'about.values.action.excellence.title': 'उत्कृष्टता मान्यता',
      'about.values.action.excellence.desc': 'उत्कृष्ट औद्योगिक प्रथाओं और नवाचार उपलब्धियों के लिए पुरस्कार और मान्यता कार्यक्रम।',

      // About - Core Values Call to Action
      'about.values.share.title': 'हमारे मूल्य साझा करें',
      'about.values.share.desc': 'इन मूल्यों को बनाए रखने और महाराष्ट्र की औद्योगिक उत्कृष्टता में योगदान देने में हमारे साथ जुड़ें।',
      'about.values.share.member': 'सदस्य बनें',
      'about.values.share.learn': 'और जानें',

      // About - Structure Additional Content
      'about.structure.detailed.title': 'विस्तृत संगठन संरचना',
      'about.structure.detailed.desc': 'समझना कि प्रत्येक विभाग हमारे मिशन में कैसे योगदान देता है और हमारे सदस्यों की सेवा करता है',
      'about.structure.leadership.title': 'संचालक मंडल',
      'about.structure.leadership.desc': 'उन समर्पित नेताओं से मिलें जो IFM की रणनीतिक दिशा और कार्यों का मार्गदर्शन करते हैं',
      'about.structure.leadershipCta': 'हमारी रणनीतिक दिशा का मार्गदर्शन करने वाले समर्पित नेताओं से मिलें।',
      'about.leadership.viewCommittee': 'समिति सदस्य देखें',
      'about.structure.chart.title': 'संगठनात्मक आलेख',
      'about.structure.chart.desc': 'हमारे संगठनात्मक पदानुक्रम और रिपोर्टिंग संरचना का दृश्य प्रतिनिधित्व',

      // About - Structure Regional Cities
      'about.structure.regional.mumbai': 'मुंबई',
      'about.structure.regional.pune': 'पुणे',
      'about.structure.regional.nagpur': 'नागपुर',
      'about.structure.regional.aurangabad': 'औरंगाबाद',
      'about.structure.regional.nashik': 'नासिक',

      // About - Structure Leadership Team
      'about.structure.leadership.president.name': 'श्री कैलास नरके',
      'about.structure.leadership.president.position': 'अध्यक्ष',
      'about.structure.leadership.president.department': 'कार्यकारी नेतृत्व',
      'about.structure.leadership.vicePresident.name': 'श्री जावेद इनामदार',
      'about.structure.leadership.vicePresident.position': 'उपाध्यक्ष',
      'about.structure.leadership.vicePresident.department': 'रणनीतिक योजना',
      'about.structure.leadership.secretary.name': 'श्रीमती दीपा महाजन',
      'about.structure.leadership.secretary.position': 'सचिव',
      'about.structure.leadership.secretary.department': 'संचालन',
      'about.structure.leadership.treasurer.name': 'श्री रामदास नापते',
      'about.structure.leadership.treasurer.position': 'कोषाध्यक्ष',
      'about.structure.leadership.treasurer.department': 'वित्त',
      'about.structure.leadership.chiefConsultant.name': 'श्री प्रशांत मुंदडा',
      'about.structure.leadership.chiefConsultant.position': 'मुख्य सलाहकार अधिकारी',
      'about.structure.leadership.chiefConsultant.department': 'सलाहकार',

      // About - Structure Chart Departments
      'about.structure.chart.technical.title': 'तकनीकी',
      'about.structure.chart.technical.subtitle': 'समिति',
      'about.structure.chart.regional.title': 'क्षेत्रीय',
      'about.structure.chart.regional.subtitle': 'समितियां',
      'about.structure.chart.support.title': 'सहायता',
      'about.structure.chart.support.subtitle': 'कर्मचारी',
      'about.structure.chart.external.title': 'बाहरी',
      'about.structure.chart.external.subtitle': 'संबंध',

      // About - Structure Call to Action
      'about.structure.join.title': 'हमारे संगठन में शामिल हों',
      'about.structure.join.desc': 'एक अच्छी तरह से संरचित संगठन का हिस्सा बनें जो औद्योगिक उत्कृष्टता और सदस्य सफलता के लिए प्रतिबद्ध है।',
      'about.structure.join.member': 'सदस्य बनें',
      'about.structure.join.learn': 'और जानें',

      // About - Achievements Page
      'about.achievements.journey.title': 'हमारी यात्रा',
      'about.achievements.journey.desc': 'मुख्य मील के पत्थर और उपलब्धियां जिन्होंने हमारे संगठन की वृद्धि और प्रभाव को आकार दिया है',
      'about.achievements.milestone.2023.title': 'डिजिटल परिवर्तन पहल',
      'about.achievements.milestone.2023.desc': 'सदस्य सेवाओं और नियामक अनुपालन के लिए व्यापक डिजिटल प्लेटफॉर्म लॉन्च किया।',
      'about.achievements.milestone.2023.achievements.1': 'ऑनलाइन सदस्यता पोर्टल',
      'about.achievements.milestone.2023.achievements.2': 'डिजिटल दस्तावेज़ प्रबंधन',
      'about.achievements.milestone.2023.achievements.3': 'मोबाइल ऐप लॉन्च',
      'about.achievements.milestone.2022.title': 'सततता कार्यक्रम',
      'about.achievements.milestone.2022.desc': 'हरित औद्योगिक प्रथाओं और पर्यावरणीय अनुपालन सहायता की शुरुआत की।',
      'about.achievements.milestone.2022.achievements.1': 'हरित प्रमाणन कार्यक्रम',
      'about.achievements.milestone.2022.achievements.2': 'कार्बन फुटप्रिंट कमी',
      'about.achievements.milestone.2022.achievements.3': 'नवीकरणीय ऊर्जा अपनाना',
      'about.achievements.milestone.2021.title': 'क्षेत्रीय विस्तार',
      'about.achievements.milestone.2021.desc': 'महाराष्ट्र के सभी प्रमुख औद्योगिक जिलों में सेवाओं का विस्तार किया।',
      'about.achievements.milestone.2021.achievements.1': '5 नए क्षेत्रीय कार्यालय',
      'about.achievements.milestone.2021.achievements.2': 'स्थानीय सहायता टीमें',
      'about.achievements.milestone.2021.achievements.3': 'जिला स्तरीय साझेदारी',
      'about.achievements.milestone.2020.title': 'कोविड-19 सहायता पहल',
      'about.achievements.milestone.2020.desc': 'महामारी के दौरान उद्योगों को महत्वपूर्ण सहायता प्रदान की।',
      'about.achievements.milestone.2020.achievements.1': 'आपातकालीन राहत कोष',
      'about.achievements.milestone.2020.achievements.2': 'सुरक्षा प्रोटोकॉल मार्गदर्शन',
      'about.achievements.milestone.2020.achievements.3': 'आपूर्ति श्रृंखला सहायता',
      'about.achievements.impact.title': 'हमारा प्रभाव',
      'about.achievements.impact.desc': 'हमारी उपलब्धियां महाराष्ट्र के औद्योगिक क्षेत्र के लिए वास्तविक लाभों में कैसे तब्दील होती हैं',
      'about.achievements.impact.economic.title': 'आर्थिक वृद्धि',
      'about.achievements.impact.economic.desc': 'सदस्य सहायता और नीति वकालत के माध्यम से महाराष्ट्र की औद्योगिक जीडीपी में योगदान।',
      'about.achievements.impact.employment.title': 'रोजगार सृजन',
      'about.achievements.impact.employment.desc': 'औद्योगिक विकास और कौशल विकास कार्यक्रमों के माध्यम से रोजगार सृजन का समर्थन।',
      'about.achievements.impact.policy.title': 'नीति प्रभाव',
      'about.achievements.impact.policy.desc': 'राज्य और राष्ट्रीय स्तर पर वकालत और प्रतिनिधित्व के माध्यम से औद्योगिक नीतियों को आकार देना।',
      'about.achievements.recognition.title': 'मान्यता और पुरस्कार',
      'about.achievements.recognition.desc': 'हमारे उत्कृष्ट योगदान और सेवा उत्कृष्टता के लिए उद्योग मान्यता',
      'about.achievements.award1.title': 'सर्वश्रेष्ठ उद्योग संघ',
      'about.achievements.award1.event': 'महाराष्ट्र औद्योगिक उत्कृष्टता पुरस्कार 2023',
      'about.achievements.award1.desc': 'महाराष्ट्र के औद्योगिक क्षेत्र में उत्कृष्ट सेवा और नवाचारी सदस्य सहायता कार्यक्रमों के लिए मान्यता।',
      'about.achievements.award2.title': 'सततता नेतृत्व',
      'about.achievements.award2.event': 'हरित औद्योगिक पुरस्कार 2022',
      'about.achievements.award2.desc': 'महाराष्ट्र भर में सतत औद्योगिक प्रथाओं और पर्यावरणीय अनुपालन को बढ़ावा देने के लिए सम्मानित।',
      'about.achievements.future.title': 'आगे देखते हुए',
      'about.achievements.future.desc': 'भविष्य के लिए हमारी  व्हिजन और महाराष्ट्र के औद्योगिक क्षेत्र को और मजबूत बनाने के लिए आगामी पहलें',
      'about.achievements.goals.title': '2024-2026 रणनीतिक लक्ष्य',
      'about.achievements.goals.1': 'सदस्यता को 1000+ सक्रिय सदस्यों तक विस्तारित करना',
      'about.achievements.goals.2': 'AI-संचालित अनुपालन सहायता प्लेटफॉर्म लॉन्च करना',
      'about.achievements.goals.3': 'अंतर्राष्ट्रीय व्यापार साझेदारी स्थापित करना',
      'about.achievements.goals.4': '100% डिजिटल सेवा वितरण प्राप्त करना',
      'about.achievements.innovation.title': 'नवाचार पहलें',
      'about.achievements.innovation.1': 'स्मार्ट विनिर्माण सहायता कार्यक्रम',
      'about.achievements.innovation.2': 'ब्लॉकचेन-आधारित प्रमाणन प्रणाली',
      'about.achievements.innovation.3': 'वर्चुअल रियलिटी प्रशिक्षण मॉड्यूल',
      'about.achievements.innovation.4': 'औद्योगिक निगरानी के लिए IoT एकीकरण',
      'about.achievements.cta.title': 'हमारी सफलता की कहानी का हिस्सा बनें',
      'about.achievements.cta.desc': 'उत्कृष्टता की हमारी यात्रा को जारी रखने और महाराष्ट्र के औद्योगिक विकास में योगदान देने में हमारे साथ जुड़ें।',
      'about.achievements.cta.member': 'सदस्य बनें',
      'about.achievements.cta.learn': 'और जानें',

      // About - Committee Page
      'about.committee.leadership.desc': 'IFM की रणनीतिक दिशा और दैनिक संचालन का नेतृत्व करने वाले अनुभवी पेशेवर',
      'about.committee.structure.desc': 'औद्योगिक समर्थन के सभी पहलुओं के व्यापक कवरेज को सुनिश्चित करने वाली संगठित समितियां',
      'about.committee.responsibilities.desc': 'प्रभावी शासन और सेवा वितरण सुनिश्चित करने वाली स्पष्ट भूमिकाएं और जिम्मेदारियां',
      'about.committee.contact.desc': 'विशिष्ट पूछताछ और समर्थन के लिए हमारे समिति सदस्यों से संपर्क करें',
      'about.committee.contact.secretary.role': 'समिति समन्वय',
      'about.committee.cta.title': 'हमारी समिति में शामिल हों',
      'about.committee.cta.desc': 'IFM के मिशन में योगदान देने में रुचि है? हमारी किसी एक समिति में शामिल होने पर विचार करें।',
      'about.committee.cta.member': 'सदस्य बनें',
      'about.committee.cta.contact': 'संपर्क करें',
      'about.committee.experience': 'अनुभव',
      'about.committee.members': 'समिति सदस्य:',
      'about.committee.membersSection.title': 'समिति सदस्य',
      'about.committee.membersSection.desc': 'हमारे समर्पित समिति सदस्य और उनकी भूमिकाएं',
      'about.committee.role.member': 'समिति सदस्य',
      'about.committee.member.prashantMundada.name': 'प्रशांत मुंदडा',
      'about.committee.member.shrikantNarke.name': 'श्री श्रीकांत नरके',
      'about.committee.member.dadasahebShinalkar.name': 'श्री दादासाहेब शिनाळकर',
      'about.committee.member.sachinDhumal.name': 'श्री सचिन धुमाळ',
      'about.committee.member.sudhirBhadhe.name': 'श्री सुधीर भाधे',
      'about.committee.executive.name': 'कार्यकारी समिति',
      'about.committee.executive.desc': 'रणनीतिक नेतृत्व और शासन निगरानी',
      'about.committee.technical.name': 'तकनीकी समिति',
      'about.committee.technical.desc': 'विषय विशेषज्ञता और सलाहकार सेवाएं',
      'about.committee.regional.name': 'क्षेत्रीय समिति',
      'about.committee.regional.desc': 'महाराष्ट्र भर में स्थानीय प्रतिनिधित्व',
      'about.committee.finance.name': 'वित्त समिति',
      'about.committee.finance.desc': 'वित्तीय निगरानी और बजट प्रबंधन',

      // Home Page - About IFM Section
      'home.about.title': 'IFM के बारे में',
      'home.about.intro': 'Industrial Fedration एक अग्रणी पेशेवर संगठन है।',
      'home.about.point1': 'यह एक ऐसा संगठन है जो उद्योग क्षेत्र और विभिन्न सरकारी विभागों को एक साथ लाता है।',
      'home.about.point2': 'विभागों के बीच एक महत्वपूर्ण कड़ी (पुल)।',
      'home.about.point3': 'इसलिए यह काम करता है। नियामक उद्योगों का सामना कर रहे हैं (नियामक), तकनीकी और बुनियादी ढांचा।',
      'home.about.commitment': 'हम हमेशा समस्याओं को हल करने के लिए प्रतिबद्ध हैं।',
      'home.about.federation.title': 'महासंघ के बारे में',
      'home.about.federation.desc1': 'Industrial Fedration एक पेशेवर और विश्वसनीय संगठन है जो उद्योगों के सामने आने वाली नियामक, परिचालन और बुनियादी ढांचे की चुनौतियों को हल करने के लिए काम करता है। हम उद्योगों और विभिन्न सरकारी विभागों के बीच एक महत्वपूर्ण समन्वय लिंक के रूप में कार्य करते हैं, यह सुनिश्चित करते हुए कि औद्योगिक संचालन सुचारू रूप से, कानूनी रूप से और स्थायी रूप से चलें।',
      'home.about.federation.desc2': 'हमारा प्राथमिक उद्देश्य उद्योगों के लिए एक अनुकूल और भय-मुक्त वातावरण बनाना है, और पर्यावरण संरक्षण, श्रमिक सुरक्षा और संसाधन प्रबंधन जैसे जिम्मेदार औद्योगिक प्रथाओं को बढ़ावा देना है।',
      'home.about.knowMore': 'और जानें',

      // Home Page - President Message Section
      'home.president.title': 'अध्यक्ष का संदेश',
      'home.president.message1': 'Industrial Fedration of Maharashtra Region (IFM) में आपका स्वागत करते हुए मुझे अत्यधिक प्रसन्नता हो रही है। जैसा कि हम औद्योगिक विकास के गतिशील परिदृश्य से गुजरते हैं, IFM महाराष्ट्र भर में सतत विकास और नवाचार को बढ़ावा देने के लिए प्रतिबद्ध है।',
      'home.president.message2': 'हमारा संगठन औद्योगिक उत्कृष्टता, सुरक्षा मानकों और पर्यावरणीय जिम्मेदारी को बढ़ावा देने में अग्रणी रहा है। हम मानते हैं कि सच्ची प्रगति आर्थिक विकास को सामाजिक जिम्मेदारी और पर्यावरणीय स्टीवर्डशिप के साथ संतुलित करने से आती है।',
      'home.president.message3': 'हमारे व्यापक कार्यक्रमों के माध्यम से, हम तकनीकी सहायता, नीति वकालत और प्रशिक्षण अवसर प्रदान करते हैं जो उद्योगों को पनपने में सशक्त बनाते हैं और साथ ही हमारे समुदायों में सकारात्मक योगदान देते हैं। हमारा सहयोगी  व्हिजनकोण सरकारी एजेंसियों, उद्योग नेताओं और स्थानीय हितधारकों को एक साथ लाता है।',
      'home.president.message4': 'जैसा कि हम भविष्य की ओर देखते हैं, IFM नई तकनीकों, सतत प्रथाओं और नवाचारी समाधानों को अपनाने के लिए प्रतिबद्ध है जो महाराष्ट्र के औद्योगिक क्षेत्र को नई ऊंचाइयों तक ले जाएंगे। एक साथ, हम एक अधिक समृद्ध और सतत कल का निर्माण कर सकते हैं।',
      'home.president.message5': 'मजबूत उद्योग = मजबूत क्षेत्र = मजबूत राष्ट्र',
      'home.president.message6': 'इस  व्हिजनकोण को प्राप्त करने के लिए, हम प्रदूषण नियंत्रण प्राधिकरण, DISH, MIDC, MSEDCL, DIC, श्रम विभाग और अन्य प्रमुख सरकारी निकायों के साथ लगातार काम करते हैं, जो औद्योगिक आवश्यकताओं के लिए पारदर्शी, विश्वसनीय और समय पर समाधान सुनिश्चित करते हैं।',
      'home.president.message7': 'हमारा उद्देश्य समस्या-समाधान से परे है। हम सतत और जिम्मेदार औद्योगिक विकास को बढ़ावा देने, सुरक्षित और अनुपालन कार्यस्थलों का निर्माण करने, पर्यावरण के अनुकूल और कुशल संसाधन प्रबंधन का समर्थन करने, उद्योगों की सामूहिक आवाज को मजबूत करने और नवाचार और विकास को प्रोत्साहित करने वाले पारिस्थितिकी तंत्र बनाने के लिए प्रतिबद्ध हैं।',
      'home.president.message8': 'औद्योगिक संघ सिर्फ एक मंच नहीं है—यह औद्योगिक समुदाय का गौरव, शक्ति और एकीकृत आवाज है। हम सभी उद्योगों की प्रगति, स्थिरता और दीर्घकालिक विकास के लिए अथक रूप से काम करने के लिए समर्पित हैं।',
      'home.president.message9': 'आपके निरंतर समर्थन के साथ, हम भविष्य के लिए एक मजबूत, प्रगतिशील और सहयोगी औद्योगिक पारिस्थितिकी तंत्र बनाने के लिए आश्वस्त हैं। औद्योगिक संघ का एक मूल्यवान हिस्सा होने के लिए धन्यवाद।',
      'home.president.thankYou': 'औद्योगिक संघ का एक मूल्यवान हिस्सा होने के लिए धन्यवाद।',
      'home.president.missionTitle': 'हमारा मिशन सरल लेकिन शक्तिशाली है',
      'home.president.name': 'श्री कैलास नरके',
      'home.president.position': 'अध्यक्ष, Industrial Fedration of Maharashtra Region',
      'home.president.experience': 'औद्योगिक नेतृत्व में 10+ वर्ष',
      'home.president.background': 'पूर्व निदेशक, महाराष्ट्र उद्योग',
      'about.president.purpose.title': 'हमारा उद्देश्य समस्या-समाधान से परे है',
      'about.president.purpose.committed': 'हम प्रतिबद्ध हैं:',
      'about.president.commitment.sustainable': 'सतत और जिम्मेदार औद्योगिक विकास को बढ़ावा देना',
      'about.president.commitment.safeWorkplaces': 'सुरक्षित और अनुपालन कार्यस्थलों का निर्माण करना',
      'about.president.commitment.resourceManagement': 'पर्यावरण के अनुकूल और कुशल संसाधन प्रबंधन का समर्थन करना',
      'about.president.commitment.collectiveVoice': 'उद्योगों की सामूहिक आवाज को मजबूत करना',
      'about.president.commitment.innovationEcosystem': 'नवाचार और विकास को प्रोत्साहित करने वाले पारिस्थितिकी तंत्र का निर्माण करना',
      'about.president.partnerships.title': 'सरकारी साझेदारी और सहयोग',
      // About - Structure
      'about.structure.title': 'संगठन संरचना',
      'about.structure.subtitle': 'उद्योग की बेहतर सेवा के लिए हमारी व्यवस्था',
      'about.structure.executive.title': 'कार्यकारी समिति',
      'about.structure.executive.desc': 'रणनीतिक नेतृत्व और संचालन',
      'about.structure.executive.members.chairman': 'अध्यक्ष',
      'about.structure.executive.members.viceChairman': 'उपाध्यक्ष',
      'about.structure.executive.members.secretary': 'महासचिव',
      'about.structure.executive.members.treasurer': 'कोषाध्यक्ष',
      'about.structure.technical.title': 'तकनीकी समिति',
      'about.structure.technical.desc': 'विषय विशेषज्ञता और परामर्श',
      'about.structure.technical.members.safety': 'औद्योगिक सुरक्षा',
      'about.structure.technical.members.environmental': 'पर्यावरणीय अनुपालन',
      'about.structure.technical.members.infrastructure': 'बुनियादी ढांचा',
      'about.structure.technical.members.compliance': 'नियामक अनुपालन',
      'about.structure.regional.title': 'क्षेत्रीय समितियाँ',
      'about.structure.regional.desc': 'महाराष्ट्र भर में स्थानीय प्रतिनिधित्व',
      'about.structure.support.title': 'सहायक स्टाफ',
      'about.structure.support.desc': 'संचालन उत्कृष्टता और सेवा वितरण',
      'about.structure.support.members.admin': 'प्रशासन',
      'about.structure.support.members.technical': 'तकनीकी सहायता',
      'about.structure.support.members.field': 'मैदान संचालन',
      'about.structure.support.members.it': 'आईटी सहायता',
      // About - Achievements
      'about.achievements.title': 'हमारी उपलब्धियाँ',
      'about.achievements.subtitle': 'महाराष्ट्र के औद्योगिक परिदृश्य में विश्वास और उत्कृष्टता का निर्माण',
      'about.quickLinks.title': 'हमारे बारे में और जानें',
      'about.quickLinks.subtitle': 'हमारे नेतृत्व, मिशन, संरचना और उपलब्धियों की खोज करें',
      'about.quickLinks.learnMore': 'अधिक जानें',
      'about.values.viewAll': 'सभी मूल मूल्य देखें',
      'about.achievements.members.label': 'सक्रिय सदस्य',
      'about.achievements.members.desc': 'मजबूत और बढ़ता हुआ सदस्य आधार',
      'about.achievements.events.label': 'आयोजित कार्यक्रम',
      'about.achievements.events.desc': 'कार्यशालाएं, सेमिनार और प्रशिक्षण',
      'about.achievements.satisfaction.label': 'सदस्य संतुष्टि',
      'about.achievements.satisfaction.desc': 'लगातार उच्च संतुष्टि रेटिंग',
      'about.achievements.years.label': 'सेवा के वर्ष',
      'about.achievements.years.desc': 'उद्योगों का समर्थन करने का अनुभव',
      // About - President
      'about.president.title': 'अध्यक्ष प्रोफाइल',
      'about.president.subtitle': 'नेतृत्व जो महाराष्ट्र भर में औद्योगिक उत्कृष्टता को चलाता है',
      'about.president.name': 'श्री कैलास नरके',
      'about.president.position': 'अध्यक्ष',
      'about.president.organization': 'Industrial Fedration of Maharashtra Region',
      'about.president.message.title': 'अध्यक्ष का संदेश',
      'about.president.message.text1': 'Industrial Fedration of Maharashtra Region (IFM) में आपका स्वागत करते हुए मुझे अत्यधिक प्रसन्नता हो रही है। औद्योगिक विकास के गतिशील परिदृश्य से गुजरते हुए, IFM महाराष्ट्र भर में सतत विकास और नवाचार को बढ़ावा देने के लिए प्रतिबद्ध है।',
      'about.president.message.text2': 'हमारा संगठन औद्योगिक उत्कृष्टता, सुरक्षा मानकों और पर्यावरणीय जिम्मेदारी को बढ़ावा देने में अग्रणी रहा है। हम मानते हैं कि सच्ची प्रगति आर्थिक विकास को सामाजिक जिम्मेदारी और पर्यावरणीय स्टीवर्डशिप के साथ संतुलित करने से आती है।',
      'about.president.message.text3': 'हमारे व्यापक कार्यक्रमों के माध्यम से, हम तकनीकी सहायता, नीति वकालत और प्रशिक्षण अवसर प्रदान करते हैं जो उद्योगों को समृद्ध होने में सक्षम बनाते हैं जबकि हमारे समुदायों में सकारात्मक योगदान देते हैं। हमारा सहयोगात्मक  व्हिजनकोण सरकारी एजेंसियों, उद्योग नेताओं और स्थानीय हितधारकों को एक साथ लाता है।',
      'about.president.message.text4': 'जैसा कि हम भविष्य की ओर देखते हैं, IFM नई तकनीकों, सतत प्रथाओं और नवाचारी समाधानों को अपनाने के लिए प्रतिबद्ध है जो महाराष्ट्र के औद्योगिक क्षेत्र को नई ऊंचाइयों पर ले जाएगा। साथ मिलकर, हम एक अधिक समृद्ध और सतत कल का निर्माण कर सकते हैं।',
      'about.president.experience.title': 'अनुभव',
      'about.president.experience.item1': 'औद्योगिक नेतृत्व में 10+ वर्ष',
      'about.president.experience.item2': 'पूर्व निदेशक, महाराष्ट्र उद्योग',
      'about.president.experience.item3': 'नीति वकालत में विशेषज्ञ',
      'about.president.experience.item4': 'नियामक अनुपालन विशेषज्ञ',
      'about.president.leadership.title': 'नेतृत्व',
      'about.president.leadership.item1': 'रणनीतिक  व्हिजन और योजना',
      'about.president.leadership.item2': 'हितधारक प्रबंधन',
      'about.president.leadership.item3': 'उद्योग विकास',
      'about.president.leadership.item4': 'टीम निर्माण और मार्गदर्शन',
      'about.president.focus.title': 'मुख्य फोकस क्षेत्र',
      'about.president.focus.sustainable.title': 'सतत विकास',
      'about.president.focus.sustainable.desc': 'पर्यावरण के अनुकूल औद्योगिक प्रथाओं और हरित प्रौद्योगिकियों को बढ़ावा देना।',
      'about.president.focus.policy.title': 'नीति वकालत',
      'about.president.focus.policy.desc': 'राज्य और राष्ट्रीय स्तर पर उद्योग हितों का प्रतिनिधित्व करना।',
      'about.president.focus.skill.title': 'कौशल विकास',
      'about.president.focus.skill.desc': 'प्रशिक्षण कार्यक्रमों के माध्यम से कार्यबल क्षमताओं को बढ़ाना।',
      'about.president.focus.innovation.title': 'नवाचार सहायता',
      'about.president.focus.innovation.desc': 'तकनीकी प्रगति और अनुसंधान एवं विकास पहलों को बढ़ावा देना।',
      'about.president.timeline.title': 'व्यावसायिक समयरेखा',
      'about.president.timeline.2020.title': '2020 - वर्तमान',
      'about.president.timeline.2020.position': 'अध्यक्ष, Industrial Fedration of Maharashtra Region',
      'about.president.timeline.2020.desc': 'औद्योगिक विकास के लिए रणनीतिक पहल और नीति वकालत का नेतृत्व',
      'about.president.timeline.2015.title': '2015 - 2020',
      'about.president.timeline.2015.position': 'निदेशक, महाराष्ट्र उद्योग',
      'about.president.timeline.2015.desc': 'औद्योगिक विकास नीतियों और नियामक ढांचे की देखरेख',
      'about.president.timeline.2010.title': '2010 - 2015',
      'about.president.timeline.2010.position': 'वरिष्ठ सलाहकार, औद्योगिक नीति',
      'about.president.timeline.2010.desc': 'औद्योगिक नियमों और अनुपालन पर विशेषज्ञ मार्गदर्शन प्रदान किया',
      // About - Founder
      'about.founder.title': 'संस्थापक',
      'about.founder.subtitle': 'वह दूरदर्शी नेता जिसने महाराष्ट्र की औद्योगिक उत्कृष्टता की नींव रखी',
      'about.founder.name': 'डॉ. राजेश कुमार शर्मा',
      'about.founder.position': 'संस्थापक और चेयरमैन एमेरिटस',
      'about.founder.organization': 'Industrial Fedration of Maharashtra Region',
      'about.founder.stats.years': 'सेवा के वर्ष',
      'about.founder.stats.industries': 'समर्थित उद्योग',
      'about.founder.stats.awards': 'प्राप्त पुरस्कार',
      'about.founder.vision.title': 'संस्थापक की  व्हिजन',
      'about.founder.vision.text1': 'मैंने एक महाराष्ट्र की कल्पना की जहां उद्योग केवल जीवित नहीं रहेंगे, बल्कि सहयोग, नवाचार और पारस्परिक सहायता के माध्यम से फलेंगे-फूलेंगे। Industrial Fedration of Maharashtra Region इसी सपने से जन्मा था - एक एकीकृत मंच बनाना जो सरकारी नीतियों और औद्योगिक आवश्यकताओं के बीच की खाई को पाटे।',
      'about.founder.vision.text2': 'हमारा मिशन सरल लेकिन गहरा था: हर औद्योगिक इकाई को, सबसे छोटे MSME से लेकर सबसे बड़े निगम तक, उन उपकरणों, ज्ञान और सहायता से सशक्त बनाना जो उन्हें लगातार विकसित होने वाले आर्थिक परिदृश्य में सफल होने के लिए चाहिए।',
      'about.founder.vision.text3': 'मैंने माना कि सच्चा औद्योगिक विकास केवल प्रतिस्पर्धा से नहीं आता, बल्कि सहयोग, साझा सीखने और सामूहिक प्रगति से आता है। यह दर्शन आज भी IFM के काम का मार्गदर्शन करता है।',
      'about.founder.journey.title': 'संस्थापन यात्रा',
      'about.founder.journey.1995.title': '1995 -  व्हिजन',
      'about.founder.journey.1995.position': 'प्रारंभिक अवधारणा विकास',
      'about.founder.journey.1995.desc': 'औद्योगिक नीति में प्रारंभिक करियर के दौरान महाराष्ट्र में एकीकृत औद्योगिक निकाय की आवश्यकता को पहचाना',
      // Privacy Policy - Hindi
      'privacy.title': 'गोपनीयता नीति',
      'privacy.subtitle': 'आपकी गोपनीयता हमारे लिए महत्वपूर्ण है। यह नीति बताती है कि हम आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित करते हैं।',
      'privacy.lastUpdated': 'अंतिम अपडेट',
      'privacy.effectiveDate': 'प्रभावी तिथि',
      'privacy.tableOfContents': 'विषय सूची',
      'privacy.section.introduction': 'परिचय',
      'privacy.section.collection': 'हम जो जानकारी एकत्र करते हैं',
      'privacy.section.usage': 'हम आपकी जानकारी का उपयोग कैसे करते हैं',
      'privacy.section.sharing': 'जानकारी साझाकरण और प्रकटीकरण',
      'privacy.section.security': 'डेटा सुरक्षा',
      'privacy.section.cookies': 'कुकीज़ और ट्रैकिंग प्रौद्योगिकियां',
      'privacy.section.rights': 'आपके अधिकार',
      'privacy.section.retention': 'डेटा प्रतिधारण',
      'privacy.section.thirdParty': 'तीसरे पक्ष के लिंक',
      'privacy.section.children': 'बच्चों की गोपनीयता',
      'privacy.section.changes': 'इस गोपनीयता नीति में परिवर्तन',
      'privacy.section.contact': 'संपर्क करें',
      // Terms & Conditions - Hindi
      'terms.title': 'नियम और शर्तें',
      'terms.subtitle': 'कृपया हमारी सेवाओं का उपयोग करने से पहले इन नियमों को ध्यान से पढ़ें।',
      'terms.tableOfContents': 'विषय सूची',
      'terms.section.introduction': 'परिचय',
      'terms.section.acceptance': 'नियमों की स्वीकृति',
      'terms.section.membership': 'सदस्यता नियम',
      'terms.section.payment': 'भुगतान नियम',
      'terms.section.services': 'सेवाएं',
      'terms.section.responsibilities': 'उपयोगकर्ता जिम्मेदारियां',
      'terms.section.intellectual': 'बौद्धिक संपदा',
      'terms.section.liability': 'दायित्व की सीमा',
      'terms.section.indemnification': 'क्षतिपूर्ति',
      'terms.section.termination': 'समाप्ति',
      'terms.section.disputes': 'विवाद समाधान',
      'terms.section.governing': 'शासी कानून',
      'terms.section.contact': 'संपर्क करें',
      // Refund Policy - Hindi
      'refund.title': 'रिफंड और वापसी नीति',
      'refund.subtitle': 'हमारी सेवाओं के लिए रिफंड और वापसी के संबंध में महत्वपूर्ण जानकारी।',
      'refund.tableOfContents': 'विषय सूची',
      'refund.noRefundNotice': 'कोई रिफंड नीति नहीं',
      'refund.section.introduction': 'परिचय',
      'refund.section.noRefund': 'कोई रिफंड नीति नहीं',
      'refund.section.payment': 'भुगतान प्रसंस्करण',
      'refund.section.exceptions': 'सीमित अपवाद',
      'refund.section.nonRefundable': 'गैर-रिफंड योग्य परिदृश्य',
      'refund.section.membership': 'सदस्यता शुल्क',
      'refund.section.events': 'कार्यक्रम पंजीकरण',
      'refund.section.disputes': 'भुगतान विवाद',
      'refund.section.chargebacks': 'चार्जबैक',
      'refund.section.cancellation': 'IFM द्वारा रद्दीकरण',
      'refund.section.contact': 'रिफंड अनुरोध के लिए संपर्क करें',
      'refund.section.acknowledgment': 'पावती',
      // Policies Page - Hindi
      'policies.noPoliciesFound': 'कोई नीतियां नहीं मिलीं',
      'policies.tryAdjusting': 'अपने खोज या फ़िल्टर मानदंड को समायोजित करने का प्रयास करें।',
      'policies.downloadDocument': 'दस्तावेज़ डाउनलोड करें',
      'policies.updated': 'अपडेट किया गया',
      'policies.version': 'संस्करण',
      'policies.size': 'आकार',
      'about.founder.journey.2000.title': '2000 - स्थापना',
      'about.founder.journey.2000.position': 'IFM स्थापना',
      'about.founder.journey.2000.desc': 'प्रारंभिक 50 सदस्य कंपनियों के साथ आधिकारिक रूप से IFM की स्थापना की और मुंबई में पहला कार्यालय स्थापित किया',
      'about.founder.journey.2005.title': '2005 - विस्तार',
      'about.founder.journey.2005.position': 'क्षेत्रीय विकास',
      'about.founder.journey.2005.desc': 'पुणे, नागपुर और औरंगाबाद में कार्यों का विस्तार किया, क्षेत्रीय समितियों की स्थापना की',
      'about.founder.journey.2010.title': '2010 - मान्यता',
      'about.founder.journey.2010.position': 'सरकारी मान्यता',
      'about.founder.journey.2010.desc': 'महाराष्ट्र सरकार से Industrial Fedration of Maharashtra Region के रूप में आधिकारिक मान्यता प्राप्त की',
      'about.founder.achievements.title': 'मुख्य उपलब्धियां',
      'about.founder.achievements.item1': 'IFM को महाराष्ट्र के प्रमुख औद्योगिक निकाय के रूप में स्थापित किया',
      'about.founder.achievements.item2': 'सदस्यता को 50 से 500+ कंपनियों तक बढ़ाया',
      'about.founder.achievements.item3': 'व्यापक सहायता ढांचा बनाया',
      'about.founder.achievements.item4': 'सरकार-उद्योग साझेदारी स्थापित की',
      'about.founder.legacy.title': 'विरासत',
      'about.founder.legacy.item1': 'सतत औद्योगिक विकास मॉडल',
      'about.founder.legacy.item2': 'सहयोगात्मक शासन ढांचा',
      'about.founder.legacy.item3': 'सदस्य-केंद्रित सेवा  व्हिजनकोण',
      'about.founder.legacy.item4': 'नवाचार-संचालित विकास रणनीति',
      'about.founder.philosophy.title': 'संस्थापन दर्शन',
      'about.founder.philosophy.unity.title': 'विविधता में एकता',
      'about.founder.philosophy.unity.desc': 'पारस्परिक लाभ के लिए सभी आकार और क्षेत्रों के उद्योगों को एक छत के नीचे लाना।',
      'about.founder.philosophy.service.title': 'स्व से ऊपर सेवा',
      'about.founder.philosophy.service.desc': 'व्यक्तिगत या संगठनात्मक लाभों से ऊपर सदस्य आवश्यकताओं और औद्योगिक विकास को प्राथमिकता देना।',
      'about.founder.philosophy.innovation.title': 'नवाचार और उत्कृष्टता',
      'about.founder.philosophy.innovation.desc': 'बदलती औद्योगिक आवश्यकताओं और तकनीकी प्रगति को पूरा करने के लिए लगातार विकसित होना।',
      'about.founder.philosophy.sustainable.title': 'सतत विकास',
      'about.founder.philosophy.sustainable.desc': 'पर्यावरणीय जिम्मेदारी और सामाजिक प्रभाव के साथ आर्थिक विकास को संतुलित करना।',
      'about.founder.awards.title': 'पुरस्कार और मान्यता',
      'about.founder.awards.2015.title': 'औद्योगिक उत्कृष्टता पुरस्कार',
      'about.founder.awards.2015.org': 'महाराष्ट्र सरकार, 2015',
      'about.founder.awards.2018.title': 'जीवनकाल उपलब्धि पुरस्कार',
      'about.founder.awards.2018.org': 'फेडरेशन ऑफ इंडियन चैंबर्स, 2018',
      'about.founder.awards.2020.title': 'सामाजिक प्रभाव पुरस्कार',
      'about.founder.awards.2020.org': 'औद्योगिक विकास सोसाइटी, 2020',
      'about.founder.awards.2022.title': 'दूरदर्शी नेता पुरस्कार',
      'about.founder.awards.2022.org': 'Industrial Fedration of Maharashtra Region, 2022',
      'about.founder.continuing.title': 'विरासत को जारी रखना',
      'about.founder.continuing.growth.title': 'सदस्य विकास',
      'about.founder.continuing.growth.desc': 'हमारे संस्थापक द्वारा कल्पित व्यक्तिगत स्पर्श और गुणवत्तापूर्ण सेवा को बनाए रखते हुए हमारे सदस्य आधार का विस्तार जारी रखना।',
      'about.founder.continuing.innovation.title': 'नवाचार',
      'about.founder.continuing.innovation.desc': 'सहयोग और सेवा के मूल मूल्यों के प्रति सच्चे रहते हुए नई तकनीकों और पद्धतियों को अपनाना।',
      'about.founder.continuing.impact.title': 'सामाजिक प्रभाव',
      'about.founder.continuing.impact.desc': 'संस्थापन सिद्धांतों में कल्पित सतत विकास और सामुदायिक कल्याण पर ध्यान केंद्रित करना।',
      // About - Committee
      'about.committee.title': 'सदस्य समिति',
      'about.committee.subtitle': 'उन समर्पित नेताओं और विशेषज्ञों से मिलें जो IFM के मिशन और कार्यों का मार्गदर्शन करते हैं',
      'about.committee.leadership.title': 'संचालक मंडल',
      'about.committee.leadership.subtitle': 'IFM की रणनीतिक दिशा और दैनिक कार्यों का नेतृत्व करने वाले अनुभवी पेशेवर',
      'about.committee.structure.title': 'समिति संरचना',
      'about.committee.structure.subtitle': 'औद्योगिक सहायता के सभी पहलुओं के व्यापक कवरेज को सुनिश्चित करने वाली संगठित समितियां',
      'about.committee.responsibilities.title': 'समिति जिम्मेदारियां',
      'about.committee.responsibilities.subtitle': 'प्रभावी शासन और सेवा वितरण सुनिश्चित करने वाली स्पष्ट भूमिकाएं और जिम्मेदारियां',
      'about.committee.contact.title': 'हमारी समिति से संपर्क करें',
      'about.committee.contact.subtitle': 'विशिष्ट पूछताछ और सहायता के लिए हमारे समिति सदस्यों से संपर्क करें',
      'about.committee.contact.general.title': 'सामान्य पूछताछ',
      'about.committee.contact.secretary.title': 'समिति सचिव',
      'about.committee.contact.secretary.desc': 'समिति समन्वय',
      // About - Team
      'about.team.title': 'संचालक मंडल',
      'about.team.subtitle': 'अनुभवी पेशेवर जो IFM का नेतृत्व करते हैं',
      'about.team.director.name': 'निदेशक',
      'about.team.director.position': 'निदेशक',
      'about.team.director.department': 'कार्यकारी नेतृत्व',
      'about.team.director.experience': '20+ वर्षों का उद्योग अनुभव',
      'about.team.director.expertise': 'नीति, रणनीति, हितधारक सहयोग',
      'about.team.deputy.name': 'उप निदेशक',
      'about.team.deputy.position': 'उप निदेशक',
      'about.team.deputy.department': 'ऑपरेशन्स',
      'about.team.deputy.experience': '15+ वर्षों का संचालन प्रबंधन',
      'about.team.deputy.expertise': 'अनुपालन, प्रशिक्षण, सदस्य सेवाएँ',
      // About - Contact
      'about.contact.title': 'संपर्क जानकारी',
      'about.contact.subtitle': 'त्वरित सहायता के लिए सही विभाग से संपर्क करें',
      'about.contact.office.title': 'मुख्य कार्यालय',
      'about.contact.office.address': 'IFM कार्यालय, 3री मंजिल, बिजनेस प्लाज़ा, बांद्रा ईस्ट, मुंबई - 400051',
      'about.contact.phone.title': 'फोन सहायता',
      'about.contact.phone.number': '+91-22-1234-5678',
      'about.contact.phone.hours': 'सोम-शुक्र, सुबह 10 से शाम 6',
      'about.contact.email.title': 'ईमेल सहायता',
      'about.contact.email.address': 'info@ifm.gov.in',
      'about.contact.email.response': 'आम तौर पर 24-48 घंटे में उत्तर',
      'services.title': 'हमारी सहायता सेवाएं',
      'services.subtitle': 'आपकी औद्योगिक जरूरतों के लिए व्यापक समाधान',
      'services.loading': 'सेवाएं लोड हो रही हैं...',
      'services.noServices': 'कोई सेवाएं उपलब्ध नहीं हैं',
      // Services - CTA
      'services.cta.title': 'सेवा चुनने में मार्गदर्शन चाहिए?',
      'services.cta.subtitle': 'हमारी टीम आपकी आवश्यकता के अनुसार सही सहायता सुझाएगी।',
      'services.cta.contactTeam': 'IFM टीम से संपर्क करें',
      'services.cta.submitQuery': 'प्रश्न सबमिट करें',
      // Services - List items
      'service.mpcb.name': 'MPCB (प्रदूषण नियंत्रण मंडल)',
      'service.mpcb.shortDesc': 'कंसेंट, नवीनीकरण, वेस्ट प्राधिकरण, अनुपालन सहायता',
      'service.dish.name': 'DISH (औद्योगिक सुरक्षा और स्वास्थ्य)',
      'service.dish.shortDesc': 'फैक्टरी लाइसेंस, सुरक्षा ऑडिट, अनुपालन दस्तावेज़',
      'service.dic.name': 'DIC (जिला उद्योग केंद्र)',
      'service.dic.shortDesc': 'पंजीकरण, MSME सुविधा, प्रोत्साहन मार्गदर्शन',
      'service.cgwa.name': 'CGWA (भूजल प्राधिकरण)',
      'service.cgwa.shortDesc': 'बोरवेल अनुमति, नवीनीकरण, अनुपालन',
      'service.midc.name': 'MIDC (औद्योगिक विकास निगम)',
      'service.midc.shortDesc': 'प्लॉट आवंटन, उपयोगिताएँ, अनुमोदन समन्वय',
      'service.mseb.name': 'MSEB / MSEDCL (विद्युत)',
      'service.mseb.shortDesc': 'नया कनेक्शन, लोड वृद्धि, बिलिंग समस्याएँ',
      'service.chwtsdf.fullName': 'सामान्य खतरनाक अपशिष्ट उपचार, भंडारण और निपटान सुविधा (CHWTSDF) - ठोस अपशिष्ट प्रबंधन में एकाधिकार',
      'service.dish.fullName': 'औद्योगिक सुरक्षा और स्वास्थ्य निदेशालय (DISH)',
      'service.infrastructure.fullName': 'औद्योगिक बुनियादी ढांचा - MIDC, MSEB / MSEDCL',
      'service.cgwa.fullName': 'केंद्रीय भूजल प्राधिकरण (CGWA)',
      'service.anti-industry.fullName': 'उद्योग-विरोधी नीतियों पर पुनर्विचार',
      'service.mpcb.fullName': 'महाराष्ट्र प्रदूषण नियंत्रण मंडल (MPCB) - पर्यावरण और प्रदूषण नियंत्रण',
      'service.labor.fullName': 'श्रम कानून और औद्योगिक संबंध - श्रम विभाग',
      'service.tax.fullName': 'कर और वित्त विभाग',
      'service.water.fullName': 'जल आपूर्ति और पर्यावरण विभाग',
      'service.municipal.fullName': 'नगरपालिका और स्थानिक सरकार',
      'service.education.fullName': 'शिक्षा और कौशल विकास',
      'service.legal.fullName': 'कानूनी सहायता और शिकायतें',
      'service.policies.fullName': 'नई औद्योगिक नीतियां और प्रोत्साहन',
      'services.viewDetails': 'विवरण देखें',
      'service.labor.name': 'श्रम एवं अनुपालन',
      'service.labor.shortDesc': 'दुकान एवं स्थापना, CLRA, रजिस्टर और रिटर्न',
      'service.fairprice.name': 'फेयर प्राइस शॉप',
      'service.fairprice.shortDesc': 'उद्योग कैंटीन और आवश्यक आपूर्ति सहायता',
      'service.hazardous.name': 'खतरनाक कचरा प्रबंधन',
      'service.hazardous.shortDesc': 'प्राधिकरण, मेनिफेस्ट, परिवहन और निपटान सहायता',
      'contact.title': 'संपर्क करें',
      'contact.subtitle': 'हम आपके व्यवसाय को बढ़ने में मदद करने के लिए यहां हैं',
      'contact.info.title': 'संपर्क करें',
      'contact.info.subtitle': 'इनमें से किसी भी चैनल के माध्यम से हमसे संपर्क करें',
      'contact.info.address': 'पता',
      'contact.info.address.value': 'ऑफिस नं. 9, A-विंग, ज्वेल ऑफ पिंपरी, कमला क्रॉस रोड, पिंपरी, पुणे-411018',
      'contact.info.phone': 'फोन',
      'contact.info.phone.value1': '9067205252',
      'contact.info.phone.value2': '',
      'contact.info.email': 'ईमेल',
      'contact.info.email.value1': 'support@mahaifm.com',
      'contact.info.email.value2': 'Info@mahaifm.com',
      'contact.info.hours': 'कार्य समय',
      'contact.info.hours.monFri': 'सोम-शुक्र: सुबह 9:00 - शाम 6:00',
      'contact.info.hours.sat': 'शनि: सुबह 9:00 - दोपहर 1:00',
      'contact.info.hours.sun': 'रवि: सुबह 9:00 - दोपहर 1:00',
      // Footer
      'footer.quickLinks': 'त्वरित लिंक',
      'footer.resources': 'संसाधन',
      'footer.support': 'सहायता',
      'footer.services': 'सेवाएं',
      'footer.events': 'कार्यक्रम',
      'footer.news': 'समाचार',
      'footer.membership': 'सदस्यता',
      'footer.contactUs': 'संपर्क करें',
      'footer.grievance': 'शिकायत',
      'footer.memberRegistration': 'सदस्य पंजीकरण',
      'footer.renewMembership': 'सदस्यता नवीकरण',
      'footer.missionVision': 'मिशन और व्हिजन',
      'footer.workingHours': 'सोम-शुक्र: सुबह 9:00 - शाम 6:00 | शनि-रवि: सुबह 9:00 - दोपहर 1:00',
      'footer.designedBy': 'डिज़ाइन और विकसित',
      'footer.organizationName': 'Industrial Fedration of Maharashtra Region',
      'footer.legalPolicies': 'कानूनी और नीतियां',
      'footer.privacyPolicy': 'गोपनीयता नीति',
      'footer.termsConditions': 'नियम और शर्तें',
      'footer.refundPolicy': 'रिफंड नीति',
      // Navigation - Important Links (Hindi)
      'nav.importantLinks.rofPortal': 'ROF | पोर्टल',
      'nav.importantLinks.incomeTax': 'आयकर विभाग',
      'nav.importantLinks.mahagst': 'MAHAGST',
      'nav.importantLinks.aapleSarkar': 'आपले सरकार',
      'nav.importantLinks.esic': 'ESIC',
      'nav.importantLinks.epfo': 'EPFO',
      // Navigation - Social Media (Hindi)
      'nav.socialMedia.linkedin': 'LinkedIn',
      'nav.socialMedia.instagram': 'Instagram',
      'nav.socialMedia.facebook': 'Facebook',
      'nav.socialMedia.youtube': 'YouTube',
      'cta.gallery.title': 'IFM के बारे में और जानें',
      'cta.gallery.subtitle': 'हमारे नवीनतम कार्यक्रम, समाचार देखें और IFM गतिविधियों से अपडेट रहने के लिए हमसे जुड़ें।',
      'cta.gallery.viewNews': 'नवीनतम समाचार देखें',
      'cta.gallery.contact': 'संपर्क करें',
      'cta.news.title': 'IFM के साथ अपडेट रहें',
      'cta.news.subtitle': 'कोई अपडेट न चूकें। IFM से नवीनतम जानकारी के लिए हमारे कार्यक्रम, गैलरी और सेवाओं का अन्वेषण करें।',
      'cta.news.viewEvents': 'आगामी कार्यक्रम देखें',
      'cta.news.visitGallery': 'गैलरी देखें',
      'cta.mission.title': 'सेवा चुनने में मार्गदर्शन चाहिए?',
      'cta.mission.subtitle': 'हमारी समर्पित सहायता टीम आपकी मदद के लिए तैयार है। त्वरित सहायता के लिए नीचे दिए गए किसी भी चैनल के माध्यम से हमसे संपर्क करें।',
      'cta.mission.contact': 'संपर्क करें',
      'cta.mission.join': 'IFM में शामिल हों',
      'cta.service.title': 'शुरू करने के लिए तैयार हैं?',
      'cta.service.subtitle': 'अपनी पर्यावरणीय अनुपालन आवश्यकताओं के लिए व्यक्तिगत मार्गदर्शन के लिए हमारे विशेषज्ञों से संपर्क करें।',
      'cta.service.contact': 'संपर्क करें',
      'cta.service.viewAll': 'सभी सेवाएं देखें',
      'cta.president.title': 'सेवा चुनने में मार्गदर्शन चाहिए?',
      'cta.president.subtitle': 'हमारी समर्पित सहायता टीम आपकी मदद के लिए तैयार है। त्वरित सहायता के लिए नीचे दिए गए किसी भी चैनल के माध्यम से हमसे संपर्क करें।',
      'cta.president.contact': 'संपर्क करें',
      'cta.president.join': 'IFM में शामिल हों',
      'cta.about.title': 'Industrial Fedration में शामिल होने के लिए तैयार हैं?',
      'cta.about.subtitle': 'महाराष्ट्र के अग्रणी औद्योगिक समुदाय का हिस्सा बनें और विशेष लाभ, विशेषज्ञ सहायता और नेटवर्किंग अवसरों का लाभ उठाएं।',
      'cta.about.join': 'IFM में शामिल हों',
      'cta.about.learnMore': 'और जानें',
      'cta.events.title': 'एक कार्यक्रम आयोजित करना चाहते हैं?',
      'cta.events.subtitle': 'औद्योगिक समुदाय के लिए कार्यशालाएं, सेमिनार या प्रशिक्षण कार्यक्रम आयोजित करने के लिए IFM के साथ साझेदारी करें।',
      'cta.events.contact': 'संपर्क करें'
    }
  },
  mr: {
    name: 'मराठी',
    isDefault: false,
    content: {
      'nav.home': 'मुख्यपृष्ठ',
      'nav.about': 'आमच्याबद्दल',
      'nav.support': 'सहाय्य',
      'nav.events': 'कार्यक्रम',
      'nav.news': 'बातम्या',
      'nav.partners': 'भागीदार',
      'nav.membership': 'सदस्यता',
      'nav.gallery': 'गॅलरी',
      'nav.contact': 'संपर्क',
      'nav.socialMedia': 'सोशल मीडिया',
      'nav.importantLinks': 'महत्त्वाचे दुवे',
      // About Us submenu
      'nav.about.submenu.about': 'आमच्याबद्दल',
      'nav.about.submenu.president': 'अध्यक्ष प्रोफाइल',
      'nav.about.submenu.founder': 'संस्थापक',
      'nav.about.submenu.mission': 'मिशन आणि व्हिजन',
      'nav.about.submenu.values': 'मूल्ये',
      'nav.about.submenu.structure': 'संस्थात्मक रचना',
      'nav.about.submenu.leadershipTeam': 'संचालक मंडळ',
      'nav.about.submenu.achievements': 'आमची यशे',
      'nav.about.submenu.committee': 'सदस्य समिती',
      // News page
      'news.title': 'बातम्या आणि अद्यतने',
      'news.subtitle': 'उद्योग बातम्या, नियामक अद्यतने आणि IFM घोषणांबद्दल माहिती ठेवा.',
      // News Detail page
      'news.detail.loading': 'बातमी लेख लोड होत आहे...',
      'news.detail.notFound': 'बातमी सापडली नाही',
      'news.detail.notFoundDesc': 'तुम्ही शोधत असलेला बातमी लेख अस्तित्वात नाही किंवा काढून टाकला गेला आहे.',
      'news.detail.backToNews': 'बातम्यांकडे परत जा',
      'news.detail.recentNews': 'अलीकडील बातम्या',
      'news.detail.noRecentNews': 'अलीकडील बातम्या नाहीत',
      'news.detail.breakingNews': 'ताजी बातमी',
      'news.detail.noContent': 'या लेखासाठी सामग्री उपलब्ध नाही.',
      'news.detail.recently': 'अलीकडे',
      // News Categories (Marathi)
      'news.category.regulatoryUpdates': 'नियामक अद्यतने',
      'news.category.events': 'कार्यक्रम',
      'news.category.infrastructure': 'पायाभूत सुविधा',
      'news.category.environmental': 'पर्यावरणीय',
      'news.category.legalUpdates': 'कायदेशीर अद्यतने',
      'news.category.industryNews': 'उद्योग बातम्या',
      'news.category.policyUpdates': 'धोरण अद्यतने',
      'news.category.uncategorized': 'अवर्गीकृत',
      'news.filter': 'फिल्टर',
      'news.allCategories': 'सर्व श्रेण्या',
      'news.defaultAuthor': 'IFM संघ',
      'news.searchPlaceholder': 'बातम्या लेख शोधा...',
      'news.loading': 'बातम्या लेख लोड होत आहेत...',
      'news.noNewsAvailable': 'अद्याप कोणतेही बातम्या लेख उपलब्ध नाहीत. लवकरच पुन्हा तपासा!',
      'news.noArticlesMatch': 'कोणतेही लेख आपल्या सध्याच्या फिल्टरशी जुळत नाहीत.',
      'news.clearFilters': 'फिल्टर साफ करा',
      'news.article': 'लेख',
      'news.articles': 'लेख',
      'news.breaking': 'ताजी बातमी',
      'news.noNewsFound': 'बातम्या सापडल्या नाहीत',
      // Contact & Grievance Forms
      'contact.form.contactTab': 'सामान्य चौकशी',
      'contact.form.grievanceTab': 'तक्रार सबमिट करा',
      'contact.form.title': 'संपर्क साधा',
      'contact.form.subtitle': 'खालील फॉर्म भरा आणि आम्ही शक्य तितक्या लवकर तुमच्याशी संपर्क साधू.',
      'contact.form.name': 'पूर्ण नाव',
      'contact.form.email': 'ईमेल पत्ता',
      'contact.form.phone': 'फोन नंबर',
      'contact.form.company': 'कंपनी/संस्था',
      'contact.form.subject': 'विषय',
      'contact.form.message': 'संदेश',
      'contact.form.submit': 'संदेश पाठवा',
      'contact.form.success': 'संदेश यशस्वीरित्या पाठवला! आम्ही लवकरच तुमच्याशी संपर्क साधू.',
      'contact.form.error': 'संदेश पाठवण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      'grievance.form.subtitle': 'तुमच्या काळजीची नोंद करा आणि आम्ही त्वरित त्यांचे निराकरण करू.',
      'grievance.form.category': 'श्रेणी',
      'grievance.form.priority': 'प्राधान्य',
      'grievance.form.description': 'विवरण',
      'grievance.form.urgent': 'गरजूचे म्हणून चिन्हांकित करा',
      'grievance.form.submit': 'तक्रार सबमिट करा',
      'grievance.form.submitting': 'सबमिट करत आहे...',
      'grievance.form.success': 'तक्रार यशस्वीरित्या सबमिट केली! आम्ही लवकरच त्याचे निराकरण करू.',
      'grievance.form.error': 'तक्रार सबमिट करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      // Grievance Page Tabs
      'grievance.tab.submit': 'तक्रार सबमिट करा',
      'grievance.tab.track': 'तक्रार ट्रॅक करा',
      'grievance.tab.faq': 'FAQ आणि मदत',
      'grievance.form.title': 'नवीन तक्रार सबमिट करा',
      'grievance.form.name': 'पूर्ण नाव',
      'grievance.form.email': 'ईमेल पत्ता',
      'grievance.form.phone': 'फोन नंबर',
      'grievance.form.company': 'कंपनी / संस्था',
      'grievance.form.subjectLabel': 'तक्रार विषय',
      'grievance.form.descriptionLabel': 'तपशीलवार तक्रार वर्णन',
      'grievance.form.descriptionPlaceholder': 'कृपया तुमच्या तक्रारीचे तपशीलवार वर्णन करा. संबंधित तारखा, स्थाने, विभाग आणि कोणतीही सहाय्यक माहिती समाविष्ट करा...',
      'grievance.form.urgentLabel': 'गरजूचे म्हणून चिन्हांकित करा (तत्काल लक्ष देणे आवश्यक)',
      // Grievance Categories (Marathi)
      'grievance.category.general': 'सामान्य',
      'grievance.category.labour': 'कामगार',
      'grievance.category.environmental': 'पर्यावरणीय',
      'grievance.category.infrastructure': 'पायाभूत सुविधा',
      'grievance.category.compliance': 'अनुपालन',
      'grievance.category.technical': 'तांत्रिक',
      'grievance.category.safety': 'सुरक्षा',
      'grievance.category.pollution': 'प्रदूषण',
      'grievance.category.land': 'जमीन',
      'grievance.category.electricity': 'वीज',
      'grievance.category.water': 'पाणी',
      'grievance.category.roads': 'रस्ते',
      'grievance.category.waste': 'कचरा',
      'grievance.category.pricing': 'किंमत',
      'grievance.category.other': 'इतर',
      // Grievance Priorities (Marathi)
      'grievance.priority.low': 'कमी',
      'grievance.priority.medium': 'मध्यम',
      'grievance.priority.high': 'उच्च',
      'grievance.priority.urgent': 'गरजूचे',
      'grievance.priority.critical': 'गंभीर',
      'grievance.track.title': 'तुमच्या तक्रारी',
      'grievance.track.allCategories': 'सर्व श्रेणी',
      'grievance.track.noGrievances': 'तक्रारी सापडल्या नाहीत',
      'grievance.track.noGrievancesDesc': 'सुरुवात करण्यासाठी तुमची पहिली तक्रार सबमिट करा.',
      'grievance.track.submittedOn': 'सबमिट केले',
      'grievance.track.viewDetails': 'तपशील पहा',
      'grievance.faq.title': 'वारंवार विचारले जाणारे प्रश्न',
      'grievance.faq.q1': 'तक्रारीचे निराकरण करण्यासाठी किती वेळ लागतो?',
      'grievance.faq.a1': 'निराकरण वेळ तुमच्या समस्येच्या जटिलतेवर आणि प्राधान्यावर अवलंबून असतो. गंभीर समस्या सामान्यत: 24-48 तासांत हाताळल्या जातात, तर मानक समस्यांना 5-7 कामकाजाचे दिवस लागू शकतात.',
      'grievance.faq.q2': 'मी माझ्या तक्रारीची प्रगती ट्रॅक करू शकतो का?',
      'grievance.faq.a2': 'होय, तुम्ही सबमिट करताना प्रदान केलेल्या तिकीट क्रमांकाचा वापर करून तुमच्या तक्रारीची प्रगती ट्रॅक करू शकता. तुम्हाला ईमेलद्वारे नियमित अपडेट देखील मिळतील.',
      'grievance.faq.q3': 'माझ्या तक्रारीमध्ये मी कोणती माहिती समाविष्ट करावी?',
      'grievance.faq.a3': 'समस्येबद्दल विशिष्ट तपशील, संबंधित तारखा, कोणतीही कागदपत्रे किंवा पुरावा आणि तुमची संपर्क माहिती समाविष्ट करा. तुमचे वर्णन जितके तपशीलवार असेल, तितक्या लवकर आम्ही तुम्हाला मदत करू शकतो.',
      'grievance.faq.q4': 'माझ्या तक्रारीचे निराकरण झाले आहे की नाही हे मला कसे कळेल?',
      'grievance.faq.a4': 'तुम्हाला ईमेलद्वारे निराकरण सूचना मिळेल आणि स्थिती तुमच्या तक्रार ट्रॅकिंगमध्ये अपडेट केली जाईल. अपडेटसाठी तुम्ही आमच्या सहाय्य टीमशी देखील संपर्क साधू शकता.',
      'grievance.cta.title': 'तत्काल सहाय्य हवे आहे?',
      'grievance.cta.subtitle': 'गरजूच्या बाबतीसाठी, आमच्या 24/7 हेल्पलाइनशी संपर्क साधा किंवा थेट आमच्या सहाय्य टीमशी संपर्क साधा.',
      'grievance.cta.callHelpline': 'हेल्पलाइनवर कॉल करा',
      'grievance.cta.contactSupport': 'सहाय्याशी संपर्क साधा',
      // Contact Page CTA
      'contact.cta.title': 'तत्काल सहाय्य हवे आहे?',
      'contact.cta.subtitle': 'आमची समर्पित सहाय्य टीम तुमची मदत करण्यासाठी तयार आहे. त्वरित सहाय्यासाठी खालील कोणत्याही चॅनेलद्वारे आमच्याशी संपर्क साधा.',
      'contact.cta.callSupport': 'सहाय्यावर कॉल करा',
      'contact.cta.sendEmail': 'ईमेल पाठवा',
      // Admin Panel
      'admin.sidebar.dashboard': 'डॅशबोर्ड',
      'admin.sidebar.news': 'बातम्या',
      'admin.sidebar.events': 'कार्यक्रम',
      'admin.sidebar.eventRegistrations': 'कार्यक्रम नोंदणी',
      'admin.sidebar.members': 'सदस्य',
      'admin.sidebar.membershipPlans': 'सदस्यता योजना',
      'admin.sidebar.gallery': 'गॅलरी',
      'admin.sidebar.payments': 'पेमेंट',
      'admin.sidebar.contactEnquiries': 'संपर्क चौकशी',
      'admin.sidebar.grievances': 'तक्रारी',
      'admin.sidebar.activityLogs': 'क्रियाकलाप लॉग',
      'admin.sidebar.logout': 'लॉगआउट',
      'admin.sidebar.language': 'भाषा',
      'admin.sidebar.selectLanguage': 'भाषा निवडा',
      // Admin Common
      'admin.common.loading': 'लोड होत आहे...',
      'admin.common.error': 'त्रुटी',
      'admin.common.success': 'यशस्वी',
      'admin.common.save': 'सेव्ह करा',
      'admin.common.cancel': 'रद्द करा',
      'admin.common.delete': 'हटवा',
      'admin.common.edit': 'संपादन करा',
      'admin.common.create': 'तयार करा',
      'admin.common.update': 'अपडेट करा',
      'admin.common.add': 'जोडा',
      'admin.common.remove': 'हटवा',
      'admin.common.search': 'शोधा',
      'admin.common.filter': 'फिल्टर',
      'admin.common.clear': 'साफ करा',
      'admin.common.clearFilters': 'फिल्टर साफ करा',
      'admin.common.apply': 'लागू करा',
      'admin.common.submit': 'सबमिट करा',
      'admin.common.close': 'बंद करा',
      'admin.common.view': 'पहा',
      'admin.common.details': 'तपशील',
      'admin.common.back': 'मागे',
      'admin.common.next': 'पुढे',
      'admin.common.previous': 'मागील',
      'admin.common.page': 'पृष्ठ',
      'admin.common.of': 'चे',
      'admin.common.total': 'एकूण',
      'admin.common.noData': 'डेटा उपलब्ध नाही',
      'admin.common.confirm': 'पुष्टी करा',
      'admin.common.yes': 'होय',
      'admin.common.no': 'नाही',
      'admin.common.actions': 'क्रिया',
      'admin.common.status': 'स्थिती',
      'admin.common.date': 'तारीख',
      'admin.common.name': 'नाव',
      'admin.common.email': 'ईमेल',
      'admin.common.phone': 'फोन',
      'admin.common.organization': 'संस्था',
      'admin.common.category': 'श्रेणी',
      'admin.common.description': 'विवरण',
      'admin.common.notes': 'नोट्स',
      'admin.common.created': 'तयार केले',
      'admin.common.updated': 'अपडेट केले',
      // Admin Dashboard
      'admin.dashboard.title': 'डॅशबोर्ड',
      'admin.dashboard.loading': 'डॅशबोर्ड लोड होत आहे...',
      'admin.dashboard.error': 'डॅशबोर्ड आकडेवारी लोड करण्यात अयशस्वी',
      'admin.dashboard.totalMembers': 'एकूण सदस्य',
      'admin.dashboard.approved': 'मंजूर',
      'admin.dashboard.events': 'कार्यक्रम',
      'admin.dashboard.upcoming': 'आगामी',
      'admin.dashboard.newsArticles': 'बातम्या लेख',
      'admin.dashboard.published': 'प्रकाशित',
      'admin.dashboard.eventRegistrations': 'कार्यक्रम नोंदणी',
      'admin.dashboard.confirmed': 'पुष्टी',
      'admin.dashboard.totalRevenue': 'एकूण महसूल',
      'admin.dashboard.payments': 'पेमेंट',
      'admin.dashboard.recentActivity': 'अलीकडील क्रियाकलाप',
      'admin.dashboard.newMembers': 'नवीन सदस्य',
      'admin.dashboard.newEvents': 'नवीन कार्यक्रम',
      'admin.dashboard.newNews': 'नवीन बातम्या',
      'admin.dashboard.newRegistrations': 'नवीन नोंदणी',
      'admin.dashboard.newPayments': 'नवीन पेमेंट',
      'admin.dashboard.managementActions': 'व्यवस्थापन क्रिया',
      'admin.dashboard.manageMembers': 'सदस्य व्यवस्थापन',
      'admin.dashboard.manageMembersDesc': 'सर्व सदस्य नोंदणी पहा आणि व्यवस्थापित करा',
      'admin.dashboard.manageEvents': 'कार्यक्रम व्यवस्थापन',
      'admin.dashboard.manageEventsDesc': 'कार्यक्रम तयार करा, संपादित करा आणि व्यवस्थापित करा',
      'admin.dashboard.manageNews': 'बातम्या व्यवस्थापन',
      'admin.dashboard.manageNewsDesc': 'बातम्या लेख तयार करा आणि प्रकाशित करा',
      'admin.dashboard.eventRegistrationsDesc': 'कार्यक्रम नोंदणी पहा आणि व्यवस्थापित करा',
      'admin.dashboard.galleryManagement': 'गॅलरी व्यवस्थापन',
      'admin.dashboard.galleryManagementDesc': 'फोटो आणि व्हिडिओ अपलोड आणि व्यवस्थापित करा',
      'admin.dashboard.membershipPlansDesc': 'सदस्यता योजना आणि किंमत कॉन्फिगर करा',
      'admin.dashboard.paymentManagement': 'पेमेंट व्यवस्थापन',
      'admin.dashboard.paymentManagementDesc': 'पेमेंट इतिहास आणि व्यवहार पहा',
      'admin.dashboard.quickLinks': 'द्रुत दुवे',
      'admin.dashboard.memberRegistration': 'सदस्य नोंदणी',
      'admin.dashboard.viewAllMembers': 'सर्व सदस्य पहा',
      'admin.dashboard.createEvent': 'कार्यक्रम तयार करा',
      'admin.dashboard.viewAllEvents': 'सर्व कार्यक्रम पहा',
      'admin.dashboard.createNews': 'बातम्या तयार करा',
      'admin.dashboard.viewAllNews': 'सर्व बातम्या पहा',
      // Admin Members
      'admin.members.title': 'सदस्य',
      'admin.members.createNew': 'नवीन सदस्य तयार करा',
      'admin.members.editMember': 'सदस्य संपादन करा',
      'admin.members.viewMember': 'सदस्य तपशील',
      'admin.members.approve': 'सदस्य मंजूर करा',
      'admin.members.approved': 'मंजूर',
      'admin.members.reject': 'सदस्य नाकारा',
      'admin.members.activate': 'सदस्य सक्रिय करा',
      'admin.members.deactivate': 'सदस्य निष्क्रिय करा',
      'admin.members.createCashPayment': 'रोख पेमेंट तयार करा',
      'admin.members.cashPayment': 'रोख पेमेंट',
      'admin.members.amount': 'रक्कम',
      'admin.members.paymentDescription': 'पेमेंट वर्णन',
      'admin.members.pending': 'प्रलंबित',
      'admin.members.active': 'सक्रिय',
      'admin.members.inactive': 'निष्क्रिय',
      'admin.members.expired': 'कालबाह्य',
      'admin.members.completed': 'पूर्ण',
      'admin.members.failed': 'अयशस्वी',
      'admin.members.cancelled': 'रद्द',
      'admin.members.personName': 'व्यक्तीचे नाव',
      'admin.members.organizationName': 'संस्थेचे नाव',
      'admin.members.mobile': 'मोबाइल',
      'admin.members.location': 'स्थान',
      'admin.members.industry': 'उद्योग',
      'admin.members.membershipPlan': 'सदस्यता योजना',
      'admin.members.approvalStatus': 'मंजुरी स्थिती',
      'admin.members.paymentStatus': 'पेमेंट स्थिती',
      'admin.members.membershipStatus': 'सदस्यता स्थिती',
      'admin.members.registrationDate': 'नोंदणी तारीख',
      'admin.members.expiryDate': 'कालबाह्य तारीख',
      'admin.members.memberId': 'सदस्य ID',
      'admin.members.filterByStatus': 'स्थितीनुसार फिल्टर करा',
      'admin.members.filterByPayment': 'पेमेंटनुसार फिल्टर करा',
      'admin.members.filterByApproval': 'मंजुरीनुसार फिल्टर करा',
      'admin.members.all': 'सर्व',
      'admin.members.memberCreated': 'सदस्य यशस्वीरित्या तयार केला!',
      'admin.members.memberUpdated': 'सदस्य यशस्वीरित्या अपडेट केला!',
      'admin.members.memberDeleted': 'सदस्य यशस्वीरित्या हटवला!',
      'admin.members.memberApproved': 'सदस्य यशस्वीरित्या मंजूर!',
      'admin.members.memberRejected': 'सदस्य यशस्वीरित्या नाकारला!',
      'admin.members.memberActivated': 'सदस्य यशस्वीरित्या सक्रिय!',
      'admin.members.paymentCreated': 'रोख पेमेंट यशस्वीरित्या तयार केला!',
      'admin.members.fillRequired': 'कृपया सर्व आवश्यक फील्ड भरा',
      'admin.members.invalidEmail': 'कृपया वैध ईमेल पत्ता प्रविष्ट करा',
      'admin.members.invalidMobile': 'कृपया वैध 10-अंकी मोबाइल नंबर प्रविष्ट करा',
      // Admin News
      'admin.news.title': 'बातम्या',
      'admin.news.createNew': 'नवीन बातम्या तयार करा',
      'admin.news.editNews': 'बातम्या संपादन करा',
      'admin.news.titleLabel': 'शीर्षक',
      'admin.news.summary': 'सारांश',
      'admin.news.content': 'सामग्री',
      'admin.news.author': 'लेखक',
      'admin.news.category': 'श्रेणी',
      'admin.news.addCategory': 'श्रेणी जोडा',
      'admin.news.newCategory': 'नवीन श्रेणी',
      'admin.news.newsCreated': 'बातम्या यशस्वीरित्या तयार केली!',
      'admin.news.newsUpdated': 'बातम्या यशस्वीरित्या अपडेट केली!',
      'admin.news.newsDeleted': 'बातम्या यशस्वीरित्या हटवली!',
      'admin.news.filterByTitle': 'शीर्षकानुसार फिल्टर करा',
      'admin.news.filterByAuthor': 'लेखकानुसार फिल्टर करा',
      'admin.news.filterByCategory': 'श्रेणीनुसार फिल्टर करा',
      // Admin Events
      'admin.events.title': 'कार्यक्रम',
      'admin.events.createNew': 'नवीन कार्यक्रम जोडा',
      'admin.events.editEvent': 'कार्यक्रम संपादन करा',
      'admin.events.eventTitle': 'कार्यक्रम शीर्षक',
      'admin.events.eventDescription': 'कार्यक्रम वर्णन',
      'admin.events.startDate': 'सुरुवात तारीख',
      'admin.events.endDate': 'समाप्ती तारीख',
      'admin.events.startTime': 'सुरुवात वेळ',
      'admin.events.endTime': 'समाप्ती वेळ',
      'admin.events.location': 'स्थान',
      'admin.events.category': 'श्रेणी',
      'admin.events.imageUrl': 'प्रतिमा URL',
      'admin.events.registrationRequired': 'नोंदणी आवश्यक',
      'admin.events.maxParticipants': 'कमाल सहभागी',
      'admin.events.fees': 'फी',
      'admin.events.published': 'प्रकाशित',
      'admin.events.eventCreated': 'कार्यक्रम यशस्वीरित्या तयार केला!',
      'admin.events.eventUpdated': 'कार्यक्रम यशस्वीरित्या अपडेट केला!',
      'admin.events.eventDeleted': 'कार्यक्रम यशस्वीरित्या हटवला!',
      'admin.events.filterByTitle': 'शीर्षकानुसार फिल्टर करा',
      'admin.events.filterByCategory': 'श्रेणीनुसार फिल्टर करा',
      'admin.events.filterByStatus': 'स्थितीनुसार फिल्टर करा',
      // Admin Payments
      'admin.payments.title': 'पेमेंट',
      'admin.payments.paymentDetails': 'पेमेंट तपशील',
      'admin.payments.markCompleted': 'पेमेंट पूर्ण म्हणून चिन्हांकित करा',
      'admin.payments.approveMember': 'सदस्य मंजूर करा',
      'admin.payments.activateMember': 'सदस्य सक्रिय करा',
      'admin.payments.orderId': 'ऑर्डर ID',
      'admin.payments.memberName': 'सदस्य नाव',
      'admin.payments.memberEmail': 'सदस्य ईमेल',
      'admin.payments.amount': 'रक्कम',
      'admin.payments.paymentMethod': 'पेमेंट पद्धत',
      'admin.payments.online': 'ऑनलाइन',
      'admin.payments.cash': 'रोख',
      'admin.payments.gateway': 'गेटवे',
      'admin.payments.processedAt': 'प्रक्रिया केली',
      'admin.payments.filterByMethod': 'पेमेंट पद्धतीनुसार फिल्टर करा',
      'admin.payments.filterByStatus': 'स्थितीनुसार फिल्टर करा',
      // Admin Grievances
      'admin.grievances.title': 'तक्रारी',
      'admin.grievances.ticketNumber': 'तिकीट क्रमांक',
      'admin.grievances.submittedBy': 'द्वारे सबमिट केले',
      'admin.grievances.category': 'श्रेणी',
      'admin.grievances.priority': 'प्राधान्य',
      'admin.grievances.resolutionNotes': 'निराकरण नोट्स',
      'admin.grievances.updateResolution': 'निराकरण अपडेट करा',
      'admin.grievances.open': 'उघडा',
      'admin.grievances.inProgress': 'प्रगतीत',
      'admin.grievances.resolved': 'निराकरण',
      'admin.grievances.closed': 'बंद',
      'admin.grievances.low': 'कमी',
      'admin.grievances.medium': 'मध्यम',
      'admin.grievances.high': 'उच्च',
      'admin.grievances.urgent': 'तातडीचे',
      'admin.grievances.critical': 'गंभीर',
      'admin.grievances.filterByTicket': 'तिकीट क्रमांकानुसार फिल्टर करा',
      'admin.grievances.filterByStatus': 'स्थितीनुसार फिल्टर करा',
      'admin.grievances.filterByPriority': 'प्राधान्यानुसार फिल्टर करा',
      // Admin Contact
      'admin.contact.title': 'संपर्क चौकशी',
      'admin.contact.submissions': 'सबमिशन',
      'admin.contact.subject': 'विषय',
      'admin.contact.message': 'संदेश',
      'admin.contact.new': 'नवीन',
      'admin.contact.inProgress': 'प्रगतीत',
      'admin.contact.resolved': 'निराकरण',
      'admin.contact.closed': 'बंद',
      'admin.contact.filterByName': 'नावानुसार फिल्टर करा',
      'admin.contact.filterByEmail': 'ईमेलनुसार फिल्टर करा',
      'admin.contact.filterByStatus': 'स्थितीनुसार फिल्टर करा',
      // Admin Gallery
      'admin.gallery.title': 'गॅलरी',
      'admin.gallery.addPhoto': 'फोटो जोडा',
      'admin.gallery.addVideo': 'व्हिडिओ जोडा',
      'admin.gallery.bulkUpload': 'बल्क अपलोड',
      'admin.gallery.photos': 'फोटो',
      'admin.gallery.videos': 'व्हिडिओ',
      'admin.gallery.titleLabel': 'शीर्षक',
      'admin.gallery.description': 'वर्णन',
      'admin.gallery.imageUrl': 'प्रतिमा URL',
      'admin.gallery.videoUrl': 'व्हिडिओ URL',
      'admin.gallery.category': 'श्रेणी',
      'admin.gallery.photoAdded': 'फोटो यशस्वीरित्या जोडला!',
      'admin.gallery.videoAdded': 'व्हिडिओ यशस्वीरित्या जोडला!',
      // Admin Membership Plans
      'admin.plans.title': 'सदस्यता योजना',
      'admin.plans.createNew': 'नवीन सदस्यता योजना तयार करा',
      'admin.plans.editPlan': 'सदस्यता योजना संपादन करा',
      'admin.plans.planName': 'योजना नाव',
      'admin.plans.price': 'किंमत',
      'admin.plans.duration': 'कालावधी',
      'admin.plans.durationUnit': 'कालावधी युनिट',
      'admin.plans.features': 'वैशिष्ट्ये',
      'admin.plans.active': 'सक्रिय',
      'admin.plans.popular': 'लोकप्रिय',
      'admin.plans.planCreated': 'सदस्यता योजना यशस्वीरित्या तयार केली!',
      'admin.plans.planUpdated': 'सदस्यता योजना यशस्वीरित्या अपडेट केली!',
      'admin.plans.planDeleted': 'सदस्यता योजना यशस्वीरित्या हटवली!',
      // Admin Audit Logs
      'admin.logs.title': 'क्रियाकलाप लॉग',
      'admin.logs.action': 'क्रिया',
      'admin.logs.entityType': 'एकक प्रकार',
      'admin.logs.entityName': 'एकक नाव',
      'admin.logs.admin': 'एडमिन',
      'admin.logs.description': 'वर्णन',
      'admin.logs.timestamp': 'वेळ',
      'admin.logs.filterByAdmin': 'एडमिननुसार फिल्टर करा',
      'admin.logs.filterByEntity': 'एकक प्रकारानुसार फिल्टर करा',
      'admin.logs.filterByAction': 'क्रियेनुसार फिल्टर करा',
      // Admin Event Registrations
      'admin.registrations.title': 'कार्यक्रम नोंदणी',
      'admin.registrations.eventTitle': 'कार्यक्रम शीर्षक',
      'admin.registrations.participantName': 'सहभागी नाव',
      'admin.registrations.participantEmail': 'सहभागी ईमेल',
      'admin.registrations.participantMobile': 'सहभागी मोबाइल',
      'admin.registrations.registrationDate': 'नोंदणी तारीख',
      'admin.registrations.paymentStatus': 'पेमेंट स्थिती',
      'admin.registrations.status': 'स्थिती',
      'admin.registrations.registered': 'नोंदणी',
      'admin.registrations.confirmed': 'पुष्टी',
      'admin.registrations.cancelled': 'रद्द',
      'admin.registrations.filterByEvent': 'कार्यक्रमानुसार फिल्टर करा',
      'admin.registrations.filterByStatus': 'स्थितीनुसार फिल्टर करा',
      // Renewal Page
      'renewal.title': 'तुमची सदस्यता नूतनीकरण करा',
      'renewal.subtitle': 'तुमची सदस्यता योजना शोधण्यासाठी आणि नूतनीकरण करण्यासाठी तुमचा ग्राहक ID किंवा ईमेल प्रविष्ट करा',
      'renewal.searchLabel': 'ग्राहक ID किंवा ईमेल',
      'renewal.searchPlaceholder': 'तुमची योजना शोधण्यासाठी ग्राहक ID किंवा ईमेल प्रविष्ट करा',
      'renewal.search': 'शोधा',
      'renewal.searching': 'शोधत आहे...',
      'renewal.memberDetails': 'सदस्य तपशील',
      'renewal.memberName': 'सदस्याचे नाव',
      'renewal.organization': 'संस्था',
      'renewal.email': 'ईमेल',
      'renewal.mobile': 'मोबाइल',
      'renewal.memberId': 'सदस्य ID',
      'renewal.currentPlan': 'वर्तमान योजना',
      'renewal.expiryDate': 'सदस्यता समाप्ती तारीख',
      'renewal.daysRemaining': 'दिवस शिल्लक',
      'renewal.expired': 'समाप्त',
      'renewal.processing': 'प्रक्रिया करत आहे...',
      'renewal.renewButton': 'सदस्यता नूतनीकरण करा',
      'renewal.viewPlans': 'योजना पहा',
      'renewal.pendingApproval': 'तुमची सदस्यता मंजुरीसाठी प्रलंबित आहे. कृपया सहाय्यासाठी समर्थनाशी संपर्क साधा.',
      'renewal.needHelp': 'मदत हवी?',
      'renewal.helpText': 'जर तुम्ही तुमची सदस्यता शोधू शकत नसाल किंवा नूतनीकरणासाठी मदत हवी असेल, तर कृपया आमच्या समर्थन टीमशी संपर्क साधा.',
      'renewal.contactSupport': 'समर्थनाशी संपर्क साधा',
      'renewal.callUs': 'आम्हाला कॉल करा',
      'renewal.searchError': 'कृपया तुमचा ग्राहक ID किंवा ईमेल प्रविष्ट करा',
      'renewal.notFound': 'सदस्य सापडले नाही. कृपया तुमचा ग्राहक ID किंवा ईमेल तपासा.',
      'renewal.cta.title': 'IFM मध्ये नवीन आहात?',
      'renewal.cta.subtitle': 'Industrial Fedration of Maharashtra Regionात सामील व्हा आणि विशेष फायदे, तज्ञ सहाय्य आणि नेटवर्किंग संधी अनलॉक करा.',
      'renewal.cta.register': 'नवीन सदस्य नोंदणी',
      'renewal.cta.viewPlans': 'सदस्यता योजना पहा',
      // Registration Form
      'registration.title': 'सदस्य नोंदणी',
      'registration.subtitle': 'कृपया आपली सदस्य नोंदणी पूर्ण करण्यासाठी सर्व आवश्यक माहिती भरा.',
      'registration.personalDetails': 'वैयक्तिक तपशील',
      'registration.membershipInfo': 'सदस्यता माहिती',
      'registration.mobile': 'व्हॉट्सअॅप / मोबाइल नंबर',
      'registration.email': 'ईमेल पत्ता',
      'registration.emailPlaceholder': 'ईमेल पत्ता प्रविष्ट करा',
      'registration.applicantName': 'अर्जदाराचे नाव (श्री./श्रीमती/M/s.)',
      'registration.organizationName': 'संस्थेचे नाव',
      'registration.representativeName': 'प्रतिनिधीचे नाव',
      'registration.gender': 'लिंग',
      'registration.gender.male': 'पुरुष',
      'registration.gender.female': 'स्त्री',
      'registration.telephone': 'टेलिफोन',
      'registration.aadhar': 'आधार नंबर',
      'registration.pancard': 'पॅन कार्ड',
      'registration.address': 'पत्ता',
      'registration.state': 'राज्य',
      'registration.district': 'जिल्हा',
      'registration.city': 'शहर',
      'registration.pincode': 'पिनकोड',
      'registration.website': 'वेबसाइट',
      'registration.gst': 'जीएसटी नंबर',
      'registration.region': 'प्रदेश',
      'registration.memberDescription': 'सदस्य वर्णन',
      'registration.category': 'श्रेणी',
      'registration.natureOfBusiness': 'व्यवसायाचे स्वरूप',
      'registration.industry': 'उद्योग',
      'registration.industryPlaceholder': 'उद्योग प्रविष्ट करा',
      'registration.workerCount': 'कामगारांची संख्या',
      'registration.membershipType': 'सदस्यता प्रकार',
      'registration.startDate': 'सुरुवातीची तारीख',
      'registration.endDate': 'समाप्तीची तारीख',
      'registration.selectPlan': 'सदस्यता योजना निवडा',
      'registration.submit': 'नोंदणी सबमिट करा',
      'registration.submitting': 'सबमिट करत आहे...',
      'registration.success': 'नोंदणी यशस्वीरित्या सबमिट केली!',
      'registration.error': 'नोंदणी सबमिट करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      'registration.cta.title': 'आधीच सदस्य आहात?',
      'registration.cta.subtitle': 'सर्व IFM फायदे आणि सेवा मिळवत राहण्यासाठी तुमची विद्यमान सदस्यता नूतनीकरण करा.',
      'registration.cta.renew': 'सदस्यता नूतनीकरण करा',
      'registration.cta.viewPlans': 'सदस्यता योजना पहा',
      'registration.required': 'हे फील्ड आवश्यक आहे',
      'registration.invalidMobile': 'कृपया वैध 10-अंकी मोबाइल नंबर प्रविष्ट करा',
      'registration.invalidEmail': 'कृपया वैध ईमेल पत्ता प्रविष्ट करा',
      'registration.invalidPincode': 'कृपया वैध 6-अंकी पिनकोड प्रविष्ट करा',
      'registration.invalidAadhar': 'कृपया वैध 12-अंकी आधार नंबर प्रविष्ट करा',
      'registration.invalidPAN': 'कृपया वैध पॅन कार्ड नंबर प्रविष्ट करा',
      'registration.selectPlanError': 'कृपया सदस्यता योजना निवडा',
      'registration.processing': 'नोंदणी प्रक्रिया करत आहे...',
      'registration.redirecting': 'पेमेंटवर पुनर्निर्देशित करत आहे...',
      'registration.submitButton': 'नोंदणी करा आणि पेमेंट करा',
      'registration.termsPrefix': 'हा फॉर्म सबमिट करून, आपण आमच्या',
      'registration.termsAnd': 'आणि',
      'registration.securePayment': 'सुरक्षित पेमेंट',
      'registration.dataProtected': 'डेटा संरक्षित',
      'registration.instantConfirmation': 'तत्काळ पुष्टी',
      // Gallery page
      'gallery.title': 'मीडिया गॅलरी',
      'gallery.subtitle': 'आमच्या कार्यक्रम, कार्यशाळा आणि औद्योगिक उपक्रमांचे फोटो व व्हिडिओ पहा.',
      // Gallery (Marathi)
      'gallery.tab.photos': 'फोटो गॅलरी',
      'gallery.tab.videos': 'व्हिडिओ गॅलरी',
      'gallery.photo.defaultTitle': 'फोटो',
      'gallery.photo.untitled': 'अनाम फोटो',
      'gallery.photo.noDescription': 'विवरण नाही',
      'gallery.video.defaultTitle': 'व्हिडिओ थंबनेल',
      'gallery.video.untitled': 'अनाम व्हिडिओ',
      'gallery.video.noDescription': 'विवरण नाही',
      'gallery.category.uncategorized': 'अवर्गीकृत',
      'gallery.aria.closeImage': 'छवी बंद करा',
      'gallery.aria.nextImage': 'पुढील छवी',
      'gallery.aria.closeVideo': 'व्हिडिओ बंद करा',
      'gallery.noPhotos': 'कोणतेही फोटो उपलब्ध नाहीत',
      'gallery.noPhotosDesc': 'प्रशासकांकडून अपलोड केल्यानंतर फोटो येथे दिसतील.',
      'gallery.noVideos': 'कोणतेही व्हिडिओ उपलब्ध नाहीत',
      'gallery.noVideosDesc': 'प्रशासकांकडून अपलोड केल्यानंतर व्हिडिओ येथे दिसतील.',
      'home.title': 'Industrial Fedration of Maharashtra Region',
      'home.subtitle': 'उद्योगांना सक्षम करणे, महाराष्ट्राचे निर्माण',
      'home.exploreSupport': 'सहाय्य पाहा',
      'home.learnMore': 'अधिक जाणून घ्या',
      'home.whyChooseUs': 'आम्हाला का निवडाल?',
      'home.whyChooseUsDesc': 'वाढ, अनुपालन आणि वकिलीसाठी विश्वासार्ह भागीदार',
      'home.whyChooseUs.title': 'आम्हाला का निवडाल?',
      'home.whyChooseUs.subtitle': 'महाराष्ट्राच्या औद्योगिक परिदृश्यात आपल्या व्यवसायाला यशस्वी होण्यास मदत करण्यासाठी आम्ही व्यापक सहाय्य आणि तज्ञ मार्गदर्शन प्रदान करतो.',
      'home.whyChooseUs.feature1.title': 'बहु-विभागीय समन्वय',
      'home.whyChooseUs.feature1.desc': 'बहु-विभागीय सरकारी समन्वयाची मजबूत साखळी',
      'home.whyChooseUs.feature2.title': 'तज्ञ अनुपालन मार्गदर्शन',
      'home.whyChooseUs.feature2.desc': 'अनुपालन आणि कायदेशीर जोखीम कमी करण्यावर तज्ञ मार्गदर्शन',
      'home.whyChooseUs.feature3.title': 'द्रुत समस्या निराकरण',
      'home.whyChooseUs.feature3.desc': 'समस्या सोडवण्यासाठी द्रुत आणि प्रभावी प्रतिनिधित्व',
      'home.whyChooseUs.feature4.title': 'शाश्वत व्यावसायिक संस्कृती',
      'home.whyChooseUs.feature4.desc': 'शाश्वतता, सुरक्षा आणि कायदेशीर व्यावसायिक संस्कृतीवर भर',
      'home.whyChooseUs.feature5.title': 'सरकारी लाभ प्रवेश',
      'home.whyChooseUs.feature5.desc': 'सरकारी योजना आणि लाभांचा पूर्ण वापर सुनिश्चित करणारी सहायता',
      'home.whyChooseUs.feature6.title': 'उद्योग नेटवर्किंग आणि सहकार्य',
      'home.whyChooseUs.feature6.desc': 'उद्योग नेते यांच्याशी जोडा, उत्तम सराव सामायिक करा आणि महाराष्ट्रातील औद्योगिक वाढीस चालना देणाऱ्या उपक्रमांवर सहकार्य करा',
      'home.whyChooseUs.feature7.title': 'प्रशिक्षण आणि विकास कार्यक्रम',
      'home.whyChooseUs.feature7.desc': 'कार्यबल क्षमता आणि उद्योग मानके वाढवण्यासाठी व्यापक प्रशिक्षण कार्यक्रम, कार्यशाळा आणि कौशल्य विकास उपक्रम',
      'home.president.experienceLabel': 'अनुभव',
      'home.president.backgroundLabel': 'पार्श्वभूमी',
      'home.recentNewsTitle': 'अलीकडील बातम्या आणि घोषणा',
      'home.recentNewsSubtitle': 'IFM कडील ताज्या बातम्या, अद्यतने आणि कार्यक्रम जाणून घ्या',
      'home.upcomingEvents': 'येणारी कार्यक्रम',
      'home.feature1.title': 'नियामक सहाय्य',
      'home.feature1.desc': 'अनुपालन आणि नियमांवर तज्ञ मार्गदर्शन',
      'home.feature2.title': 'उद्योग नेटवर्किंग',
      'home.feature2.desc': 'सहकारी उद्योगपतींशी जोडा',
      'home.feature3.title': 'प्रशिक्षण कार्यक्रम',
      'home.feature3.desc': 'व्यावसायिक विकासाच्या संधी',
      'home.feature4.title': 'वकिली',
      'home.feature4.desc': 'उद्योग हितांचे प्रतिनिधित्व',
      // Home - Quick Links
      'home.quickLinks': 'त्वरित दुवे',
      'home.quickLinksDesc': 'पोर्टलचे सामान्य विभाग लवकर उघडा',
      // Home - Companies
      'home.companies.title': 'आमच्याशी संलग्न कंपन्या',
      'home.companies.subtitle': 'IFM सोबत कार्य करणारे विश्वासार्ह भागीदार आणि उद्योग सहयोगी',
      'home.companies.emptyTitle': 'कंपन्या लवकरच',
      'home.companies.emptyDesc': 'आम्ही भागीदार कंपन्या जोडत आहोत आणि लवकरच येथे दर्शवू.',
      'home.companies.viewAll': 'सर्व भागीदार पहा',
      // Partners Page
      'partners.title': 'आमचे भागीदार',
      'partners.subtitle': 'IFM सोबत संलग्न कंपन्या आणि उद्योग सहयोग पाहा.',
      'partners.filters': 'फिल्टर्स',
      'partners.searchPlaceholder': 'कंपनी नाव किंवा टॅगलाइन शोधा',
      'partners.filterAll': 'सर्व कंपन्या',
      'partners.filterWithWebsite': 'वेबसाइट असलेले',
      'partners.filterWithoutWebsite': 'वेबसाइट नसलेले',
      'partners.loading': 'कंपन्या लोड होत आहेत...',
      'partners.emptyTitle': 'कंपन्या सापडल्या नाहीत',
      'partners.emptyDesc': 'कृपया फिल्टर बदला किंवा नंतर पुन्हा पाहा.',
      'partners.visitWebsite': 'वेबसाइट पाहा',
      'partners.noWebsite': 'वेबसाइट लिंक उपलब्ध नाही',
      'partners.back': 'मागे जा',
      'partners.homeLink': 'होम वर जा',
      'home.viewAllNews': 'सर्व बातम्या पहा',
      'home.viewAllEvents': 'सर्व कार्यक्रम पहा',
      'home.quickLink1.title': 'सहाय्य सेवांचा शोध घ्या',
      'home.quickLink1.desc': 'नियामक, अनुपालन आणि सल्लागार सहाय्य',
      'home.quickLink2.title': 'येणारी कार्यक्रम',
      'home.quickLink2.desc': 'कार्यशाळा, सेमिनार आणि नेटवर्किंग',
      'home.quickLink3.title': 'फोटो गॅलरी',
      'home.quickLink3.desc': 'अलीकडील कार्यक्रम आणि उपक्रम पहा',
      // Home - Contact
      'home.contactUs': 'आमच्याशी संपर्क साधा',
      'home.contactUsDesc': 'मदत आणि माहितीसाठी संपर्क करा',
      'home.contact.phone': 'फोन',
      'home.contact.email': 'ईमेल',
      'home.contact.address': 'कार्यालयाचा पत्ता',
      'home.contact.addressValue': 'IFM कार्यालय, ३रा मजला, बिझनेस प्लाझा, बांद्रा ईस्ट, मुंबई - 400051',
      'home.contact.followUs': 'आमचे अनुसरण करा',
      'home.contact.quickLinks': 'द्रुत दुवे',
      'home.contact.aboutUs': 'आमच्याबद्दल',
      'home.contact.missionVision': 'मिशन आणि व्हिजन',
      'home.contact.committee': 'समिती',
      'home.contact.presidentMessage': 'अध्यक्ष संदेश',
      'home.contact.copyright': 'सर्व हक्क सुरक्षित',
      'home.readMore': 'अधिक वाचा',
      'home.news.label': 'बातम्या',
      'home.event.label': 'कार्यक्रम',
      // About - Hero
      'about.title': 'IFM बद्दल',
      'about.subtitle': 'महाराष्ट्राच्या औद्योगिक विकासाचे नेतृत्व',
      // About - Vision & Mission
      'about.vision.title': 'आमचे व्हिजन',
      'about.vision.desc': 'एक एकसंध, अनुपालनशील आणि प्रगतिशील औद्योगिक परिसंस्था निर्माण करणे जी शाश्वत वाढ, नियामकीय अनुपालन आणि उद्योग व शासकीय प्राधिकरणांमधील परस्पर सहकार्याला प्रोत्साहन देते.',
      'about.mission.title': 'आमचे मिशन',
      'about.mission.subtitle': 'उद्योगांसाठी एक सक्रिय आणि परिणामाभिमुख मंच म्हणून कार्य करणे, जो प्रभावी समन्वय, तज्ज्ञ प्रतिनिधित्व आणि धोरणात्मक वकिलीच्या माध्यमातून महत्त्वाच्या नियामकीय, पायाभूत आणि प्रशासकीय आव्हानांचे निराकरण करतो.',
      'about.mission.desc': 'उद्योगांसाठी एक सक्रिय आणि परिणामाभिमुख मंच म्हणून कार्य करणे, जो प्रभावी समन्वय, तज्ज्ञ प्रतिनिधित्व आणि धोरणात्मक वकिलीच्या माध्यमातून महत्त्वाच्या नियामकीय, पायाभूत आणि प्रशासकीय आव्हानांचे निराकरण करतो.',
      // Events
      'events.title': 'कार्यक्रम आणि कार्यक्रम',
      'events.subtitle': 'आमच्या नवीनतम कार्यशाळा, सेमिनार, प्रशिक्षण कार्यक्रम आणि उद्योग कार्यक्रमांबद्दल अद्ययावत रहा.',
      'events.searchPlaceholder': 'कार्यक्रम शोधा...',
      'events.allCategories': 'सर्व श्रेण्या',
      'events.loading': 'कार्यक्रम लोड होत आहेत...',
      'events.noEventsFound': 'कार्यक्रम सापडले नाहीत',
      'events.tryAdjusting': 'कृपया आपली शोध किंवा फिल्टर निकष समायोजित करण्याचा प्रयत्न करा.',
      'events.viewDetails': 'तपशील पहा',
      'events.recentEvents': 'अलीकडील कार्यक्रम',
      'events.noRecentEvents': 'अलीकडील कार्यक्रम नाहीत',
      'events.free': 'मोफत',
      'events.status.upcoming': 'आगामी',
      'events.status.ongoing': 'चालू आहे',
      'events.status.completed': 'पूर्ण',
      'events.dateTBD': 'तारीख निश्चित नाही',
      'events.locationTBD': 'स्थान निश्चित नाही',
      // Event Detail
      'events.detail.backToEvents': 'कार्यक्रमांवर परत जा',
      'events.detail.notFound': 'कार्यक्रम सापडला नाही',
      'events.detail.notFoundDesc': 'आपण शोधत असलेला कार्यक्रम अस्तित्वात नाही किंवा काढून टाकला गेला आहे.',
      'events.detail.loading': 'कार्यक्रम तपशील लोड होत आहेत...',
      'events.detail.registration': 'कार्यक्रम नोंदणी',
      'events.detail.registrationClosed': 'नोंदणी बंद',
      'events.detail.registrationClosedDesc': 'हे कार्यक्रम आधीच संपले आहे.',
      'events.detail.registrationNotAvailable': 'नोंदणी उपलब्ध नाही',
      'events.detail.registrationNotAvailableDesc': 'हे कार्यक्रम सध्या नोंदणीसाठी खुले नाही.',
      'events.detail.eventFull': 'कार्यक्रम भरले',
      'events.detail.eventFullDesc': 'जास्तीत जास्त सहभागी पोहोचले',
      'events.detail.registrationFee': 'नोंदणी शुल्क',
      'events.detail.freeEvent': 'मोफत कार्यक्रम',
      'events.detail.registerNow': 'आत्ता नोंदणी करा',
      'events.detail.eventInformation': 'कार्यक्रम माहिती',
      'events.detail.capacity': 'क्षमता',
      'events.detail.participants': 'सहभागी',
      'events.detail.fee': 'शुल्क',
      'events.detail.registrationRequired': 'नोंदणी',
      'events.detail.required': 'आवश्यक',
      'events.detail.otherEvents': 'इतर कार्यक्रम',
      // Login (Marathi)
      'login.title': 'तुमच्या खात्यात साइन इन करा',
      'login.email': 'ईमेल पत्ता',
      'login.emailPlaceholder': 'तुमचा ईमेल प्रविष्ट करा',
      'login.emailRequired': 'ईमेल आवश्यक आहे',
      'login.emailInvalid': 'अवैध ईमेल पत्ता',
      'login.password': 'पासवर्ड',
      'login.passwordPlaceholder': 'तुमचा पासवर्ड प्रविष्ट करा',
      'login.passwordRequired': 'पासवर्ड आवश्यक आहे',
      'login.passwordMinLength': 'पासवर्ड किमान 6 वर्ण असावे',
      'login.rememberMe': 'मला लक्षात ठेवा',
      'login.forgotPassword': 'तुमचा पासवर्ड विसरलात?',
      'login.signIn': 'साइन इन करा',
      'login.signingIn': 'साइन इन करत आहे...',
      'login.success': 'लॉगिन यशस्वी!',
      'login.invalidCredentials': 'अवैध क्रेडेंशियल',
      'login.error': 'लॉगिन अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      // Event Registration (Marathi)
      'eventRegistration.mobileRequired': 'मोबाइल नंबर आवश्यक आहे',
      'eventRegistration.mobileInvalid': 'कृपया वैध 10-अंकीय मोबाइल नंबर प्रविष्ट करा',
      'eventRegistration.emailRequired': 'ईमेल आवश्यक आहे',
      'eventRegistration.emailInvalid': 'कृपया वैध ईमेल पत्ता प्रविष्ट करा',
      'eventRegistration.nameRequired': 'सहभागीचे नाव आवश्यक आहे',
      'eventRegistration.nameMinLength': 'सहभागीचे नाव किमान 2 वर्ण असावे',
      'eventRegistration.pincodeInvalid': 'कृपया वैध 6-अंकीय पिनकोड प्रविष्ट करा',
      'eventRegistration.namePlaceholder': 'तुमचे पूर्ण नाव प्रविष्ट करा',
      'eventRegistration.emailPlaceholder': 'तुमचा ईमेल पत्ता प्रविष्ट करा',
      'eventRegistration.designationPlaceholder': 'तुमचे पदनाम प्रविष्ट करा (पर्यायी)',
      'eventRegistration.addressPlaceholder': 'तुमचा पत्ता प्रविष्ट करा (पर्यायी)',
      'eventRegistration.registerAndPay': 'नोंदणी करा आणि पेमेंटसाठी पुढे जा',
      'eventRegistration.completeRegistration': 'नोंदणी पूर्ण करा',
      'eventRegistration.dismissError': 'त्रुटी रद्द करा',
      'eventRegistration.redirectingToPayment': 'पेमेंटवर पुनर्निर्देशित करत आहे...',
      'eventRegistration.redirectingToPaymentGateway': 'पेमेंट गेटवेवर पुनर्निर्देशित करत आहे',
      'eventRegistration.addressDetails': 'पत्ता तपशील',
      'eventRegistration.pleaseWaitRedirect': 'कृपया प्रतीक्षा करा जोपर्यंत आम्ही तुम्हाला पेमेंट पूर्ण करण्यासाठी पुनर्निर्देशित करतो...',
      // Policies (Marathi)
      'policies.title': 'धोरणे आणि मार्गदर्शक तत्त्वे',
      'policies.subtitle': 'औद्योगिक अनुपालन आणि सर्वोत्तम प्रथांसाठी व्यापक धोरणे, मार्गदर्शक तत्त्वे आणि नियामक दस्तऐवजांना प्रवेश.',
      'policies.searchPlaceholder': 'धोरणे शोधा...',
      'policies.allCategories': 'सर्व श्रेण्या',
      'policies.category.membership': 'सदस्यत्व',
      'policies.category.environmental': 'पर्यावरणीय',
      'policies.category.safety': 'सुरक्षा',
      'policies.category.labor': 'कामगार',
      'policies.category.infrastructure': 'पायाभूत सुविधा',
      // Event Categories (Marathi)
      'events.category.workshop': 'कार्यशाळा',
      'events.category.seminar': 'सेमिनार',
      'events.category.training': 'प्रशिक्षण',
      'events.category.meeting': 'बैठक',
      'events.category.conference': 'परिषद',
      'events.category.webinar': 'वेबिनार',
      'events.category.exhibition': 'प्रदर्शनी',
      'events.category.general': 'सामान्य',
      'events.filter': 'फिल्टर',
      'events.detail.registered': 'नोंदणीकृत',
      // Membership (UI text)
      'membership.title': 'सदस्यत्व',
      'membership.subtitle': 'IFM मध्ये सहभागी व्हा आणि सहाय्य, साधने व नेटवर्किंगचा लाभ घ्या.',
      'membership.benefits.title': 'सदस्यत्वाचे फायदे',
      'membership.benefits.subtitle': 'महाराष्ट्रातील उद्योगांसाठी घडवलेले ठोस लाभ',
      'membership.benefits.regulatory.title': 'नियामक सहाय्य',
      'membership.benefits.regulatory.desc': 'अनुपालन, फायलिंग, तपासणी व मंजुरींसाठी मार्गदर्शन',
      'membership.benefits.infrastructure.title': 'आधारभूत सुविधा',
      'membership.benefits.infrastructure.desc': 'सुविधा, जमीन, परवानग्या आणि समन्वयात मदत',
      'membership.benefits.networking.title': 'नेटवर्किंग',
      'membership.benefits.networking.desc': 'समविचारी उद्योग, तज्ज्ञ व अधिकाऱ्यांशी जोडा',
      'membership.benefits.documentation.title': 'दस्तऐवजीकरण',
      'membership.benefits.documentation.desc': 'टेम्पलेट्स, चेकलिस्ट आणि कागदपत्रांमध्ये सहाय्य',
      'membership.benefits.training.title': 'प्रशिक्षण व कार्यशाळा',
      'membership.benefits.training.desc': 'कौशल्य व जागरूकतेसाठी नियमित कार्यक्रम',
      'membership.benefits.support.title': 'समर्पित सहाय्य',
      'membership.benefits.support.desc': 'प्राधान्य प्रतिसाद व केस फॉलो-अप',
      'membership.whyChoose.title': 'IFM सदस्यत्व का निवडा?',
      'membership.whyChoose.network.title': 'उद्योग नेटवर्क',
      'membership.whyChoose.network.desc': 'सहकाऱ्यांना आणि तज्ञांशी जोडा',
      'membership.whyChoose.regulatory.title': 'नियामक सहाय्य',
      'membership.whyChoose.regulatory.desc': 'अनुपालनावर तज्ञ मार्गदर्शन',
      'membership.whyChoose.infrastructure.title': 'पायाभूत सुविधा मदत',
      'membership.whyChoose.infrastructure.desc': 'उपयोगिता आणि परवानग्यांमध्ये सहायता',
      'membership.whyChoose.documentation.title': 'दस्तऐवजीकरण',
      'membership.whyChoose.documentation.desc': 'टेम्प्लेट आणि चेकलिस्ट',
      'membership.benefits.core.title': 'मुख्य फायदे',
      // Detailed IFM Membership Benefits (Marathi)
      'membership.benefits.long.title': 'सविस्तर सदस्यत्व फायदे',
      'membership.benefits.long.items': [
        'IFM सदस्यत्व तुम्हाला जगभरातील व्यवसाय आणि संस्थांच्या वाढत्या सहयोगाशी जोडते आणि स्थानिक बाजारपेठेतील बदलत्या प्रवाहांबद्दल अद्ययावत ठेवते.',
        'व्यवसाय निर्मिती: व्यापार, वाणिज्य आणि कृषी समुदायासाठी B2B संधी व नेटवर्किंगद्वारे अधिक व्यवसाय चालना.',
        'निर्यातकांसाठी उत्पत्ती प्रमाणपत्र मार्गदर्शन (FTAs/कस्टमसाठी आवश्यक).',
        'कायदेशीर कागदपत्रांचे अटेस्टेशन (POA, करारपत्र, अनुवाद, व्हिसा पत्र, इ.).',
        'मासिक पत्रिका/न्यूजलेटर: धोरण अद्यतने, लेख, कार्यक्रम व उपलब्धी.',
        'कार्यक्रम व उपक्रम: B2B, नेटवर्किंग, पुरस्कार, राउंडटेबल, एक्सपो इत्यादी.',
        'आंतरराष्ट्रीय व्यापार प्रोत्साहन व प्रतिनिधीमंडळ.',
        'विविध शासकीय संस्थांमध्ये प्रतिनिधित्व आणि नामनिर्देशने.',
        'वेब सेवा: नोंदणी, सर्क्युलर, प्रेस नोट, प्रकाशने, कायदेशीर अद्ययने, फॉर्म.',
        'दृश्यमानता वाढ: वेबसाइट डायरेक्टरी, ई-न्यूजलेटर, मार्केटिंग संधी.',
        'व्हिसा शिफारस पत्र.',
        'प्रशिक्षण कार्यक्रम: एक्सिम, उद्योजकता, स्टार्टअप, कर, वित्त, कौशल्यवर्धन.',
        'साप्ताहिक आर्थिक अपडेट्स.',
        'SMS अलर्ट: कर/GST, अनुपालन अंतिम मुदती, कार्यक्रम निमंत्रणे, धोरण बदल, संधी.',
        'ट्रेड/बिझनेस डेलीगेशन; परिषद, परिसंवाद, कार्यशाळा.',
        'तज्ज्ञ समित्यांपर्यंत प्रवेश; धोरण वकालत व वाद निराकरण.',
        'IFM सभागृह बुकिंग सवलतीच्या दरात.',
        'सदस्य निर्देशिकेचा प्रवेश (B2B नेटवर्किंग).'
      ],
      'membership.plans.title': 'सदस्यत्व योजना',
      'membership.plans.subtitle': 'तुमच्या संस्थेला अनुकूल अशी योजना निवडा',
      'membership.eligibility.title': 'पात्रता',
      'membership.eligibility.subtitle': 'IFM सदस्यत्वासाठी कोण अर्ज करू शकतो',
      'membership.eligibility.item1': 'नोंदणीकृत औद्योगिक संस्था किंवा MSME',
      'membership.eligibility.item2': 'वैध व्यावसायिक व ओळख दस्तऐवज',
      'membership.eligibility.item3': 'लागू कायद्यांचे पालन',
      'membership.eligibility.item4': 'IFM आचारसंहितेची स्वीकृती',
      'membership.eligibility.item5': 'सदस्यत्व शुल्क वेळेवर भरणे',
      'membership.eligibility.item6': 'डेटा व संप्रेषण धोरणांशी सहमती',
      'membership.requirements.title': 'दस्तऐवज आवश्यकताएं',
      'membership.requirements.item1': 'उद्योग / MSME नोंदणी (लागू असल्यास)',
      'membership.requirements.item2': 'GST नोंदणी प्रमाणपत्र',
      'membership.requirements.item3': 'PAN कार्ड (कंपनी/मालक)',
      'membership.requirements.item4': 'स्थळाचा पत्ता पुरावा',
      'membership.requirements.item5': 'अधिकृत स्वाक्षरीदाराचा ओळख पुरावा',
      'membership.requirements.item6': 'कंपनी लेटरहेड व शिक्का',
      'membership.requirements.item7': 'दोन अलीकडील छायाचित्रे',
      'membership.requirements.item8': 'विशिष्ट परवाने (लागू असल्यास)',
      'membership.cta.register': 'नोंदणी',
      'membership.cta.title': 'IFM सदस्य व्हा',
      'membership.cta.subtitle': 'तज्ज्ञ मार्गदर्शन, प्रतिनिधित्व आणि वाढीच्या संधींना प्रवेश',
      'membership.comparison.title': 'योजना तुलना',
      'membership.comparison.subtitle': 'तुमच्या गरजांसाठी सर्वोत्तम फिट शोधण्यासाठी सर्व सदस्यता योजनांची तुलना करा',
      'membership.comparison.tab': 'तुलना सारणी',
      'membership.comparison.loading': 'तुलना डेटा लोड होत आहे...',
      'membership.comparison.noPlans': 'तुलनेसाठी कोणतीही योजना उपलब्ध नाहीत.',
      'membership.comparison.featuresPlan': 'सुविधा / योजना',
      'membership.comparison.price': 'किंमत (प्रति वर्ष)',
      'membership.comparison.unitsCovered': 'कव्हर केलेल्या युनिट्स',
      'membership.comparison.issueResolution': 'समस्या निराकरण सहाय्य',
      'membership.comparison.govtCoordination': 'सरकारी विभाग समन्वय',
      'membership.comparison.consultations': 'सल्लागार',
      'membership.comparison.complianceAudit': 'अनुपालन ऑडिट',
      'membership.comparison.cgwaDish': 'CGWA/DISH दस्तऐवजीकरण',
      'membership.comparison.infrastructure': 'पायाभूत सुविधा एस्केलेशन',
      'membership.comparison.workshops': 'कार्यशाळा / कार्यक्रम',
      'membership.comparison.networking': 'नेटवर्किंग',
      'membership.comparison.branding': 'ब्रांडिंग / लोगो प्रदर्शन',
      'membership.comparison.responseTime': 'प्रतिसाद वेळ',
      'membership.comparison.choosePlan': '{tier} योजना निवडा',
      'membership.comparison.notAvailable': 'उपलब्ध नाही',
      'membership.comparison.yes': 'होय',
      'membership.comparison.no': 'नाही',
      // Membership Plans specific
      'membership.plans.loading': 'सदस्यत्व योजना लोड होत आहेत...',
      'membership.plans.noPlans': 'या क्षणी कोणतीही सदस्यत्व योजना उपलब्ध नाहीत.',
      'membership.plans.noPlansDesc': 'कृपया नंतर पुन्हा तपासा किंवा अधिक माहितीसाठी आमच्याशी संपर्क साधा.',
      'membership.plans.popular': 'लोकप्रिय',
      'membership.plans.plan': 'योजना',
      'membership.plans.units': 'युनिट्स',
      'membership.plans.per': 'प्रति',
      'membership.plans.months': 'महिने',
      'membership.plans.response': 'प्रतिसाद:',
      'membership.plans.keyBenefits': 'मुख्य फायदे',
      'membership.plans.showLess': 'कमी दाखवा',
      'membership.plans.viewAllBenefits': 'सर्व {count} फायदे पहा',
      'membership.plans.noBenefits': 'कोणतेही फायदे सूचीबद्ध नाहीत',
      'membership.plans.support': 'सहाय्य',
      'membership.plans.consultations': 'सल्लागार',
      'membership.plans.choosePlan': '{tier} योजना निवडा',
      'membership.benefits.long.subtitle': 'सर्व IFM सदस्यांसाठी उपलब्ध व्यापक फायदे आणि सेवा',
      // Membership Registration/Renewal/Help/Join
      'membership.registration.new.title': 'नवीन सदस्य नोंदणी',
      'membership.registration.new.desc': 'पहिल्यांदाच IFM मध्ये सामील होत आहात? सदस्य होण्यासाठी नोंदणी प्रक्रिया पूर्ण करा.',
      'membership.registration.new.cta': 'नोंदणी सुरू करा',
      'membership.renewal.title': 'सदस्यत्व नूतनीकरण',
      'membership.renewal.desc': 'आधीच सदस्य आहात? आमच्या सेवांचा लाभ चालू ठेवण्यासाठी सदस्यत्व नूतनीकरण करा.',
      'membership.renewal.cta': 'सदस्यत्व नूतनीकरण',
      'membership.help.title': 'मदत हवी आहे?',
      'membership.help.desc': 'नोंदणी प्रक्रियेसाठी आमची टीम मदतीसाठी उपलब्ध आहे.',
      'membership.help.call': 'फोन करा',
      'membership.help.email': 'ईमेल करा',
      'membership.join.title': 'IFM मध्ये सामील होण्यासाठी तयार आहात?',
      'membership.join.desc': 'आजच सदस्य व्हा आणि व्यापक औद्योगिक सहाय्य सेवांचा लाभ घ्या.',
      'membership.join.registerNow': 'आता नोंदणी करा',
      // Membership Calculator
      'membership.calculator.title': 'तुमच्या सदस्यत्व शुल्काची गणना करा',
      'membership.calculator.workerCount': 'कामगारांची संख्या',
      'membership.calculator.workerCountPlaceholder': 'कामगार संख्या प्रविष्ट करा',
      'membership.calculator.calculate': 'गणना करा',
      'membership.calculator.fee': 'सदस्यत्व शुल्क',
      'membership.calculator.category': 'श्रेणी:',
      'membership.calculator.baseFee': 'मूळ शुल्क',
      'membership.calculator.additional': 'अतिरिक्त',
      'membership.calculator.total': 'एकूण:',
      'membership.calculator.member': 'सदस्य',
      'membership.calculator.members': 'सदस्य',
      'membership.calculator.pricingStructure': 'किंमत रचना:',
      'membership.calculator.smallIndustries': 'लहान उद्योग',
      'membership.calculator.mediumLargeIndustries': 'मध्यम/मोठे उद्योग',
      'membership.calculator.workers': 'कामगार',
      'membership.calculator.oneTime': 'एक वेळ',
      'membership.calculator.base': 'मूळ',
      'membership.calculator.perAdditionalWorker': 'प्रति अतिरिक्त कामगार',
      'membership.calculator.error.workerCount': 'कृपया वैध कामगार संख्या प्रविष्ट करा (किमान 1)',
      'membership.calculator.error.calculation': 'शुल्काची गणना करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      // Membership Plan Details
      'membership.plan.unified': 'स्टीवर्डशिप  सदस्यत्व योजना',
      'membership.plan.notAvailable': 'स्टीवर्डशिप  सदस्यत्व योजना उपलब्ध नाही',
      'membership.plan.contactAdmin': 'कृपया प्रशासकाशी संपर्क साधा',
      'membership.plan.duration': 'कालावधी',
      'membership.plan.trainingProgram': 'प्रशिक्षण कार्यक्रम',
      'membership.plan.trainingProgram.weekProgram': '-आठवड्याचा कार्यक्रम समाविष्ट',
      'membership.plan.trainingProgram.notAvailable': 'उपलब्ध नाही',
      'membership.plan.trainingProgram.title': '52-आठवड्यांचा कामगार प्रशिक्षण कार्यक्रम',
      'membership.plan.trainingProgram.description': 'मूल्य-वर्धित फायदा म्हणून, Industrial Fedration सदस्य उद्योगांच्या कामगारांसाठी वर्षभर (52 आठवडे) सतत ऑनलाइन आणि ऑफलाइन कार्यशाळा आणि प्रशिक्षण कार्यक्रम आयोजित करते.',
      'membership.plan.trainingProgram.areas': 'प्रशिक्षण क्षेत्रे:',
      'membership.plan.trainingProgram.outcomes': 'प्रशिक्षण परिणाम:',
      'membership.plan.keyBenefits': 'मुख्य फायदे',
      // Events
      'events.participants': 'सहभागी',
      // Gallery
      'gallery.video.unsupported': 'असमर्थित व्हिडिओ URL',
      'gallery.aria.previousImage': 'मागील प्रतिमा',
      // Navigation - Mobile
      'nav.mobile.followUs': 'आम्हाला फॉलो करा:',
      'nav.mobile.language': 'भाषा / Language',
      // Video
      'video.browserNotSupported': 'तुमचा ब्राउझर व्हिडिओ टॅगचे समर्थन करत नाही.',
      // Carousel
      'carousel.previous': 'मागील वैशिष्ट्य',
      'carousel.next': 'पुढील वैशिष्ट्य',
      'carousel.goToSlide': 'स्लाइडवर जा',
      // Dashboard (Marathi)
      'dashboard.title': 'डॅशबोर्ड',
      'dashboard.welcome': 'पुन्हा स्वागत आहे! IFM सह काय होत आहे ते येथे पहा.',
      'dashboard.totalMembers': 'एकूण सदस्य',
      'dashboard.activeServices': 'सक्रिय सेवा',
      'dashboard.upcomingEvents': 'आगामी कार्यक्रम',
      'dashboard.openGrievances': 'उघड्या तक्रारी',
      'dashboard.fromLastMonth': 'मागील महिन्यापासून',
      'dashboard.quickActions': 'द्रुत क्रिया',
      'dashboard.recentActivities': 'अलीकडील क्रियाकलाप',
      'dashboard.submitGrievance': 'तक्रार सबमिट करा',
      'dashboard.submitGrievanceDesc': 'एक समस्या किंवा चिंता निवेदन करा',
      'dashboard.registerForEvent': 'कार्यक्रमासाठी नोंदणी करा',
      'dashboard.registerForEventDesc': 'आगामी कार्यशाळांमध्ये सामील व्हा',
      'dashboard.downloadPolicy': 'धोरण डाउनलोड करा',
      'dashboard.downloadPolicyDesc': 'नवीनतम मार्गदर्शक तत्त्वांमध्ये प्रवेश करा',
      'dashboard.contactSupport': 'समर्थनाशी संपर्क साधा',
      'dashboard.contactSupportDesc': 'आमच्या संघाकडून मदद मिळवा',
      'dashboard.upcomingEventsTitle': 'आगामी कार्यक्रम',
      'dashboard.systemStatus': 'सिस्टम स्थिती',
      'dashboard.operational': 'ऑपरेशनल',
      'dashboard.apiServices': 'API सेवा',
      'dashboard.database': 'डेटाबेस',
      'dashboard.paymentGateway': 'पेमेंट गेटवे',
      'dashboard.emailService': 'ईमेल सेवा',
      // Committee (Marathi)
      'about.committee.expertise': 'तज्ञता',
      'about.committee.responsibility.executive.1': 'रणनीतिक नियोजन आणि धोरण निर्माण',
      'about.committee.responsibility.executive.2': 'बोर्ड शासन आणि देखरेख',
      'about.committee.responsibility.executive.3': 'आर्थिक मंजुरी आणि अंदाज व्यवस्थापन',
      'about.committee.responsibility.executive.4': 'भागधारक संबंध व्यवस्थापन',
      'about.committee.responsibility.technical.1': 'तांत्रिक सल्लागार आणि सल्लामसलत',
      'about.committee.responsibility.technical.2': 'सुरक्षा मानके आणि अनुपालन मार्गदर्शन',
      'about.committee.responsibility.technical.3': 'तंत्रज्ञान अपनावण्याच्या शिफारसी',
      'about.committee.responsibility.technical.4': 'प्रशिक्षण कार्यक्रम विकास',
      'about.committee.responsibility.regional.1': 'स्थानिक सदस्य समर्थन आणि जोडणी',
      'about.committee.responsibility.regional.2': 'प्रादेशिक कार्यक्रम समन्वय',
      'about.committee.responsibility.regional.3': 'जिल्हा स्तरीय धोरण वकिली',
      'about.committee.responsibility.regional.4': 'समुदाय आउटरीच कार्यक्रम',
      'about.committee.responsibility.finance.1': 'अंदाज नियोजन आणि निरीक्षण',
      'about.committee.responsibility.finance.2': 'आर्थिक अहवाल आणि ऑडिट देखरेख',
      'about.committee.responsibility.finance.3': 'गुंतवणूक आणि निधी व्यवस्थापन',
      'about.committee.responsibility.finance.4': 'खर्च नियंत्रण आणि कार्यक्षमता उपाय',
      'membership.join.downloadBrochure': 'ब्रशर डाउनलोड करा',
      // About - Values
      'about.values.title': 'मूलभूत मूल्ये',
      'about.values.desc': 'आमच्या ध्येय आणि सेवांना मार्गदर्शन करणारी तत्त्वे',
      'about.values.integrity': 'प्रामाणिकपणा',
      'about.values.integrity.desc': 'आम्ही पारदर्शकता आणि जबाबदारी पाळतो',
      'about.values.collaboration': 'सहकार्य',
      'about.values.collaboration.desc': 'उत्तम परिणामांसाठी भागधारकांसोबत काम',
      'about.values.innovation': 'नवीनता',
      'about.values.innovation.desc': 'आधुनिक, कार्यक्षम आणि शाश्वत पद्धतींचा प्रसार',
      'about.values.excellence': 'उत्कृष्टता',
      'about.values.excellence.desc': 'उच्च मानके आणि सातत्यपूर्ण सुधारणा',

      // About - Strategic Objectives
      'about.objectives.title': 'रणनीतिक उद्दिष्टे',
      'about.objectives.desc': 'मुख्य फोकस क्षेत्र जे आमच्या मिशन आणि व्हिजनला पुढे नेतात',
      'about.objectives.sustainable.title': 'शाश्वत वाढ',
      'about.objectives.sustainable.desc': 'दीर्घकालीन समृद्धीसाठी पर्यावरणास अनुकूल औद्योगिक पद्धती आणि हरित तंत्रज्ञान प्रोत्साहित करणे।',
      'about.objectives.collaboration.title': 'उद्योग सहकार्य',
      'about.objectives.collaboration.desc': 'परस्पर फायद्यासाठी सरकार, उद्योग आणि समुदायांमध्ये मजबूत भागीदारी तयार करणे।',
      'about.objectives.innovation.title': 'नवकल्पना सहाय्य',
      'about.objectives.innovation.desc': 'औद्योगिक स्पर्धात्मकता वाढवण्यासाठी तांत्रिक प्रगती आणि संशोधन पहलांना प्रोत्साहन देणे।',

      // About - Call to Action
      'about.join.title': 'आमच्या मिशनमध्ये सामील व्हा',
      'about.join.desc': 'महाराष्ट्राच्या औद्योगिक परिवर्तनाचा भाग व्हा। एकत्रितपणे, आपण शाश्वत आणि समृद्ध भविष्य बांधू शकतो।',
      'about.join.member': 'सदस्य व्हा',
      'about.join.contact': 'संपर्क साधा',

      // About - IFM Introduction
      'about.intro.title': 'Industrial Fedration of Maharashtra Region बद्दल',
      'about.intro.description': 'Industrial Fedration of Maharashtra Region (IFM) (नोंदणी क्र. महा./745/2025, पुणे) ही महाराष्ट्रातील उद्योगांच्या हक्क आणि समस्यांसाठी काम करणारी नोंदणीकृत संस्था आहे. आम्ही MPCB, MIDC, DIC, सुरक्षा विभाग आणि प्रदूषण नियंत्रण मंडळांसारख्या सरकारी अधिकाऱ्यांसमोर उद्योगांचे प्रतिनिधित्व करतो जेणेकरून लहान, मध्यम आणि मोठ्या उद्योगांसाठी न्याय्य धोरणे, पारदर्शकता आणि समर्थन सुनिश्चित होईल.',

      // About - Vision Details
      'about.vision.details.1': 'सर्व उद्योगांसाठी समान संधी सुनिश्चित करणे.',
      'about.vision.details.2': 'पारदर्शक आणि स्पर्धात्मक वातावरण निर्माण करणे.',
      'about.vision.details.3': 'वैज्ञानिक आणि न्याय्य पर्यावरणीय धोरणांना प्रोत्साहन देणे.',
      'about.vision.details.4': 'औद्योगिक सेवांमध्ये एकाधिकार प्रथांना समाप्त करणे.',
      'about.vision.details.5': 'महाराष्ट्रात सतत आणि प्रगतिशील औद्योगिक पारिस्थितिकी तंत्र निर्माण करणे.',

      // About - Core Values Details
      'about.values.integrity.details.1': 'पारदर्शक निर्णय घेण्याच्या प्रक्रिया',
      'about.values.integrity.details.2': 'जबाबदार नेतृत्व आणि शासन',
      'about.values.integrity.details.3': 'नैतिक व्यवसाय पद्धती',
      'about.values.integrity.details.4': 'भागधारकांसोबत प्रामाणिक संवाद',
      'about.values.collaboration.details.1': 'क्रॉस-सेक्टर भागीदारी',
      'about.values.collaboration.details.2': 'सरकार-उद्योग सहकार्य',
      'about.values.collaboration.details.3': 'समुदाय जोडणी पहल',
      'about.values.collaboration.details.4': 'ज्ञान सामायिकरण मंच',
      'about.values.innovation.details.1': 'तंत्रज्ञान स्वीकरण कार्यक्रम',
      'about.values.innovation.details.2': 'डिजिटल परिवर्तन पहल',
      'about.values.innovation.details.3': 'शाश्वत उत्पादन प्रक्रिया',
      'about.values.innovation.details.4': 'संशोधन आणि विकास सहाय्य',
      'about.values.excellence.details.1': 'गुणवत्ता आश्वासन कार्यक्रम',
      'about.values.excellence.details.2': 'सातत्यपूर्ण सुधारणा पहल',
      'about.values.excellence.details.3': 'सर्वोत्तम पद्धतींची अंमलबजावणी',
      'about.values.excellence.details.4': 'कार्यप्रदर्शन बेंचमार्किंग',

      // About - Core Values Sections
      'about.values.living.title': 'आमच्या मूल्यांना जगणे',
      'about.values.living.desc': 'आम्ही आमच्या मुख्य मूल्यांना क्रियाशील पहलांमध्ये आणि मोजता येण्याजोग्या परिणामांमध्ये कसे रूपांतरित करतो',
      'about.values.initiatives.title': 'मुख्य पहल',
      'about.values.action.title': 'कार्यात मूल्ये',
      'about.values.action.desc': 'आमच्या मूल्ये आमच्या कामाचे मार्गदर्शन कसे करतात आणि सकारात्मक प्रभाव कसा निर्माण करतात याची वास्तविक उदाहरणे',
      'about.values.action.transparent.title': 'पारदर्शक शासन',
      'about.values.action.transparent.desc': 'आमच्या क्रियाकलापांवर नियमित सार्वजनिक अहवाल, आर्थिक पारदर्शकता आणि सर्व भागधारकांसोबत खुला संवाद।',
      'about.values.action.community.title': 'समुदाय भागीदारी',
      'about.values.action.community.desc': 'स्थानिक समुदायांसोबत, शैक्षणिक संस्था आणि उद्योग संघटनांसोबत सहकार्यात्मक प्रकल्प।',
      'about.values.action.excellence.title': 'उत्कृष्टता मान्यता',
      'about.values.action.excellence.desc': 'उत्कृष्ट औद्योगिक पद्धती आणि नवकल्पना यशांसाठी पुरस्कार आणि मान्यता कार्यक्रम।',

      // About - Core Values Call to Action
      'about.values.share.title': 'आमची मूल्ये सामायिक करा',
      'about.values.share.desc': 'या मूल्यांचे पालन करण्यात आणि महाराष्ट्राच्या औद्योगिक उत्कृष्टतेत योगदान देण्यात आमच्यासोबत सामील व्हा।',
      'about.values.share.member': 'सदस्य व्हा',
      'about.values.share.learn': 'अधिक जाणा',

      // About - Structure Additional Content
      'about.structure.detailed.title': 'तपशीलवार संघटना रचना',
      'about.structure.detailed.desc': 'प्रत्येक विभाग आमच्या मिशनमध्ये कसा योगदान देतो आणि आमच्या सदस्यांची सेवा कशी करतो हे समजून घेणे',
      'about.structure.leadership.title': 'संचालक मंडळ',
      'about.structure.leadership.desc': 'IFM च्या रणनीतिक दिशा आणि कार्यांचे मार्गदर्शन करणाऱ्या समर्पित नेत्यांना भेटा',
      'about.structure.leadershipCta': 'आमच्या रणनीतिक दिशेचे मार्गदर्शन करणाऱ्या समर्पित नेत्यांना भेटा.',
      'about.leadership.viewCommittee': 'समिती सदस्य पहा',
      'about.structure.chart.title': 'संघटनात्मक आलेख',
      'about.structure.chart.desc': 'आमच्या संघटनात्मक पदानुक्रम आणि अहवाल संरचनेचे दृश्य प्रतिनिधित्व',

      // About - Structure Regional Cities
      'about.structure.regional.mumbai': 'मुंबई',
      'about.structure.regional.pune': 'पुणे',
      'about.structure.regional.nagpur': 'नागपूर',
      'about.structure.regional.aurangabad': 'औरंगाबाद',
      'about.structure.regional.nashik': 'नाशिक',

      // About - Structure Leadership Team
      'about.structure.leadership.president.name': 'श्री कैलास नरके',
      'about.structure.leadership.president.position': 'अध्यक्ष',
      'about.structure.leadership.president.department': 'कार्यकारी नेतृत्व',
      'about.structure.leadership.vicePresident.name': 'श्री जावेद इनामदार',
      'about.structure.leadership.vicePresident.position': 'उपाध्यक्ष',
      'about.structure.leadership.vicePresident.department': 'रणनीतिक नियोजन',
      'about.structure.leadership.secretary.name': 'श्रीमती दीपा महाजन',
      'about.structure.leadership.secretary.position': 'सचिव',
      'about.structure.leadership.secretary.department': 'संचालन',
      'about.structure.leadership.treasurer.name': 'श्री रामदास नापते',
      'about.structure.leadership.treasurer.position': 'कोषाध्यक्ष',
      'about.structure.leadership.treasurer.department': 'वित्त',
      'about.structure.leadership.chiefConsultant.name': 'श्री प्रशांत मुंदडा',
      'about.structure.leadership.chiefConsultant.position': 'मुख्य सलाहकार अधिकारी',
      'about.structure.leadership.chiefConsultant.department': 'सलाहकार',

      // About - Structure Chart Departments
      'about.structure.chart.technical.title': 'तांत्रिक',
      'about.structure.chart.technical.subtitle': 'समिती',
      'about.structure.chart.regional.title': 'प्रादेशिक',
      'about.structure.chart.regional.subtitle': 'समित्या',
      'about.structure.chart.support.title': 'सहाय्य',
      'about.structure.chart.support.subtitle': 'कर्मचारी',
      'about.structure.chart.external.title': 'बाह्य',
      'about.structure.chart.external.subtitle': 'संबंध',

      // About - Structure Call to Action
      'about.structure.join.title': 'आमच्या संघटनेत सामील व्हा',
      'about.structure.join.desc': 'औद्योगिक उत्कृष्टता आणि सदस्य यशासाठी वचनबद्ध असलेल्या चांगल्या प्रकारे संरचित संघटनेचा भाग व्हा।',
      'about.structure.join.member': 'सदस्य व्हा',
      'about.structure.join.learn': 'अधिक जाणा',

      // About - Achievements Page
      'about.achievements.journey.title': 'आमची प्रवास',
      'about.achievements.journey.desc': 'मुख्य टप्पे आणि यश ज्यांनी आमच्या संस्थेच्या वाढीला आणि प्रभावाला आकार दिला आहे',
      'about.achievements.milestone.2023.title': 'डिजिटल परिवर्तन पहल',
      'about.achievements.milestone.2023.desc': 'सदस्य सेवा आणि नियामक अनुपालनासाठी व्यापक डिजिटल प्लॅटफॉर्म लॉन्च केले.',
      // Privacy Policy - Marathi
      'privacy.title': 'गोपनीयता धोरण',
      'privacy.subtitle': 'आपली गोपनीयता आमच्यासाठी महत्त्वाची आहे. हे धोरण स्पष्ट करते की आम्ही आपली माहिती कशी गोळा करतो, वापरतो आणि संरक्षित करतो.',
      'privacy.lastUpdated': 'शेवटचे अद्यतन',
      'privacy.effectiveDate': 'प्रभावी तारीख',
      'privacy.tableOfContents': 'अनुक्रमणिका',
      'privacy.section.introduction': 'परिचय',
      'privacy.section.collection': 'आम्ही गोळा केलेली माहिती',
      'privacy.section.usage': 'आम्ही आपली माहिती कशी वापरतो',
      'privacy.section.sharing': 'माहिती सामायिकरण आणि प्रकटीकरण',
      'privacy.section.security': 'डेटा सुरक्षा',
      'privacy.section.cookies': 'कुकीज आणि ट्रॅकिंग तंत्रज्ञान',
      'privacy.section.rights': 'आपले अधिकार',
      'privacy.section.retention': 'डेटा प्रतिधारण',
      'privacy.section.thirdParty': 'तृतीय-पक्ष लिंक',
      'privacy.section.children': 'मुलांची गोपनीयता',
      'privacy.section.changes': 'या गोपनीयता धोरणात बदल',
      'privacy.section.contact': 'आमच्याशी संपर्क साधा',
      // Terms & Conditions - Marathi
      'terms.title': 'अटी आणि नियम',
      'terms.subtitle': 'कृपया आमच्या सेवा वापरण्यापूर्वी ह्या अटी काळजीपूर्वक वाचा.',
      'terms.tableOfContents': 'अनुक्रमणिका',
      'terms.section.introduction': 'परिचय',
      'terms.section.acceptance': 'अटींची स्वीकृती',
      'terms.section.membership': 'सदस्यता अटी',
      'terms.section.payment': 'पेमेंट अटी',
      'terms.section.services': 'सेवा',
      'terms.section.responsibilities': 'वापरकर्ता जबाबदाऱ्या',
      'terms.section.intellectual': 'बौद्धिक मालमत्ता',
      'terms.section.liability': 'दायित्व मर्यादा',
      'terms.section.indemnification': 'क्षतिपूर्ती',
      'terms.section.termination': 'समाप्ती',
      'terms.section.disputes': 'विवाद निराकरण',
      'terms.section.governing': 'शासकीय कायदा',
      'terms.section.contact': 'आमच्याशी संपर्क साधा',
      // Refund Policy - Marathi
      'refund.title': 'परतावा आणि रिटर्न धोरण',
      'refund.subtitle': 'आमच्या सेवांसाठी परतावा आणि रिटर्न संबंधित महत्त्वाची माहिती.',
      'refund.tableOfContents': 'अनुक्रमणिका',
      'refund.noRefundNotice': 'परतावा धोरण नाही',
      'refund.section.introduction': 'परिचय',
      'refund.section.noRefund': 'परतावा धोरण नाही',
      'refund.section.payment': 'पेमेंट प्रक्रिया',
      'refund.section.exceptions': 'मर्यादित अपवाद',
      'refund.section.nonRefundable': 'परतावा न देता येणारे परिस्थिती',
      'refund.section.membership': 'सदस्यता शुल्क',
      'refund.section.events': 'कार्यक्रम नोंदणी',
      'refund.section.disputes': 'पेमेंट विवाद',
      'refund.section.chargebacks': 'चार्जबॅक',
      'refund.section.cancellation': 'IFM द्वारे रद्दीकरण',
      'refund.section.contact': 'परतावा विनंतीसाठी संपर्क साधा',
      'refund.section.acknowledgment': 'पावती',
      // Policies Page - Marathi
      'policies.noPoliciesFound': 'धोरणे सापडली नाहीत',
      'policies.tryAdjusting': 'आपली शोध किंवा फिल्टर निकष समायोजित करण्याचा प्रयत्न करा.',
      'policies.downloadDocument': 'दस्तऐवज डाउनलोड करा',
      'policies.updated': 'अद्यतनित',
      'policies.version': 'आवृत्ती',
      'policies.size': 'आकार',
      'about.achievements.milestone.2023.achievements.1': 'ऑनलाइन सदस्यता पोर्टल',
      'about.achievements.milestone.2023.achievements.2': 'डिजिटल दस्तावेज व्यवस्थापन',
      'about.achievements.milestone.2023.achievements.3': 'मोबाइल ऍप लॉन्च',
      'about.achievements.milestone.2022.title': 'शाश्वतता कार्यक्रम',
      'about.achievements.milestone.2022.desc': 'हरित औद्योगिक पद्धती आणि पर्यावरणीय अनुपालन समर्थन सुरू केले.',
      'about.achievements.milestone.2022.achievements.1': 'हरित प्रमाणपत्र कार्यक्रम',
      'about.achievements.milestone.2022.achievements.2': 'कार्बन फुटप्रिंट कमी करणे',
      'about.achievements.milestone.2022.achievements.3': 'नवीकरणीय ऊर्जा स्वीकरण',
      'about.achievements.milestone.2021.title': 'प्रादेशिक विस्तार',
      'about.achievements.milestone.2021.desc': 'महाराष्ट्रातील सर्व प्रमुख औद्योगिक जिल्ह्यांमध्ये सेवा विस्तारित केल्या.',
      'about.achievements.milestone.2021.achievements.1': '5 नवे प्रादेशिक कार्यालये',
      'about.achievements.milestone.2021.achievements.2': 'स्थानिक समर्थन टीम',
      'about.achievements.milestone.2021.achievements.3': 'जिल्हा स्तरीय भागीदारी',
      'about.achievements.milestone.2020.title': 'कोविड-19 समर्थन पहल',
      'about.achievements.milestone.2020.desc': 'महामारी दरम्यान उद्योगांना महत्वपूर्ण समर्थन प्रदान केले.',
      'about.achievements.milestone.2020.achievements.1': 'आणीबाणी राहत निधी',
      'about.achievements.milestone.2020.achievements.2': 'सुरक्षा प्रोटोकॉल मार्गदर्शन',
      'about.achievements.milestone.2020.achievements.3': 'पुरवठा साखळी समर्थन',
      'about.achievements.impact.title': 'आमचा प्रभाव',
      'about.achievements.impact.desc': 'आमची यश महाराष्ट्राच्या औद्योगिक क्षेत्रासाठी वास्तविक फायद्यांमध्ये कसे रूपांतरित होतात',
      'about.achievements.impact.economic.title': 'आर्थिक वाढ',
      'about.achievements.impact.economic.desc': 'सदस्य समर्थन आणि धोरण वकिलीद्वारे महाराष्ट्राच्या औद्योगिक जीडीपीमध्ये योगदान.',
      'about.achievements.impact.employment.title': 'रोजगार निर्मिती',
      'about.achievements.impact.employment.desc': 'औद्योगिक विकास आणि कौशल्य विकास कार्यक्रमांद्वारे रोजगार निर्मितीला समर्थन.',
      'about.achievements.impact.policy.title': 'धोरण प्रभाव',
      'about.achievements.impact.policy.desc': 'राज्य आणि राष्ट्रीय स्तरावर वकिली आणि प्रतिनिधित्वाद्वारे औद्योगिक धोरणांना आकार देणे.',
      'about.achievements.recognition.title': 'मान्यता आणि पुरस्कार',
      'about.achievements.recognition.desc': 'आमच्या उत्कृष्ट योगदान आणि सेवा उत्कृष्टतेसाठी उद्योग मान्यता',
      'about.achievements.award1.title': 'सर्वोत्कृष्ट उद्योग संघ',
      'about.achievements.award1.event': 'महाराष्ट्र औद्योगिक उत्कृष्टता पुरस्कार 2023',
      'about.achievements.award1.desc': 'महाराष्ट्राच्या औद्योगिक क्षेत्रात उत्कृष्ट सेवा आणि नवाचारी सदस्य समर्थन कार्यक्रमांसाठी मान्यता.',
      'about.achievements.award2.title': 'शाश्वतता नेतृत्व',
      'about.achievements.award2.event': 'हरित औद्योगिक पुरस्कार 2022',
      'about.achievements.award2.desc': 'महाराष्ट्रभर शाश्वत औद्योगिक पद्धती आणि पर्यावरणीय अनुपालनाला प्रोत्साहन देण्यासाठी सन्मानित.',
      'about.achievements.future.title': 'पुढे पाहताना',
      'about.achievements.future.desc': 'भविष्यासाठी आमची व्हिजन आणि महाराष्ट्राच्या औद्योगिक क्षेत्राला आणखी मजबूत बनवण्यासाठी आगामी पहल',
      'about.achievements.goals.title': '2024-2026 रणनीतिक ध्येये',
      'about.achievements.goals.1': 'सदस्यता 1000+ सक्रिय सदस्यांपर्यंत विस्तारित करणे',
      'about.achievements.goals.2': 'AI-चालित अनुपालन सहायता प्लॅटफॉर्म लॉन्च करणे',
      'about.achievements.goals.3': 'आंतरराष्ट्रीय व्यापार भागीदारी स्थापित करणे',
      'about.achievements.goals.4': '100% डिजिटल सेवा वितरण साध्य करणे',
      'about.achievements.innovation.title': 'नवाचार पहल',
      'about.achievements.innovation.1': 'स्मार्ट विनिर्माण समर्थन कार्यक्रम',
      'about.achievements.innovation.2': 'ब्लॉकचेन-आधारित प्रमाणपत्र प्रणाली',
      'about.achievements.innovation.3': 'व्हर्चुअल रिअॅलिटी प्रशिक्षण मॉड्यूल',
      'about.achievements.innovation.4': 'औद्योगिक निरीक्षणासाठी IoT एकीकरण',
      'about.achievements.cta.title': 'आमच्या यशाच्या कथेचा भाग व्हा',
      'about.achievements.cta.desc': 'उत्कृष्टतेच्या आमच्या प्रवासाला सुरुवात ठेवण्यात आणि महाराष्ट्राच्या औद्योगिक विकासात योगदान देण्यात आमच्यासोबत सामील व्हा.',
      'about.achievements.cta.member': 'सदस्य व्हा',
      'about.achievements.cta.learn': 'अधिक जाणा',

      // About - Committee Page
      'about.committee.subtitle': 'IFM च्या मिशन आणि संचालनाचे मार्गदर्शन करणाऱ्या समर्पित नेत्यांना आणि तज्ञांना भेटा',
      'about.committee.leadership.title': 'संचालक मंडल',
      'about.committee.leadership.desc': 'IFM च्या रणनीतिक दिशेचे आणि दैनंदिन संचालनाचे नेतृत्व करणाऱ्या अनुभवी व्यावसायिक',
      'about.committee.structure.title': 'समिती रचना',
      'about.committee.structure.desc': 'औद्योगिक समर्थनाच्या सर्व पैलूंचे व्यापक कव्हरेज सुनिश्चित करणाऱ्या संघटित समित्या',
      'about.committee.responsibilities.title': 'समिती जबाबदाऱ्या',
      'about.committee.responsibilities.desc': 'प्रभावी शासन आणि सेवा वितरण सुनिश्चित करणाऱ्या स्पष्ट भूमिका आणि जबाबदाऱ्या',
      'about.committee.contact.title': 'आमच्या समितीशी संपर्क साधा',
      'about.committee.contact.desc': 'विशिष्ट चौकशी आणि समर्थनासाठी आमच्या समिती सदस्यांशी संपर्क साधा',
      'about.committee.contact.general.title': 'सामान्य चौकशी',
      'about.committee.contact.secretary.title': 'समिती सचिव',
      'about.committee.contact.secretary.role': 'समिती समन्वय',
      'about.committee.cta.title': 'आमच्या समितीत सामील व्हा',
      'about.committee.cta.desc': 'IFM च्या मिशनमध्ये योगदान देण्यात रस आहे? आमच्या कोणत्याही एका समितीत सामील होण्याचा विचार करा।',
      'about.committee.cta.member': 'सदस्य व्हा',
      'about.committee.cta.contact': 'संपर्क साधा',
      'about.committee.experience': 'अनुभव',
      'about.committee.members': 'समिती सदस्य:',
      'about.committee.membersSection.title': 'समिती सदस्य',
      'about.committee.membersSection.desc': 'आमचे समर्पित समिती सदस्य आणि त्यांच्या भूमिका',
      'about.committee.role.member': 'समिती सदस्य',
      'about.committee.member.prashantMundada.name': 'प्रशांत मुंदडा',
      'about.committee.member.shrikantNarke.name': 'श्री श्रीकांत नरके',
      'about.committee.member.dadasahebShinalkar.name': 'श्री दादासाहेब शिनाळकर',
      'about.committee.member.sachinDhumal.name': 'श्री सचिन धुमाळ',
      'about.committee.member.sudhirBhadhe.name': 'श्री सुधीर भाधे',
      'about.committee.executive.name': 'कार्यकारी समिती',
      'about.committee.executive.desc': 'रणनीतिक नेतृत्व आणि शासन निरीक्षण',
      'about.committee.technical.name': 'तांत्रिक समिती',
      'about.committee.technical.desc': 'विषय विशेषज्ञता आणि सल्लागार सेवा',
      'about.committee.regional.name': 'प्रादेशिक समिती',
      'about.committee.regional.desc': 'महाराष्ट्रभर स्थानिक प्रतिनिधित्व',
      'about.committee.finance.name': 'वित्त समिती',
      'about.committee.finance.desc': 'वित्तीय निरीक्षण आणि अंदाज व्यवस्थापन',

      // Home Page - About IFM Section
      'home.about.title': 'IFM बद्दल',
      'home.about.intro': 'Industrial Fedration ही एक अग्रगण्य व्यावसायिक संघटना आहे.',
      'home.about.point1': 'ही एक अशी संघटना आहे जी उद्योग क्षेत्र आणि विविध सरकारी विभागांना एकत्र आणते.',
      'home.about.point2': 'विभागांमधील एक महत्त्वाची कडी (पूल).',
      'home.about.point3': 'म्हणून ते काम करते. नियामक उद्योगांचा सामना करत आहेत (नियामक), तांत्रिक आणि पायाभूत सुविधा.',
      'home.about.commitment': 'आम्ही नेहमी समस्या सोडवण्यासाठी वचनबद्ध आहोत.',
      'home.about.federation.title': 'महासंघाबद्दल',
      'home.about.federation.desc1': 'Industrial Fedration ही एक व्यावसायिक आणि विश्वासार्ह संघटना आहे जी उद्योगांना सामोरे जाणाऱ्या नियामक, परिचालन आणि पायाभूत सुविधांच्या आव्हानांचे निराकरण करण्यासाठी काम करते. आम्ही उद्योग आणि विविध सरकारी विभागांमधील एक महत्त्वाची समन्वय कडी म्हणून काम करतो, ज्यामुळे औद्योगिक कार्यक्रम सुरळीत, कायदेशीर आणि शाश्वतपणे चालतात याची खात्री करतो.',
      'home.about.federation.desc2': 'आमचे प्राथमिक उद्दिष्ट उद्योगांसाठी एक अनुकूल आणि भयमुक्त वातावरण निर्माण करणे आणि पर्यावरण संरक्षण, कामगार सुरक्षा आणि संसाधन व्यवस्थापन यासारख्या जबाबदार औद्योगिक पद्धतींना प्रोत्साहन देणे आहे.',
      'home.about.knowMore': 'अधिक जाणा',

      // Home Page - President Message Section
      'home.president.title': 'अध्यक्षाचे संदेश',
      'home.president.message1': 'Industrial Fedration of Maharashtra Region (IFM) तुमचे स्वागत करताना मला अत्यंत आनंद होत आहे. जसा आपण औद्योगिक विकासाच्या गतिशील परिदृश्यातून जात आहोत, IFM महाराष्ट्रभर सतत विकास आणि नवकल्पना प्रोत्साहित करण्यासाठी प्रतिबद्ध आहे.',
      'home.president.message2': 'आमची संघटना औद्योगिक उत्कृष्टता, सुरक्षा मानकांना आणि पर्यावरणीय जबाबदाऱ्यांना प्रोत्साहन देण्यात अग्रणी राहिली आहे. आम्ही मानतो की खरी प्रगती आर्थिक विकासाला सामाजिक जबाबदारी आणि पर्यावरणीय स्टीवर्डशिपसह संतुलित करण्यातून येते.',
      'home.president.message3': 'आमच्या व्यापक कार्यक्रमांद्वारे, आम्ही तांत्रिक समर्थन, नीती वकिली आणि प्रशिक्षण संधी प्रदान करतो ज्या उद्योगांना पनपण्यास सक्षम बनवतात आणि त्याच वेळी आमच्या समुदायांमध्ये सकारात्मक योगदान देतात. आमचा सहकारी  व्हिजनकोण सरकारी संस्था, उद्योग नेते आणि स्थानिक हितधारकांना एकत्र आणतो.',
      'home.president.message4': 'जसा आपण भविष्याकडे पाहत आहोत, IFM नवीन तंत्रज्ञान, सतत पद्धती आणि नवकल्पनात्मक उपायांना स्वीकारण्यासाठी प्रतिबद्ध आहे जे महाराष्ट्राच्या औद्योगिक क्षेत्राला नवीन उंचीवर नेतील. एकत्रितपणे, आपण अधिक समृद्ध आणि सतत उद्याचे निर्माण करू शकतो.',
      'home.president.message5': 'मजबूत उद्योग = मजबूत प्रदेश = मजबूत राष्ट्र',
      'home.president.message6': 'हे  व्हिजनकोण साध्य करण्यासाठी, आम्ही प्रदूषण नियंत्रण प्राधिकरण, DISH, MIDC, MSEDCL, DIC, कामगार विभाग आणि इतर प्रमुख सरकारी संस्थांसोबत सातत्याने काम करतो, जे औद्योगिक गरजांसाठी पारदर्शक, विश्वासार्ह आणि वेळेवर उपाय सुनिश्चित करतात.',
      'home.president.message7': 'आमची उद्दिष्ट समस्या-निराकरणाकडे जाते. आम्ही शाश्वत आणि जबाबदार औद्योगिक विकासाला प्रोत्साहन देण्यासाठी, सुरक्षित आणि अनुपालन कार्यस्थळे तयार करण्यासाठी, पर्यावरणास अनुकूल आणि कार्यक्षम संसाधन व्यवस्थापनास समर्थन देण्यासाठी, उद्योगांच्या सामूहिक आवाजाला मजबूत करण्यासाठी आणि नवकल्पना आणि विकासाला प्रोत्साहन देणारे पारिस्थितिकी तंत्र निर्माण करण्यासाठी वचनबद्ध आहोत.',
      'home.president.message8': 'औद्योगिक संघ हे फक्त एक मंच नाही—हे औद्योगिक समुदायाचा अभिमान, शक्ती आणि एकीकृत आवाज आहे. आम्ही सर्व उद्योगांच्या प्रगती, स्थिरता आणि दीर्घकालीन विकासासाठी अथकपणे काम करण्यासाठी समर्पित आहोत.',
      'home.president.message9': 'तुमच्या सतत समर्थनासह, आम्ही भविष्यासाठी एक मजबूत, प्रगतिशील आणि सहकारी औद्योगिक पारिस्थितिकी तंत्र तयार करण्यासाठी आत्मविश्वासी आहोत. औद्योगिक संघाचा मौल्यवान भाग असल्याबद्दल धन्यवाद.',
      'home.president.thankYou': 'औद्योगिक संघाचा मौल्यवान भाग असल्याबद्दल धन्यवाद.',
      'home.president.missionTitle': 'आमचे मिशन सोपे पण शक्तिशाली आहे',
      'home.president.name': 'श्री कैलास नरके',
      'home.president.position': 'अध्यक्ष, Industrial Fedration of Maharashtra Region',
      'home.president.experience': 'औद्योगिक नेतृत्वात 10+ वर्षे',
      'home.president.background': 'पूर्व निदेशक, महाराष्ट्र उद्योग',
      'about.president.purpose.title': 'आमची उद्दिष्ट समस्या-निराकरणाकडे जाते',
      'about.president.purpose.committed': 'आम्ही वचनबद्ध आहोत:',
      'about.president.commitment.sustainable': 'शाश्वत आणि जबाबदार औद्योगिक विकासाला प्रोत्साहन देणे',
      'about.president.commitment.safeWorkplaces': 'सुरक्षित आणि अनुपालन कार्यस्थळे तयार करणे',
      'about.president.commitment.resourceManagement': 'पर्यावरणास अनुकूल आणि कार्यक्षम संसाधन व्यवस्थापनास समर्थन देणे',
      'about.president.commitment.collectiveVoice': 'उद्योगांच्या सामूहिक आवाजाला मजबूत करणे',
      'about.president.commitment.innovationEcosystem': 'नवकल्पना आणि विकासाला प्रोत्साहन देणारे पारिस्थितिकी तंत्र निर्माण करणे',
      'about.president.partnerships.title': 'सरकारी भागीदारी आणि सहकार्य',
      // About - Structure
      'about.structure.title': 'संघटनेची रचना',
      'about.structure.subtitle': 'उद्योगांना अधिक चांगली सेवा देण्यासाठी आमची मांडणी',
      'about.structure.executive.title': 'कार्यकारी समिती',
      'about.structure.executive.desc': 'धोरणात्मक नेतृत्व आणि प्रशासन',
      'about.structure.executive.members.chairman': 'अध्यक्ष',
      'about.structure.executive.members.viceChairman': 'उपाध्यक्ष',
      'about.structure.executive.members.secretary': 'सचिव',
      'about.structure.executive.members.treasurer': 'खजिनदार',
      'about.structure.technical.title': 'तांत्रिक समिती',
      'about.structure.technical.desc': 'विषय तज्ज्ञता आणि सल्ला',
      'about.structure.technical.members.safety': 'औद्योगिक सुरक्षा',
      'about.structure.technical.members.environmental': 'पर्यावरणीय अनुपालन',
      'about.structure.technical.members.infrastructure': 'पायाभूत सुविधा',
      'about.structure.technical.members.compliance': 'नियामक अनुपालन',
      'about.structure.regional.title': 'प्रादेशिक समित्या',
      'about.structure.regional.desc': 'महाराष्ट्रभर स्थानिक प्रतिनिधित्व',
      'about.structure.support.title': 'सपोर्ट स्टाफ',
      'about.structure.support.desc': 'कार्यक्षमता आणि सेवा वितरण',
      'about.structure.support.members.admin': 'प्रशासन',
      'about.structure.support.members.technical': 'तांत्रिक सहाय्य',
      'about.structure.support.members.field': 'मैदानी कार्य',
      'about.structure.support.members.it': 'आयटी सहाय्य',
      // About - Achievements
      'about.achievements.title': 'आमची यशे',
      'about.achievements.subtitle': 'महाराष्ट्राच्या औद्योगिक परिदृश्यात विश्वास आणि उत्कृष्टता निर्माण करणे',
      'about.quickLinks.title': 'आमच्याबद्दल अधिक जाणून घ्या',
      'about.quickLinks.subtitle': 'आमचे नेतृत्व, मिशन, संरचना आणि यशे शोधा',
      'about.quickLinks.learnMore': 'अधिक जाणून घ्या',
      'about.values.viewAll': 'सर्व मूल मूल्ये पहा',
      'about.achievements.members.label': 'सक्रिय सदस्य',
      'about.achievements.members.desc': 'मजबूत आणि वाढता सदस्य आधार',
      'about.achievements.events.label': 'आयोजित कार्यक्रम',
      'about.achievements.events.desc': 'कार्यशाळा, सेमिनार आणि प्रशिक्षण',
      'about.achievements.satisfaction.label': 'सदस्य समाधान',
      'about.achievements.satisfaction.desc': 'सातत्याने उच्च समाधान रेटिंग',
      'about.achievements.years.label': 'सेवेची वर्षे',
      'about.achievements.years.desc': 'उद्योगांना सहाय्य करण्याचा अनुभव',
      // About - Team
      'about.team.title': 'संचालक मंडल',
      'about.team.subtitle': 'अनुभवी व्यावसायिक IFM चे नेतृत्व करतात',
      'about.team.director.name': 'संचालक',
      'about.team.director.position': 'संचालक',
      'about.team.director.department': 'कार्यकारी नेतृत्व',
      'about.team.director.experience': '20+ वर्षांचा उद्योग अनुभव',
      'about.team.director.expertise': 'धोरण, रणनीती, हितधारक संबंध',
      'about.team.deputy.name': 'उप संचालक',
      'about.team.deputy.position': 'उप संचालक',
      'about.team.deputy.department': 'ऑपरेशन्स',
      'about.team.deputy.experience': '15+ वर्षांचे ऑपरेशन्स व्यवस्थापन',
      'about.team.deputy.expertise': 'अनुपालन, प्रशिक्षण, सदस्य सेवा',
      // About - Contact
      'about.contact.title': 'संपर्क माहिती',
      'about.contact.subtitle': 'त्वरित मदतीसाठी योग्य विभागाशी संपर्क साधा',
      'about.contact.office.title': 'मुख्य कार्यालय',
      'about.contact.office.address': 'IFM कार्यालय, ३रा मजला, बिझनेस प्लाझा, बांद्रा ईस्ट, मुंबई - 400051',
      'about.contact.phone.title': 'फोन सहाय्य',
      'about.contact.phone.number': '+91-22-1234-5678',
      'about.contact.phone.hours': 'सोम-शुक्र: सकाळी 9:00 - संध्याकाळी 6:00 | शनि-रवि: सकाळी 9:00 - दुपारी 1:00',
      'about.contact.email.title': 'ईमेल सहाय्य',
      'about.contact.email.address': 'info@ifm.gov.in',
      'about.contact.email.response': 'साधारणपणे 24-48 तासांत उत्तर',
      'services.title': 'आमच्या सहाय्य सेवा',
      'services.subtitle': 'तुमच्या औद्योगिक गरजांसाठी व्यापक उपाय',
      'services.loading': 'सेवा लोड होत आहेत...',
      'services.noServices': 'कोणतीही सेवा उपलब्ध नाहीत',
      // Services - CTA
      'services.cta.title': 'सेवा निवडण्यासाठी मार्गदर्शन हवे आहे का?',
      'services.cta.subtitle': 'तुमच्या गरजेनुसार योग्य सहाय्य आमची टीम सुचवेल.',
      'services.cta.contactTeam': 'IFM टीमशी संपर्क साधा',
      'services.cta.submitQuery': 'प्रश्न सबमिट करा',
      // CTA Sections
      'cta.gallery.title': 'IFM बद्दल अधिक शोधा',
      'cta.gallery.subtitle': 'आमच्या नवीनतम कार्यक्रम, बातम्या पहा आणि IFM क्रियाकलापांशी अपडेट राहण्यासाठी आमच्याशी जोडा.',
      'cta.gallery.viewNews': 'नवीनतम बातम्या पहा',
      'cta.gallery.contact': 'संपर्क साधा',
      'cta.news.title': 'IFM सोबत अपडेट रहा',
      'cta.news.subtitle': 'कोणतीही अपडेट चुकवू नका. IFM कडून नवीनतम माहितीसाठी आमच्या कार्यक्रम, गॅलरी आणि सेवांचा शोध घ्या.',
      'cta.news.viewEvents': 'येणारी कार्यक्रम पहा',
      'cta.news.visitGallery': 'गॅलरी भेट द्या',
      'cta.mission.title': 'सेवा निवडण्यात मार्गदर्शन हवे?',
      'cta.mission.subtitle': 'आमची समर्पित सहाय्य टीम तुमची मदत करण्यासाठी तयार आहे. त्वरित सहाय्यासाठी खालील कोणत्याही चॅनेलद्वारे आमच्याशी संपर्क साधा.',
      'cta.mission.contact': 'संपर्क साधा',
      'cta.mission.join': 'IFM मध्ये सामील व्हा',
      'cta.service.title': 'सुरु करण्यासाठी तयार आहात?',
      'cta.service.subtitle': 'तुमच्या पर्यावरणीय अनुपालन गरजांसाठी वैयक्तिक मार्गदर्शनासाठी आमच्या तज्ञांशी संपर्क साधा.',
      'cta.service.contact': 'संपर्क साधा',
      'cta.service.viewAll': 'सर्व सेवा पहा',
      'cta.president.title': 'सेवा निवडण्यात मार्गदर्शन हवे?',
      'cta.president.subtitle': 'आमची समर्पित सहाय्य टीम तुमची मदत करण्यासाठी तयार आहे. त्वरित सहाय्यासाठी खालील कोणत्याही चॅनेलद्वारे आमच्याशी संपर्क साधा.',
      'cta.president.contact': 'संपर्क साधा',
      'cta.president.join': 'IFM मध्ये सामील व्हा',
      'cta.about.title': 'Industrial Federationात सामील होण्यासाठी तयार आहात?',
      'cta.about.subtitle': 'महाराष्ट्राच्या अग्रगण्य औद्योगिक समुदायाचा भाग बना आणि विशेष फायदे, तज्ञ सहाय्य आणि नेटवर्किंग संधी अनलॉक करा.',
      'cta.about.join': 'IFM मध्ये सामील व्हा',
      'cta.about.learnMore': 'अधिक जाणून घ्या',
      'cta.events.title': 'कार्यक्रम आयोजित करू इच्छित आहात?',
      'cta.events.subtitle': 'औद्योगिक समुदायासाठी कार्यशाळा, सेमिनार किंवा प्रशिक्षण कार्यक्रम आयोजित करण्यासाठी IFM सोबत भागीदारी करा.',
      'cta.events.contact': 'संपर्क साधा',
      // Services - List items
      'service.mpcb.name': 'MPCB (प्रदूषण नियंत्रण मंडळ)',
      'service.mpcb.shortDesc': 'कन्सेंट, नूतनीकरण, कचरा प्राधिकरण, अनुपालन सहाय्य',
      'service.dish.name': 'DISH (औद्योगिक सुरक्षा आणि आरोग्य)',
      'service.dish.shortDesc': 'फॅक्टरी परवाना, सुरक्षा ऑडिट, अनुपालन कागदपत्रे',
      'service.dic.name': 'DIC (जिल्हा उद्योग केंद्र)',
      'service.dic.shortDesc': 'नोंदणी, MSME सुविधा, प्रोत्साहन मार्गदर्शन',
      'service.cgwa.name': 'CGWA (भूजल प्राधिकरण)',
      'service.cgwa.shortDesc': 'बोरवेल परवानग्या, नूतनीकरण, अनुपालन',
      'service.midc.name': 'MIDC (औद्योगिक विकास महामंडळ)',
      'service.midc.shortDesc': 'प्लॉट वाटप, सुविधा, मंजुरी समन्वय',
      'service.mseb.name': 'MSEB / MSEDCL (वीज)',
      'service.mseb.shortDesc': 'नवीन कनेक्शन, लोड वाढ, बिलिंग समस्या',
      'service.chwtsdf.fullName': 'सामान्य धोकादायक कचरा उपचार, साठवण आणि निपटान सुविधा (CHWTSDF) - घन कचरा व्यवस्थापनातील एकाधिकार',
      'service.dish.fullName': 'औद्योगिक सुरक्षा आणि आरोग्य निदेशालय (DISH)',
      'service.infrastructure.fullName': 'औद्योगिक पायाभूत सुविधा - MIDC, MSEB / MSEDCL',
      'service.cgwa.fullName': 'केंद्रीय भूजल प्राधिकरण (CGWA)',
      'service.anti-industry.fullName': 'उद्योगविरोधी धोरणे पुनर्विचार',
      'service.mpcb.fullName': 'महाराष्ट्र प्रदूषण नियंत्रण मंडळ (MPCB) - पर्यावरण आणि प्रदूषण नियंत्रण',
      'service.labor.fullName': 'कामगार विभाग व DISH',
      'service.tax.fullName': 'कर व वित्त विभाग',
      'service.water.fullName': 'पाणीपुरवठा व पर्यावरण विभाग',
      'service.municipal.fullName': 'महानगरपालिका व स्थानिक स्वराज्य संस्था',
      'service.education.fullName': 'शिक्षण व कौशल्य विकास',
      'service.legal.fullName': 'कायदेशीर सहाय्य व तक्रारी',
      'service.policies.fullName': 'नवीन औद्योगिक धोरणे व प्रोत्साहने',
      'services.viewDetails': 'तपशील पहा',
      'service.labor.name': 'कामगार आणि अनुपालन',
      'service.labor.shortDesc': 'दुकान व आस्थापना, CLRA, रजिस्टर व रिटर्न',
      'service.fairprice.name': 'फेअर प्राइस शॉप',
      'service.fairprice.shortDesc': 'उद्योग कँटीन आणि आवश्यक पुरवठा सहाय्य',
      'service.hazardous.name': 'धोकादायक कचरा व्यवस्थापन',
      'service.hazardous.shortDesc': 'प्राधिकरण, मेनिफेस्ट, वाहतूक आणि डिस्पोजल सहाय्य',
      'contact.title': 'संपर्क साधा',
      'contact.subtitle': 'तुमच्या व्यवसायाच्या वाढीसाठी आम्ही येथे आहोत',
      'contact.info.title': 'संपर्क साधा',
      'contact.info.subtitle': 'या कोणत्याही चॅनेलद्वारे आमच्याशी संपर्क साधा',
      'contact.info.address': 'पत्ता',
      'contact.info.address.value': 'ऑफिस नं. 9, A-विंग, ज्वेल ऑफ पिंपरी, कमला क्रॉस रोड, पिंपरी, पुणे-411018',
      'contact.info.phone': 'फोन',
      'contact.info.phone.value1': '9067205252',
      'contact.info.phone.value2': '',
      'contact.info.email': 'ईमेल',
      'contact.info.email.value1': 'support@mahaifm.com',
      'contact.info.email.value2': 'Info@mahaifm.com',
      'contact.info.hours': 'कार्य वेळ',
      'contact.info.hours.monFri': 'सोम-शुक्र: सकाळी 9:00 - संध्याकाळी 6:00',
      'contact.info.hours.sat': 'शनि: सकाळी 9:00 - दुपारी 1:00',
      'contact.info.hours.sun': 'रवि: सकाळी 9:00 - दुपारी 1:00',
      // Footer
      'footer.quickLinks': 'त्वरित दुवे',
      'footer.resources': 'संसाधने',
      'footer.support': 'सहाय्य',
      'footer.services': 'सेवा',
      'footer.events': 'कार्यक्रम',
      'footer.news': 'बातम्या',
      'footer.membership': 'सदस्यता',
      'footer.contactUs': 'संपर्क साधा',
      'footer.grievance': 'तक्रार',
      'footer.memberRegistration': 'सदस्य नोंदणी',
      'footer.renewMembership': 'सदस्यता नूतनीकरण',
      'footer.missionVision': 'मिशन आणि व्हिजन',
      'footer.workingHours': 'सोम-शुक्र: सकाळी 9:00 - संध्याकाळी 6:00 | शनि-रवि: सकाळी 9:00 - दुपारी 1:00',
      'footer.designedBy': 'डिझाइन आणि विकसित',
      'footer.organizationName': 'Industrial Fedration of Maharashtra Region',
      'footer.legalPolicies': 'कायदेशीर आणि धोरणे',
      'footer.privacyPolicy': 'गोपनीयता धोरण',
      'footer.termsConditions': 'अटी आणि नियम',
      'footer.refundPolicy': 'परतावा धोरण',
      // Navigation - Important Links (Marathi)
      'nav.importantLinks.rofPortal': 'ROF | पोर्टल',
      'nav.importantLinks.incomeTax': 'आयकर विभाग',
      'nav.importantLinks.mahagst': 'MAHAGST',
      'nav.importantLinks.aapleSarkar': 'आपले सरकार',
      'nav.importantLinks.esic': 'ESIC',
      'nav.importantLinks.epfo': 'EPFO',
      // Navigation - Social Media (Marathi)
      'nav.socialMedia.linkedin': 'LinkedIn',
      'nav.socialMedia.instagram': 'Instagram',
      'nav.socialMedia.facebook': 'Facebook',
      'nav.socialMedia.youtube': 'YouTube',
      // About - President
      'about.president.title': 'अध्यक्ष प्रोफाइल',
      'about.president.subtitle': 'महाराष्ट्रभर औद्योगिक उत्कृष्टता चालविणारे नेतृत्व',
      'about.president.name': 'श्री कैलास नरके',
      'about.president.position': 'अध्यक्ष',
      'about.president.organization': 'Industrial Fedration of Maharashtra Region',
      'about.president.message.title': 'अध्यक्षाचे संदेश',
      'about.president.message.text1': 'Industrial Fedration of Maharashtra Region (IFM) मध्ये आपले स्वागत करताना मला अत्यधिक आनंद होत आहे. औद्योगिक विकासाच्या गतिशील परिस्थितीतून जाताना, IFM महाराष्ट्रभर शाश्वत वाढ आणि नवकल्पना प्रोत्साहित करण्यासाठी वचनबद्ध आहे.',
      'about.president.message.text2': 'आमची संस्था औद्योगिक उत्कृष्टता, सुरक्षा मानके आणि पर्यावरणीय जबाबदारी प्रोत्साहित करण्यात अग्रणी राहिली आहे. आमचा विश्वास आहे की खरी प्रगती आर्थिक वाढीला सामाजिक जबाबदारी आणि पर्यावरणीय स्टीवर्डशिपसह संतुलित करण्यातून येते.',
      'about.president.message.text3': 'आमच्या व्यापक कार्यक्रमांद्वारे, आम्ही तांत्रिक सहाय्य, धोरण वकिली आणि प्रशिक्षण संधी प्रदान करतो ज्या उद्योगांना समृद्ध होण्यास सक्षम बनवतात तर आमच्या समुदायांमध्ये सकारात्मक योगदान देतात. आमचा सहकार्यात्मक  व्हिजनकोण सरकारी संस्था, उद्योग नेते आणि स्थानिक भागधारकांना एकत्र आणतो.',
      'about.president.message.text4': 'जसा आपण भविष्याकडे पाहतो, IFM नवीन तंत्रज्ञान, शाश्वत पद्धती आणि नवकल्पनात्मक उपाय अपनावण्यासाठी वचनबद्ध आहे जे महाराष्ट्राच्या औद्योगिक क्षेत्राला नवीन उंचावर नेईल. एकत्रितपणे, आपण अधिक समृद्ध आणि शाश्वत उद्या बांधू शकतो.',
      'about.president.experience.title': 'अनुभव',
      'about.president.experience.item1': 'औद्योगिक नेतृत्वात 10+ वर्षे',
      'about.president.experience.item2': 'माजी निदेशक, महाराष्ट्र उद्योग',
      'about.president.experience.item3': 'धोरण वकिलीत तज्ज्ञ',
      'about.president.experience.item4': 'नियामक अनुपालन तज्ज्ञ',
      'about.president.leadership.title': 'नेतृत्व',
      'about.president.leadership.item1': 'रणनीतिक व्हिजन आणि नियोजन',
      'about.president.leadership.item2': 'भागधारक व्यवस्थापन',
      'about.president.leadership.item3': 'उद्योग विकास',
      'about.president.leadership.item4': 'संघ निर्माण आणि मार्गदर्शन',
      'about.president.focus.title': 'मुख्य फोकस क्षेत्र',
      'about.president.focus.sustainable.title': 'शाश्वत विकास',
      'about.president.focus.sustainable.desc': 'पर्यावरणास अनुकूल औद्योगिक पद्धती आणि हरित तंत्रज्ञान प्रोत्साहित करणे.',
      'about.president.focus.policy.title': 'धोरण वकिली',
      'about.president.focus.policy.desc': 'राज्य आणि राष्ट्रीय स्तरावर उद्योग हितांचे प्रतिनिधित्व करणे.',
      'about.president.focus.skill.title': 'कौशल्य विकास',
      'about.president.focus.skill.desc': 'प्रशिक्षण कार्यक्रमांद्वारे कार्यबल क्षमता वाढवणे.',
      'about.president.focus.innovation.title': 'नवकल्पना सहाय्य',
      'about.president.focus.innovation.desc': 'तांत्रिक प्रगती आणि संशोधन आणि विकास पहलांना प्रोत्साहन देणे.',
      'about.president.timeline.title': 'व्यावसायिक वेळरेषा',
      'about.president.timeline.2020.title': '2020 - सध्याचे',
      'about.president.timeline.2020.position': 'अध्यक्ष, Industrial Fedration of Maharashtra Region',
      'about.president.timeline.2020.desc': 'औद्योगिक विकासासाठी रणनीतिक पहल आणि धोरण वकिलीचे नेतृत्व',
      'about.president.timeline.2015.title': '2015 - 2020',
      'about.president.timeline.2015.position': 'निदेशक, महाराष्ट्र उद्योग',
      'about.president.timeline.2015.desc': 'औद्योगिक विकास धोरणे आणि नियामक चौकटींचे निरीक्षण',
      'about.president.timeline.2010.title': '2010 - 2015',
      'about.president.timeline.2010.position': 'वरिष्ठ सल्लागार, औद्योगिक धोरण',
      'about.president.timeline.2010.desc': 'औद्योगिक नियम आणि अनुपालनावर तज्ज्ञ मार्गदर्शन प्रदान केले',
      // About - Founder
      'about.founder.title': 'संस्थापक',
      'about.founder.subtitle': 'महाराष्ट्राच्या औद्योगिक उत्कृष्टतेची पायाभरणी घालणारे दूरव्हिजन नेते',
      'about.founder.name': 'डॉ. राजेश कुमार शर्मा',
      'about.founder.position': 'संस्थापक आणि चेअरमन एमेरिटस',
      'about.founder.organization': 'Industrial Fedration of Maharashtra Region',
      'about.founder.stats.years': 'सेवेची वर्षे',
      'about.founder.stats.industries': 'समर्थित उद्योग',
      'about.founder.stats.awards': 'प्राप्त पुरस्कार',
      'about.founder.vision.title': 'संस्थापकाची व्हिजन',
      'about.founder.vision.text1': 'मी एक महाराष्ट्राची कल्पना केली जिथे उद्योग फक्त जगणार नाहीत, तर सहकार्य, नवकल्पना आणि परस्पर सहाय्याद्वारे फुलतात. Industrial Fedration of Maharashtra Region या स्वप्नातून जन्माला आला - सरकारी धोरणे आणि औद्योगिक गरजांमधील अंतर पाटणारे एकीकृत मंच तयार करणे.',
      'about.founder.vision.text2': 'आमचे मिशन सोपे पण खोल होते: प्रत्येक औद्योगिक युनिटला, सर्वात लहान MSME पासून सर्वात मोठ्या कॉर्पोरेशनपर्यंत, त्यांना सतत विकसित होत असलेल्या आर्थिक परिस्थितीत यशस्वी होण्यासाठी आवश्यक असलेली साधने, ज्ञान आणि सहाय्य प्रदान करणे.',
      'about.founder.vision.text3': 'मी मानले की खरी औद्योगिक वाढ फक्त स्पर्धेतून येत नाही, तर सहकार्य, सामायिक शिक्षण आणि सामूहिक प्रगतीतून येते. हे तत्त्वज्ञान आजही IFM च्या कामाचे मार्गदर्शन करते.',
      'about.founder.journey.title': 'संस्थापन प्रवास',
      'about.founder.journey.1995.title': '1995 - व्हिजन',
      'about.founder.journey.1995.position': 'प्रारंभिक संकल्पना विकास',
      'about.founder.journey.1995.desc': 'औद्योगिक धोरणातील प्रारंभिक कारकिर्दीत महाराष्ट्रात एकीकृत औद्योगिक संस्थेची गरज ओळखली',
      'about.founder.journey.2000.title': '2000 - स्थापना',
      'about.founder.journey.2000.position': 'IFM स्थापना',
      'about.founder.journey.2000.desc': 'प्रारंभिक 50 सदस्य कंपन्यांसह अधिकृतपणे IFM स्थापन केले आणि मुंबईत पहिले कार्यालय स्थापन केले',
      'about.founder.journey.2005.title': '2005 - विस्तार',
      'about.founder.journey.2005.position': 'प्रादेशिक वाढ',
      'about.founder.journey.2005.desc': 'पुणे, नागपूर आणि औरंगाबादमध्ये कार्याचा विस्तार केला, प्रादेशिक समित्या स्थापन केल्या',
      'about.founder.journey.2010.title': '2010 - मान्यता',
      'about.founder.journey.2010.position': 'सरकारी मान्यता',
      'about.founder.journey.2010.desc': 'महाराष्ट्र सरकारकडून Industrial Fedration of Maharashtra Region म्हणून अधिकृत मान्यता मिळाली',
      'about.founder.achievements.title': 'मुख्य यश',
      'about.founder.achievements.item1': 'IFM ला महाराष्ट्राचे प्रमुख औद्योगिक संस्था म्हणून स्थापन केले',
      'about.founder.achievements.item2': 'सदस्यता 50 वरून 500+ कंपन्यांपर्यंत वाढवली',
      'about.founder.achievements.item3': 'व्यापक सहाय्य चौकट तयार केली',
      'about.founder.achievements.item4': 'सरकार-उद्योग भागीदारी स्थापन केली',
      'about.founder.legacy.title': 'वारसा',
      'about.founder.legacy.item1': 'शाश्वत औद्योगिक विकास मॉडेल',
      'about.founder.legacy.item2': 'सहकार्यात्मक शासन चौकट',
      'about.founder.legacy.item3': 'सदस्य-केंद्रित सेवा  व्हिजनकोण',
      'about.founder.legacy.item4': 'नवकल्पना-चालित विकास धोरण',
      'about.founder.philosophy.title': 'संस्थापन तत्त्वज्ञान',
      'about.founder.philosophy.unity.title': 'विविधतेत एकता',
      'about.founder.philosophy.unity.desc': 'परस्पर फायद्यासाठी सर्व आकार आणि क्षेत्रांचे उद्योग एका छताखाली आणणे.',
      'about.founder.philosophy.service.title': 'स्वतःपेक्षा सेवा',
      'about.founder.philosophy.service.desc': 'वैयक्तिक किंवा संस्थात्मक फायद्यांपेक्षा सदस्य गरजा आणि औद्योगिक विकासाला प्राधान्य देणे.',
      'about.founder.philosophy.innovation.title': 'नवकल्पना आणि उत्कृष्टता',
      'about.founder.philosophy.innovation.desc': 'बदलत्या औद्योगिक गरजा आणि तांत्रिक प्रगती पूर्ण करण्यासाठी सतत विकसित होणे.',
      'about.founder.philosophy.sustainable.title': 'शाश्वत वाढ',
      'about.founder.philosophy.sustainable.desc': 'पर्यावरणीय जबाबदारी आणि सामाजिक प्रभावासह आर्थिक विकास संतुलित करणे.',
      'about.founder.awards.title': 'पुरस्कार आणि मान्यता',
      'about.founder.awards.2015.title': 'औद्योगिक उत्कृष्टता पुरस्कार',
      'about.founder.awards.2015.org': 'महाराष्ट्र सरकार, 2015',
      'about.founder.awards.2018.title': 'आयुष्यभराचे यश पुरस्कार',
      'about.founder.awards.2018.org': 'फेडरेशन ऑफ इंडियन चेंबर्स, 2018',
      'about.founder.awards.2020.title': 'सामाजिक प्रभाव पुरस्कार',
      'about.founder.awards.2020.org': 'औद्योगिक विकास सोसायटी, 2020',
      'about.founder.awards.2022.title': 'दूरव्हिजन नेता पुरस्कार',
      'about.founder.awards.2022.org': 'Industrial Fedration of Maharashtra Region, 2022',
      'about.founder.continuing.title': 'वारसा चालू ठेवणे',
      'about.founder.continuing.growth.title': 'सदस्य वाढ',
      'about.founder.continuing.growth.desc': 'आमच्या संस्थापकाने कल्पिलेले वैयक्तिक स्पर्श आणि गुणवत्तापूर्ण सेवा राखताना आमच्या सदस्य आधाराचा विस्तार चालू ठेवणे.',
      'about.founder.continuing.innovation.title': 'नवकल्पना',
      'about.founder.continuing.innovation.desc': 'सहकार्य आणि सेवेच्या मूलभूत मूल्यांना प्रामाणिक राहताना नवीन तंत्रज्ञान आणि पद्धतींना स्वीकारणे.',
      'about.founder.continuing.impact.title': 'सामाजिक प्रभाव',
      'about.founder.continuing.impact.desc': 'संस्थापन तत्त्वांमध्ये कल्पिलेल्या शाश्वत विकास आणि समुदाय कल्याणावर लक्ष केंद्रित करणे.',
    }
  }
};

// Force refresh language data to ensure new translations are loaded
export const refreshLanguageData = () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Refreshing language data...');
  }
  localStorage.setItem(STORAGE_KEYS.LANGUAGES, JSON.stringify(languages));
  if (process.env.NODE_ENV === 'development') {
    console.log('Language data refreshed');
  }
};

// Initialize languages - force update to ensure new translations are loaded
localStorage.setItem(STORAGE_KEYS.LANGUAGES, JSON.stringify(languages));

// Initialize data if it doesn't exist
export const initializeData = () => {
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - Initializing data...');
    }

  // Force refresh language data to ensure new translations are loaded
  refreshLanguageData();

  // Initialize events
  if (!localStorage.getItem(STORAGE_KEYS.EVENTS)) {
    localStorage.setItem(STORAGE_KEYS.EVENTS, JSON.stringify(existingData.events));
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - Events initialized');
    }
  }

  // Initialize news
  if (!localStorage.getItem(STORAGE_KEYS.NEWS)) {
    localStorage.setItem(STORAGE_KEYS.NEWS, JSON.stringify(existingData.news));
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - News initialized');
    }
  }

  // Initialize membership plans
  if (!localStorage.getItem(STORAGE_KEYS.MEMBERSHIP_PLANS)) {
    localStorage.setItem(STORAGE_KEYS.MEMBERSHIP_PLANS, JSON.stringify(existingData.membershipPlans));
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - Membership plans initialized');
    }
  }

  // Initialize gallery
  if (!localStorage.getItem(STORAGE_KEYS.GALLERY)) {
    localStorage.setItem(STORAGE_KEYS.GALLERY, JSON.stringify(existingData.gallery));
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - Gallery initialized');
    }
  }

  // Initialize grievances
  if (!localStorage.getItem(STORAGE_KEYS.GRIEVANCES)) {
    localStorage.setItem(STORAGE_KEYS.GRIEVANCES, JSON.stringify(existingData.grievances));
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - Grievances initialized');
    }
  }

  // Initialize members
  if (!localStorage.getItem(STORAGE_KEYS.MEMBERS)) {
    localStorage.setItem(STORAGE_KEYS.MEMBERS, JSON.stringify(existingData.members));
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - Members initialized');
    }
  }

  // Initialize languages
  if (!localStorage.getItem(STORAGE_KEYS.LANGUAGES)) {
    localStorage.setItem(STORAGE_KEYS.LANGUAGES, JSON.stringify(languages));
    if (process.env.NODE_ENV === 'development') {
      console.log('dataSync - Languages initialized');
    }
  }
};

// Initialize data when module is imported
initializeData();

// Language functions
const deepMerge = (base, override) => {
  if (typeof base !== 'object' || base === null) return override ?? base;
  const out = Array.isArray(base) ? [...base] : { ...base };
  Object.keys(override || {}).forEach((k) => {
    const bv = base[k];
    const ov = override[k];
    if (typeof bv === 'object' && bv && typeof ov === 'object' && ov) {
      out[k] = deepMerge(bv, ov);
    } else {
      out[k] = ov;
    }
  });
  return out;
};

export const getLanguages = () => {
  const stored = localStorage.getItem(STORAGE_KEYS.LANGUAGES);
  if (!stored) return languages;
  try {
    const parsed = JSON.parse(stored);
    // Merge stored with current defaults so new keys (like recentNewsTitle) are available
    const merged = {};
    const allCodes = new Set([...Object.keys(languages), ...Object.keys(parsed || {})]);
    allCodes.forEach((code) => {
      const base = languages[code] || {};
      const over = parsed[code] || {};
      merged[code] = deepMerge(base, over);
      // Ensure content object exists
      if (!merged[code].content) merged[code].content = (base.content || {});
    });
    return merged;
  } catch {
    return languages;
  }
};

export const getCurrentLanguage = () => {
  const lang = localStorage.getItem('ifm_current_language') || 'en';
  return lang;
};

export const setCurrentLanguage = (langCode) => {
  localStorage.setItem('ifm_current_language', langCode);
  // Dispatch custom event for language change
  window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: langCode } }));
};

// Text retrieval function
export const getText = (key) => {
  try {
    const currentLang = getCurrentLanguage();
    const languages = getLanguages();
    const lang = languages[currentLang];

    if (process.env.NODE_ENV === 'development') {
      console.log('getText: Looking for key:', key, 'in language:', currentLang);
    }

    if (lang && lang.content && lang.content[key]) {
      if (process.env.NODE_ENV === 'development') {
        console.log('getText: Found translation for', key, ':', lang.content[key]);
      }
      return lang.content[key];
    }

    // Fallback to English
    const englishLang = languages.en;
    if (englishLang && englishLang.content && englishLang.content[key]) {
      if (process.env.NODE_ENV === 'development') {
        console.log('getText: Fallback to English for key:', key, 'value:', englishLang.content[key]);
      }
      return englishLang.content[key];
    }

    if (process.env.NODE_ENV === 'development') {
      console.log('getText: No text found for key:', key, 'falling back to key transformation');
    }
    return key.replace(/^[^.]+\./, '').replace(/\./g, ' ').replace(/([A-Z])/g, ' $1').trim();
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('getText: Error getting text for key:', key, 'error:', error);
    }
    return key;
  }
};

// Data functions
export const getEvents = () => {
  const events = localStorage.getItem(STORAGE_KEYS.EVENTS);
  return events ? JSON.parse(events) : [];
};

export const getNews = () => {
  const news = localStorage.getItem(STORAGE_KEYS.NEWS);
  return news ? JSON.parse(news) : [];
};

export const getMembershipPlans = () => {
  const plans = localStorage.getItem(STORAGE_KEYS.MEMBERSHIP_PLANS);
  return plans ? JSON.parse(plans) : [];
};

export const getGallery = () => {
  const gallery = localStorage.getItem(STORAGE_KEYS.GALLERY);
  return gallery ? JSON.parse(gallery) : { photos: [], videos: [] };
};

export const getGrievances = () => {
  const grievances = localStorage.getItem(STORAGE_KEYS.GRIEVANCES);
  return grievances ? JSON.parse(grievances) : [];
};

export const getMembers = () => {
  const members = localStorage.getItem(STORAGE_KEYS.MEMBERS);
  return members ? JSON.parse(members) : [];
};

// Event dispatching for data changes
const dispatchDataChangeEvent = (type, action) => {
  const event = new CustomEvent('dataChanged', {
    detail: { type, action }
  });
  window.dispatchEvent(event);
};

// CRUD operations for members
export const addMember = (memberData) => {
  const members = getMembers();
  const newMember = {
    ...memberData,
    id: Date.now(),
    registrationDate: new Date().toISOString(),
    approvalStatus: 'Pending',
    membershipStatus: 'Pending'
  };
  members.push(newMember);
  localStorage.setItem(STORAGE_KEYS.MEMBERS, JSON.stringify(members));

  // Dispatch event to notify components
  dispatchDataChangeEvent('members', 'added');

  return newMember;
};

export const updateMember = (id, updates) => {
  const members = getMembers();
  const index = members.findIndex(m => m.id === id);
  if (index !== -1) {
    members[index] = { ...members[index], ...updates };
    localStorage.setItem(STORAGE_KEYS.MEMBERS, JSON.stringify(members));

    // Dispatch event to notify components
    dispatchDataChangeEvent('members', 'updated');

    return members[index];
  }
  return null;
};

export const deleteMember = (id) => {
  const members = getMembers();
  const filtered = members.filter(m => m.id !== id);
  localStorage.setItem(STORAGE_KEYS.MEMBERS, JSON.stringify(filtered));

  // Dispatch event to notify components
  dispatchDataChangeEvent('members', 'deleted');

  return true;
};

// CRUD operations for events
export const addEvent = (eventData) => {
  const events = getEvents();
  const newEvent = { ...eventData, id: Date.now() };
  events.push(newEvent);
  localStorage.setItem(STORAGE_KEYS.EVENTS, JSON.stringify(events));

  // Dispatch event to notify components
  dispatchDataChangeEvent('events', 'added');

  return newEvent;
};

export const updateEvent = (id, updates) => {
  const events = getEvents();
  const index = events.findIndex(e => e.id === id);
  if (index !== -1) {
    events[index] = { ...events[index], ...updates };
    localStorage.setItem(STORAGE_KEYS.EVENTS, JSON.stringify(events));

    // Dispatch event to notify components
    dispatchDataChangeEvent('events', 'updated');

    return events[index];
  }
  return null;
};

export const deleteEvent = (id) => {
  const events = getEvents();
  const filtered = events.filter(e => e.id !== id);
  localStorage.setItem(STORAGE_KEYS.EVENTS, JSON.stringify(filtered));

  // Dispatch event to notify components
  dispatchDataChangeEvent('events', 'deleted');

  return true;
};

// CRUD operations for news
export const addNews = (newsData) => {
  const newsItems = getNews();
  const newNews = { ...newsData, id: Date.now() };
  newsItems.push(newNews);
  localStorage.setItem(STORAGE_KEYS.NEWS, JSON.stringify(newsItems));

  // Dispatch event to notify components
  dispatchDataChangeEvent('news', 'added');

  return newNews;
};

export const updateNews = (id, updates) => {
  const newsItems = getNews();
  const index = newsItems.findIndex(n => n.id === id);
  if (index !== -1) {
    newsItems[index] = { ...newsItems[index], ...updates };
    localStorage.setItem(STORAGE_KEYS.NEWS, JSON.stringify(newsItems));

    // Dispatch event to notify components
    dispatchDataChangeEvent('news', 'updated');

    return newsItems[index];
  }
  return null;
};

export const deleteNews = (id) => {
  const newsItems = getNews();
  const filtered = newsItems.filter(n => n.id !== id);
  localStorage.setItem(STORAGE_KEYS.NEWS, JSON.stringify(filtered));

  // Dispatch event to notify components
  dispatchDataChangeEvent('news', 'deleted');

  return true;
};

// CRUD operations for gallery
export const addPhoto = (photoData) => {
  const gallery = getGallery();
  const newPhoto = { ...photoData, id: Date.now() };
  gallery.photos.push(newPhoto);
  localStorage.setItem(STORAGE_KEYS.GALLERY, JSON.stringify(gallery));

  // Dispatch event to notify components
  dispatchDataChangeEvent('gallery', 'photo_added');

  return newPhoto;
};

export const addVideo = (videoData) => {
  const gallery = getGallery();
  const newVideo = { ...videoData, id: Date.now() };
  gallery.videos.push(newVideo);
  localStorage.setItem(STORAGE_KEYS.GALLERY, JSON.stringify(gallery));

  // Dispatch event to notify components
  dispatchDataChangeEvent('gallery', 'video_added');

  return newVideo;
};

export const deletePhoto = (id) => {
  const gallery = getGallery();
  gallery.photos = gallery.photos.filter(p => p.id !== id);
  localStorage.setItem(STORAGE_KEYS.GALLERY, JSON.stringify(gallery));

  // Dispatch event to notify components
  dispatchDataChangeEvent('gallery', 'photo_deleted');

  return true;
};

export const deleteVideo = (id) => {
  const gallery = getGallery();
  gallery.videos = gallery.videos.filter(v => v.id !== id);
  localStorage.setItem(STORAGE_KEYS.GALLERY, JSON.stringify(gallery));

  // Dispatch event to notify components
  dispatchDataChangeEvent('gallery', 'video_deleted');

  return true;
};

// CRUD operations for grievances
export const addGrievance = (grievanceData) => {
  const grievances = getGrievances();
  const newGrievance = { ...grievanceData, id: Date.now(), status: 'Pending' };
  grievances.push(newGrievance);
  localStorage.setItem(STORAGE_KEYS.GRIEVANCES, JSON.stringify(grievances));

  // Dispatch event to notify components
  dispatchDataChangeEvent('grievances', 'added');

  return newGrievance;
};

export const updateGrievanceStatus = (id, status) => {
  const grievances = getGrievances();
  const index = grievances.findIndex(g => g.id === id);
  if (index !== -1) {
    grievances[index].status = status;
    localStorage.setItem(STORAGE_KEYS.GRIEVANCES, JSON.stringify(grievances));

    // Dispatch event to notify components
    dispatchDataChangeEvent('grievances', 'status_updated');

    return grievances[index];
  }
  return null;
};

export const deleteGrievance = (id) => {
  const grievances = getGrievances();
  const filtered = grievances.filter(g => g.id !== id);
  localStorage.setItem(STORAGE_KEYS.GRIEVANCES, JSON.stringify(filtered));

  // Dispatch event to notify components
  dispatchDataChangeEvent('grievances', 'deleted');

  return true;
};

// Language management
export const addLanguage = (code, name, content) => {
  const languages = getLanguages();
  languages[code] = { name, isDefault: false, content };
  localStorage.setItem(STORAGE_KEYS.LANGUAGES, JSON.stringify(languages));
  return languages[code];
};

export const removeLanguage = (code) => {
  const languages = getLanguages();
  if (languages[code] && !languages[code].isDefault) {
    delete languages[code];
    localStorage.setItem(STORAGE_KEYS.LANGUAGES, JSON.stringify(languages));
    return true;
  }
  return false;
};
